(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredb49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredb49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eMV3U", function(module, exports) {

$parcel$export(module.exports, "focus", function () { return src_default; });
$parcel$export(module.exports, "default", function () { return module_default; });
// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = [
    "input:not([inert]):not([inert] *)",
    "select:not([inert]):not([inert] *)",
    "textarea:not([inert]):not([inert] *)",
    "a[href]:not([inert]):not([inert] *)",
    "button:not([inert]):not([inert] *)",
    "[tabindex]:not(slot):not([inert]):not([inert] *)",
    "audio[controls]:not([inert]):not([inert] *)",
    "video[controls]:not([inert]):not([inert] *)",
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    "details>summary:first-of-type:not([inert]):not([inert] *)",
    "details:not([inert]):not([inert] *)"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var _isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === "function" ? node.closest("[inert]") : _isInert(node.parentNode));
    return result;
};
var isContentEditable = function isContentEditable2(node) {
    var _node$getAttribute2;
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    if (_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var _getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (_isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = _getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = _getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var hasTabIndex = function hasTabIndex2(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) return 0;
    return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
    var _nodeRoot;
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            nodeRoot = getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === "full-native") {
        if ("checkVisibility" in node) {
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === "full-native" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (isNodeAttached(node)) return !node.getClientRects().length;
        if (displayCheck !== "legacy-full") return true;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isShadowRootTabbable = function isShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var _sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = getSortOrderTabIndex(element, isScope);
        var elements = isScope ? _sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = _getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isShadowRootTabbable
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return _sortByOrder(candidates);
};
var focusable = function focusable2(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = _getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe:not([inert]):not([inert] *)").join(",");
var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
// node_modules/focus-trap/dist/focus-trap.esm.js
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n2) {
        return void e(n2);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n2) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n2);
            }
            function _throw(n2) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n2);
            }
            _next(void 0);
        });
    };
}
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: true
                    } : {
                        done: false,
                        value: r[n++]
                    };
                },
                e: function(r2) {
                    throw r2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = true, u = false;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r2 = t.next();
            return a = r2.done, r2;
        },
        e: function(r2) {
            u = true, o = r2;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
            return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
            _defineProperty(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
            Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
    }
    return e;
}
function _regenerator() {
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r2, n2, o2, i2) {
        var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
        return _regeneratorDefine(u2, "_invoke", function(r3, n3, o3) {
            var i3, c3, u3, f2 = 0, p = o3 || [], y = false, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function(t2, r4) {
                    return i3 = t2, c3 = 0, u3 = e, G.n = r4, a;
                }
            };
            function d(r4, n4) {
                for(c3 = r4, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++){
                    var o4, i4 = p[t], d2 = G.p, l = i4[2];
                    r4 > 3 ? (o4 = l === n4) && (u3 = i4[(c3 = i4[4]) ? 5 : (c3 = 3, 3)], i4[4] = i4[5] = e) : i4[0] <= d2 && ((o4 = r4 < 2 && d2 < i4[1]) ? (c3 = 0, G.v = n4, G.n = i4[1]) : d2 < l && (o4 = r4 < 3 || i4[0] > n4 || n4 > l) && (i4[4] = r4, i4[5] = n4, G.n = l, c3 = 0));
                }
                if (o4 || r4 > 1) return a;
                throw y = true, n4;
            }
            return function(o4, p2, l) {
                if (f2 > 1) throw TypeError("Generator is already running");
                for(y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y;){
                    i3 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
                    try {
                        if (f2 = 2, i3) {
                            if (c3 || (o4 = "next"), t = i3[o4]) {
                                if (!(t = t.call(i3, u3))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u3 = t.value, c3 < 2 && (c3 = 0);
                            } else 1 === c3 && (t = i3.return) && t.call(i3), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
                            i3 = e;
                        } else if ((t = (y = G.n < 0) ? u3 : r3.call(n3, G)) !== a) break;
                    } catch (t2) {
                        i3 = e, c3 = 1, u3 = t2;
                    } finally{
                        f2 = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r2, o2, i2), true), u2;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e2) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function() {
        return this;
    }), _regeneratorDefine(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e2) {
        i = 0;
    }
    _regeneratorDefine = function(e2, r2, n2, t2) {
        function o(r3, n3) {
            _regeneratorDefine(e2, r3, function(e3) {
                return this._invoke(r3, n3, e3);
            });
        }
        r2 ? i ? i(e2, r2, {
            value: n2,
            enumerable: !t2,
            configurable: !t2,
            writable: !t2
        }) : e2[r2] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine(e, r, n, t);
}
function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var activeFocusTraps = {
    // Returns the trap from the top of the stack.
    getActiveTrap: function getActiveTrap(trapStack) {
        if ((trapStack === null || trapStack === void 0 ? void 0 : trapStack.length) > 0) return trapStack[trapStack.length - 1];
        return null;
    },
    // Pauses the currently active trap, then adds a new trap to the stack.
    activateTrap: function activateTrap(trapStack, trap) {
        var activeTrap = activeFocusTraps.getActiveTrap(trapStack);
        if (trap !== activeTrap) activeFocusTraps.pauseTrap(trapStack);
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    // Removes the trap from the top of the stack, then unpauses the next trap down.
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        activeFocusTraps.unpauseTrap(trapStack);
    },
    // Pauses the trap at the top of the stack.
    pauseTrap: function pauseTrap(trapStack) {
        var activeTrap = activeFocusTraps.getActiveTrap(trapStack);
        activeTrap === null || activeTrap === void 0 || activeTrap._setPausedState(true);
    },
    // Unpauses the trap at the top of the stack.
    unpauseTrap: function unpauseTrap(trapStack) {
        var activeTrap = activeFocusTraps.getActiveTrap(trapStack);
        if (activeTrap && !activeTrap._isManuallyPaused()) activeTrap._setPausedState(false);
    }
};
var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent2(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
var isKeyForward = function isKeyForward2(e) {
    return isTabEvent(e) && !e.shiftKey;
};
var isKeyBackward = function isKeyBackward2(e) {
    return isTabEvent(e) && e.shiftKey;
};
var delay = function delay2(fn) {
    return setTimeout(fn, 0);
};
var valueOrHandler = function valueOrHandler2(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isolateSubtrees: false,
        isKeyForward: isKeyForward,
        isKeyBackward: isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        /** @type {Array<HTMLElement>} */ containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */ containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        // references to nodes that are siblings to the ancestors of this trap's containers.
        /** @type {Set<HTMLElement>} */ adjacentElements: /* @__PURE__ */ new Set(),
        // references to nodes that were inert or aria-hidden before the trap was activated.
        /** @type {Set<HTMLElement>} */ alreadySilent: /* @__PURE__ */ new Set(),
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : void 0;
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
        var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref2$hasFallback = _ref2.hasFallback, hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? [] : _ref2$params;
        var optionValue = config[optionName];
        if (typeof optionValue === "function") optionValue = optionValue.apply(void 0, _toConsumableArray(params));
        if (optionValue === true) optionValue = void 0;
        if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) return optionValue;
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue;
        if (typeof optionValue === "string") {
            try {
                node = doc.querySelector(optionValue);
            } catch (err) {
                throw new Error("`".concat(optionName, '` appears to be an invalid selector; error="').concat(err.message, '"'));
            }
            if (!node) {
                if (!hasFallback) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
        var node = getNodeForOption("initialFocus", {
            hasFallback: true
        });
        if (node === false) return false;
        if (node === void 0 || node && !isFocusable(node, config.tabbableOptions)) {
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        } else if (node === null) node = getNodeForOption("fallbackFocus");
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            var focusableNodes = focusable(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : void 0;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : void 0;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return isTabbable(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return isTabbable(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return getTabIndex(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                posTabIndexesFound: /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound,
                firstTabbableNode: /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode,
                lastTabbableNode: /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode,
                firstDomTabbableNode: // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode,
                lastDomTabbableNode: /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return isTabbable(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return isTabbable(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    var _getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return _getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var _tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === _getActiveElement(document)) return;
        if (!node || !node.focus) {
            _tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", {
            params: [
                previousActiveElement
            ]
        });
        return node ? node : node === false ? false : previousActiveElement;
    };
    var findNextNavNode = function findNextNavNode2(_ref3) {
        var target = _ref3.target, event = _ref3.event, _ref3$isBackward = _ref3.isBackward, isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
        target = target || getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
            if (containerIndex < 0) {
                if (isBackward) destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                var startOfGroupIndex = state.tabbableGroups.findIndex(function(_ref4) {
                    var firstTabbableNode = _ref4.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!isTabEvent(event)) destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                var lastOfGroupIndex = state.tabbableGroups.findIndex(function(_ref5) {
                    var lastTabbableNode = _ref5.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!isTabEvent(event)) destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    var checkPointerDown = function checkPointerDown2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(event) {
        var target = getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            event.stopImmediatePropagation();
            var nextNode;
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if (getTabIndex(state.mostRecentlyFocusedNode) > 0) {
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        }
                    }
                } else if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return getTabIndex(n) > 0;
                    });
                })) navAcrossContainers = false;
            } else navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) _tryFocus(nextNode);
            else _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = void 0;
    };
    var checkKeyNav = function checkKeyNav2(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if (isTabEvent(event)) event.preventDefault();
            _tryFocus(destinationNode);
        }
    };
    var checkTabKey = function checkTabKey2(event) {
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkEscapeKey = function checkEscapeKey2(event) {
        if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
        }
    };
    var checkClick = function checkClick2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
        if (!state.active) return Promise.resolve();
        activeFocusTraps.activateTrap(trapStack, trap);
        var promise;
        if (config.delayInitialFocus) promise = new Promise(function(resolve) {
            state.delayInitialFocusTimer = delay(function() {
                _tryFocus(getInitialFocusNode());
                resolve();
            });
        });
        else {
            promise = Promise.resolve();
            _tryFocus(getInitialFocusNode());
        }
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkTabKey, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkEscapeKey);
        return promise;
    };
    var collectAdjacentElements = function collectAdjacentElements2(containers) {
        if (state.active && !state.paused) trap._setSubtreeIsolation(false);
        state.adjacentElements.clear();
        state.alreadySilent.clear();
        var containerAncestors = /* @__PURE__ */ new Set();
        var adjacentElements = /* @__PURE__ */ new Set();
        var _iterator = _createForOfIteratorHelper(containers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var container = _step.value;
                containerAncestors.add(container);
                var insideShadowRoot = typeof ShadowRoot !== "undefined" && container.getRootNode() instanceof ShadowRoot;
                var current = container;
                while(current){
                    containerAncestors.add(current);
                    var parent = current.parentElement;
                    var siblings = [];
                    if (parent) siblings = parent.children;
                    else if (!parent && insideShadowRoot) {
                        siblings = current.getRootNode().children;
                        parent = current.getRootNode().host;
                        insideShadowRoot = typeof ShadowRoot !== "undefined" && parent.getRootNode() instanceof ShadowRoot;
                    }
                    var _iterator2 = _createForOfIteratorHelper(siblings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var child = _step2.value;
                            adjacentElements.add(child);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    current = parent;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        containerAncestors.forEach(function(el) {
            adjacentElements["delete"](el);
        });
        state.adjacentElements = adjacentElements;
    };
    var removeListeners = function removeListeners2() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkTabKey, true);
        doc.removeEventListener("keydown", checkEscapeKey);
        return trap;
    };
    var checkDomRemoval = function checkDomRemoval2(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        if (isFocusedNodeRemoved) _tryFocus(getInitialFocusNode());
    };
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : void 0;
    var updateObservedNodes = function updateObservedNodes2() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            var preexistingTrap = activeFocusTraps.getActiveTrap(trapStack);
            var revertState = false;
            if (preexistingTrap && !preexistingTrap.paused) {
                var _preexistingTrap$_set;
                (_preexistingTrap$_set = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set === void 0 || _preexistingTrap$_set.call(preexistingTrap, false);
                revertState = true;
            }
            try {
                if (!checkCanFocusTrap) updateTabbableNodes();
                state.active = true;
                state.paused = false;
                state.nodeFocusedBeforeActivation = _getActiveElement(doc);
                onActivate === null || onActivate === void 0 || onActivate();
                var finishActivation = /* @__PURE__ */ function() {
                    var _ref6 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee() {
                        return _regenerator().w(function(_context) {
                            while(true)switch(_context.n){
                                case 0:
                                    if (checkCanFocusTrap) updateTabbableNodes();
                                    _context.n = 1;
                                    return addListeners();
                                case 1:
                                    trap._setSubtreeIsolation(true);
                                    updateObservedNodes();
                                    onPostActivate === null || onPostActivate === void 0 || onPostActivate();
                                case 2:
                                    return _context.a(2);
                            }
                        }, _callee);
                    }));
                    return function finishActivation2() {
                        return _ref6.apply(this, arguments);
                    };
                }();
                if (checkCanFocusTrap) {
                    checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                    return this;
                }
                finishActivation();
            } catch (error) {
                if (preexistingTrap === activeFocusTraps.getActiveTrap(trapStack) && revertState) {
                    var _preexistingTrap$_set2;
                    (_preexistingTrap$_set2 = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set2 === void 0 || _preexistingTrap$_set2.call(preexistingTrap, true);
                }
                throw error;
            }
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            if (!state.paused) trap._setSubtreeIsolation(false);
            state.alreadySilent.clear();
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation2() {
                delay(function() {
                    if (returnFocus) _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = true;
            return this._setPausedState(true, pauseOptions);
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = false;
            if (trapStack[trapStack.length - 1] !== this) return this;
            return this._setPausedState(false, unpauseOptions);
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (config.isolateSubtrees) collectAdjacentElements(state.containers);
            if (state.active) {
                updateTabbableNodes();
                if (!state.paused) trap._setSubtreeIsolation(true);
            }
            updateObservedNodes();
            return this;
        }
    };
    Object.defineProperties(trap, {
        _isManuallyPaused: {
            value: function value() {
                return state.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function value(paused, options) {
                if (state.paused === paused) return this;
                state.paused = paused;
                if (paused) {
                    var onPause = getOption(options, "onPause");
                    var onPostPause = getOption(options, "onPostPause");
                    onPause === null || onPause === void 0 || onPause();
                    removeListeners();
                    trap._setSubtreeIsolation(false);
                    updateObservedNodes();
                    onPostPause === null || onPostPause === void 0 || onPostPause();
                } else {
                    var onUnpause = getOption(options, "onUnpause");
                    var onPostUnpause = getOption(options, "onPostUnpause");
                    onUnpause === null || onUnpause === void 0 || onUnpause();
                    var finishUnpause = /* @__PURE__ */ function() {
                        var _ref7 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee2() {
                            return _regenerator().w(function(_context2) {
                                while(true)switch(_context2.n){
                                    case 0:
                                        updateTabbableNodes();
                                        _context2.n = 1;
                                        return addListeners();
                                    case 1:
                                        trap._setSubtreeIsolation(true);
                                        updateObservedNodes();
                                        onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
                                    case 2:
                                        return _context2.a(2);
                                }
                            }, _callee2);
                        }));
                        return function finishUnpause2() {
                            return _ref7.apply(this, arguments);
                        };
                    }();
                    finishUnpause();
                }
                return this;
            }
        },
        _setSubtreeIsolation: {
            value: function value(isEnabled) {
                if (config.isolateSubtrees) state.adjacentElements.forEach(function(el) {
                    var _el$getAttribute;
                    if (isEnabled) switch(config.isolateSubtrees){
                        case "aria-hidden":
                            if (el.ariaHidden === "true" || ((_el$getAttribute = el.getAttribute("aria-hidden")) === null || _el$getAttribute === void 0 ? void 0 : _el$getAttribute.toLowerCase()) === "true") state.alreadySilent.add(el);
                            el.setAttribute("aria-hidden", "true");
                            break;
                        default:
                            if (el.inert || el.hasAttribute("inert")) state.alreadySilent.add(el);
                            el.setAttribute("inert", true);
                            break;
                    }
                    else {
                        if (state.alreadySilent.has(el)) ;
                        else switch(config.isolateSubtrees){
                            case "aria-hidden":
                                el.removeAttribute("aria-hidden");
                                break;
                            default:
                                el.removeAttribute("inert");
                                break;
                        }
                    }
                });
            }
        }
    });
    trap.updateContainerElements(elements);
    return trap;
};
// packages/focus/src/index.js
function src_default(Alpine) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", ()=>{
        lastFocused = currentFocused;
        currentFocused = document.activeElement;
    });
    Alpine.magic("focus", (el)=>{
        let within = el;
        return {
            __noscroll: false,
            __wrapAround: false,
            within (el2) {
                within = el2;
                return this;
            },
            withoutScrolling () {
                this.__noscroll = true;
                return this;
            },
            noscroll () {
                this.__noscroll = true;
                return this;
            },
            withWrapAround () {
                this.__wrapAround = true;
                return this;
            },
            wrap () {
                return this.withWrapAround();
            },
            focusable (el2) {
                return isFocusable(el2);
            },
            previouslyFocused () {
                return lastFocused;
            },
            lastFocused () {
                return lastFocused;
            },
            focused () {
                return currentFocused;
            },
            focusables () {
                if (Array.isArray(within)) return within;
                return focusable(within, {
                    displayCheck: "none"
                });
            },
            all () {
                return this.focusables();
            },
            isFirst (el2) {
                let els = this.all();
                return els[0] && els[0].isSameNode(el2);
            },
            isLast (el2) {
                let els = this.all();
                return els.length && els.slice(-1)[0].isSameNode(el2);
            },
            getFirst () {
                return this.all()[0];
            },
            getLast () {
                return this.all().slice(-1)[0];
            },
            getNext () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === list.length - 1) return list[0];
                return list[list.indexOf(current) + 1];
            },
            getPrevious () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === 0) return list.slice(-1)[0];
                return list[list.indexOf(current) - 1];
            },
            first () {
                this.focus(this.getFirst());
            },
            last () {
                this.focus(this.getLast());
            },
            next () {
                this.focus(this.getNext());
            },
            previous () {
                this.focus(this.getPrevious());
            },
            prev () {
                return this.previous();
            },
            focus (el2) {
                if (!el2) return;
                setTimeout(()=>{
                    if (!el2.hasAttribute("tabindex")) el2.setAttribute("tabindex", "0");
                    el2.focus({
                        preventScroll: this.__noscroll
                    });
                });
            }
        };
    });
    Alpine.directive("trap", Alpine.skipDuringClone((el, { expression, modifiers }, { effect, evaluateLater, cleanup })=>{
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: ()=>el
        };
        let undoInert = ()=>{};
        if (modifiers.includes("noautofocus")) options.initialFocus = false;
        else {
            let autofocusEl = el.querySelector("[autofocus]");
            if (autofocusEl) options.initialFocus = autofocusEl;
        }
        if (modifiers.includes("inert")) options.onPostActivate = ()=>{
            Alpine.nextTick(()=>{
                undoInert = setInert(el);
            });
        };
        let trap = createFocusTrap(el, options);
        let undoDisableScrolling = ()=>{};
        const releaseFocus = ()=>{
            undoInert();
            undoInert = ()=>{};
            undoDisableScrolling();
            undoDisableScrolling = ()=>{};
            trap.deactivate({
                returnFocus: !modifiers.includes("noreturn")
            });
        };
        effect(()=>evaluator((value)=>{
                if (oldValue === value) return;
                if (value && !oldValue) {
                    if (modifiers.includes("noscroll")) undoDisableScrolling = disableScrolling();
                    setTimeout(()=>{
                        trap.activate();
                    }, 15);
                }
                if (!value && oldValue) releaseFocus();
                oldValue = !!value;
            }));
        cleanup(releaseFocus);
    }, // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate })=>{
        if (modifiers.includes("inert") && evaluate(expression)) setInert(el);
    }));
}
function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling)=>{
        let cache = sibling.hasAttribute("aria-hidden");
        sibling.setAttribute("aria-hidden", "true");
        undos.push(()=>cache || sibling.removeAttribute("aria-hidden"));
    });
    return ()=>{
        while(undos.length)undos.pop()();
    };
}
function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode) return;
    Array.from(el.parentNode.children).forEach((sibling)=>{
        if (sibling.isSameNode(el)) crawlSiblingsUp(el.parentNode, callback);
        else callback(sibling);
    });
}
function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    let scrollbarGutter = window.getComputedStyle(document.documentElement).scrollbarGutter;
    document.documentElement.style.overflow = "hidden";
    if (scrollbarGutter && scrollbarGutter !== "auto") return ()=>{
        document.documentElement.style.overflow = overflow;
    };
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return ()=>{
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;
    };
}
// packages/focus/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 6.4.0
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 8.0.0
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE *)
*/ 
});

parcelRegister("hraYB", function(module, exports) {

module.exports = (parcelRequire("izwFG"))($parcel$resolve("eVd7F")).then(()=>parcelRequire('beOou'));

});
parcelRegister("izwFG", function(module, exports) {
"use strict";

var $2OFcw = parcelRequire("2OFcw");
module.exports = $2OFcw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2OFcw", function(module, exports) {
"use strict";
var $20d035ed65b0bacc$var$cachedBundles = {};
var $20d035ed65b0bacc$var$cachedPreloads = {};
var $20d035ed65b0bacc$var$cachedPrefetches = {};
function $20d035ed65b0bacc$var$getCache(type) {
    switch(type){
        case 'preload':
            return $20d035ed65b0bacc$var$cachedPreloads;
        case 'prefetch':
            return $20d035ed65b0bacc$var$cachedPrefetches;
        default:
            return $20d035ed65b0bacc$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $20d035ed65b0bacc$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("EXigr", function(module, exports) {

module.exports = (parcelRequire("izwFG"))($parcel$resolve("dHi2f")).then(()=>parcelRequire('itqb7'));

});

parcelRegister("fxb6u", function(module, exports) {

module.exports = (parcelRequire("izwFG"))($parcel$resolve("fTmoj")).then(()=>parcelRequire('6MDaS'));

});

parcelRegister("97H3y", function(module, exports) {

module.exports = (parcelRequire("izwFG"))($parcel$resolve("lAatH")).then(()=>parcelRequire('iP92h'));

});

var $1a80fab45ffceb5b$exports = {};
$parcel$extendImportMap({
    "eVd7F": "swipers.8146c1d7.js",
    "dHi2f": "muxVideo.04595dd3.js",
    "fTmoj": "skillQuiz.4619d8f2.js",
    "lAatH": "matchingQuiz.d52dc142.js"
});

// @fancyapps/ui/Fancybox v4.0.31
const $c996c779fad8b3f3$var$t = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $c996c779fad8b3f3$var$e = (...i)=>{
    let s = !1;
    "boolean" == typeof i[0] && (s = i.shift());
    let o = i[0];
    if (!o || "object" != typeof o) throw new Error("extendee must be an object");
    const n = i.slice(1), a = n.length;
    for(let i = 0; i < a; i++){
        const a = n[i];
        for(let i in a)if (a.hasOwnProperty(i)) {
            const n = a[i];
            if (s && (Array.isArray(n) || $c996c779fad8b3f3$var$t(n))) {
                const t = Array.isArray(n) ? [] : {};
                o[i] = $c996c779fad8b3f3$var$e(!0, o.hasOwnProperty(i) ? o[i] : t, n);
            } else o[i] = n;
        }
    }
    return o;
}, $c996c779fad8b3f3$var$i = (t, e = 1e4)=>(t = parseFloat(t) || 0, Math.round((t + Number.EPSILON) * e) / e), $c996c779fad8b3f3$var$s = function(t) {
    return !!(t && "object" == typeof t && t instanceof Element && t !== document.body) && !t.__Panzoom && (function(t) {
        const e = getComputedStyle(t)["overflow-y"], i = getComputedStyle(t)["overflow-x"], s = ("scroll" === e || "auto" === e) && Math.abs(t.scrollHeight - t.clientHeight) > 1, o = ("scroll" === i || "auto" === i) && Math.abs(t.scrollWidth - t.clientWidth) > 1;
        return s || o;
    }(t) ? t : $c996c779fad8b3f3$var$s(t.parentNode));
}, $c996c779fad8b3f3$var$o = "undefined" != typeof window && window.ResizeObserver || class {
    constructor(t){
        this.observables = [], this.boundCheck = this.check.bind(this), this.boundCheck(), this.callback = t;
    }
    observe(t) {
        if (this.observables.some((e)=>e.el === t)) return;
        const e = {
            el: t,
            size: {
                height: t.clientHeight,
                width: t.clientWidth
            }
        };
        this.observables.push(e);
    }
    unobserve(t) {
        this.observables = this.observables.filter((e)=>e.el !== t);
    }
    disconnect() {
        this.observables = [];
    }
    check() {
        const t = this.observables.filter((t)=>{
            const e = t.el.clientHeight, i = t.el.clientWidth;
            if (t.size.height !== e || t.size.width !== i) return t.size.height = e, t.size.width = i, !0;
        }).map((t)=>t.el);
        t.length > 0 && this.callback(t), window.requestAnimationFrame(this.boundCheck);
    }
};
class $c996c779fad8b3f3$var$n {
    constructor(t){
        this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY;
    }
}
const $c996c779fad8b3f3$var$a = (t, e)=>e ? Math.sqrt((e.clientX - t.clientX) ** 2 + (e.clientY - t.clientY) ** 2) : 0, $c996c779fad8b3f3$var$r = (t, e)=>e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
class $c996c779fad8b3f3$var$h {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: s = ()=>{} } = {}){
        this._element = t, this.startPointers = [], this.currentPointers = [], this._pointerStart = (t)=>{
            if (t.buttons > 0 && 0 !== t.button) return;
            const e = new $c996c779fad8b3f3$var$n(t);
            this.currentPointers.some((t)=>t.id === e.id) || this._triggerPointerStart(e, t) && (window.addEventListener("mousemove", this._move), window.addEventListener("mouseup", this._pointerEnd));
        }, this._touchStart = (t)=>{
            for (const e of Array.from(t.changedTouches || []))this._triggerPointerStart(new $c996c779fad8b3f3$var$n(e), t);
        }, this._move = (t)=>{
            const e = this.currentPointers.slice(), i = ((t)=>"changedTouches" in t)(t) ? Array.from(t.changedTouches).map((t)=>new $c996c779fad8b3f3$var$n(t)) : [
                new $c996c779fad8b3f3$var$n(t)
            ];
            for (const t of i){
                const e = this.currentPointers.findIndex((e)=>e.id === t.id);
                e < 0 || (this.currentPointers[e] = t);
            }
            this._moveCallback(e, this.currentPointers.slice(), t);
        }, this._triggerPointerEnd = (t, e)=>{
            const i = this.currentPointers.findIndex((e)=>e.id === t.id);
            return !(i < 0) && (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this._endCallback(t, e), !0);
        }, this._pointerEnd = (t)=>{
            t.buttons > 0 && 0 !== t.button || this._triggerPointerEnd(new $c996c779fad8b3f3$var$n(t), t) && (window.removeEventListener("mousemove", this._move, {
                passive: !1
            }), window.removeEventListener("mouseup", this._pointerEnd, {
                passive: !1
            }));
        }, this._touchEnd = (t)=>{
            for (const e of Array.from(t.changedTouches || []))this._triggerPointerEnd(new $c996c779fad8b3f3$var$n(e), t);
        }, this._startCallback = e, this._moveCallback = i, this._endCallback = s, this._element.addEventListener("mousedown", this._pointerStart, {
            passive: !1
        }), this._element.addEventListener("touchstart", this._touchStart, {
            passive: !1
        }), this._element.addEventListener("touchmove", this._move, {
            passive: !1
        }), this._element.addEventListener("touchend", this._touchEnd), this._element.addEventListener("touchcancel", this._touchEnd);
    }
    stop() {
        this._element.removeEventListener("mousedown", this._pointerStart, {
            passive: !1
        }), this._element.removeEventListener("touchstart", this._touchStart, {
            passive: !1
        }), this._element.removeEventListener("touchmove", this._move, {
            passive: !1
        }), this._element.removeEventListener("touchend", this._touchEnd), this._element.removeEventListener("touchcancel", this._touchEnd), window.removeEventListener("mousemove", this._move), window.removeEventListener("mouseup", this._pointerEnd);
    }
    _triggerPointerStart(t, e) {
        return !!this._startCallback(t, e) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
}
class $c996c779fad8b3f3$var$l {
    constructor(t = {}){
        this.options = $c996c779fad8b3f3$var$e(!0, {}, t), this.plugins = [], this.events = {};
        for (const t of [
            "on",
            "once"
        ])for (const e of Object.entries(this.options[t] || {}))this[t](...e);
    }
    option(t, e, ...i) {
        t = String(t);
        let s = (o = t, n = this.options, o.split(".").reduce(function(t, e) {
            return t && t[e];
        }, n));
        var o, n;
        return "function" == typeof s && (s = s.call(this, this, ...i)), void 0 === s ? e : s;
    }
    localize(t, e = []) {
        return t = (t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, i, s)=>{
            let o = "";
            s ? o = this.option(`${i[0] + i.toLowerCase().substring(1)}.l10n.${s}`) : i && (o = this.option(`l10n.${i}`)), o || (o = t);
            for(let t = 0; t < e.length; t++)o = o.split(e[t][0]).join(e[t][1]);
            return o;
        })).replace(/\{\{(.*)\}\}/, (t, e)=>e);
    }
    on(e, i) {
        if ($c996c779fad8b3f3$var$t(e)) {
            for (const t of Object.entries(e))this.on(...t);
            return this;
        }
        return String(e).split(" ").forEach((t)=>{
            const e = this.events[t] = this.events[t] || [];
            -1 == e.indexOf(i) && e.push(i);
        }), this;
    }
    once(e, i) {
        if ($c996c779fad8b3f3$var$t(e)) {
            for (const t of Object.entries(e))this.once(...t);
            return this;
        }
        return String(e).split(" ").forEach((t)=>{
            const e = (...s)=>{
                this.off(t, e), i.call(this, this, ...s);
            };
            e._ = i, this.on(t, e);
        }), this;
    }
    off(e, i) {
        if (!$c996c779fad8b3f3$var$t(e)) return e.split(" ").forEach((t)=>{
            const e = this.events[t];
            if (!e || !e.length) return this;
            let s = -1;
            for(let t = 0, o = e.length; t < o; t++){
                const o = e[t];
                if (o && (o === i || o._ === i)) {
                    s = t;
                    break;
                }
            }
            -1 != s && e.splice(s, 1);
        }), this;
        for (const t of Object.entries(e))this.off(...t);
    }
    trigger(t, ...e) {
        for (const i of [
            ...this.events[t] || []
        ].slice())if (i && !1 === i.call(this, this, ...e)) return !1;
        for (const i of [
            ...this.events["*"] || []
        ].slice())if (i && !1 === i.call(this, t, this, ...e)) return !1;
        return !0;
    }
    attachPlugins(t) {
        const i = {};
        for (const [s, o] of Object.entries(t || {}))!1 === this.options[s] || this.plugins[s] || (this.options[s] = $c996c779fad8b3f3$var$e({}, o.defaults || {}, this.options[s]), i[s] = new o(this));
        for (const [t, e] of Object.entries(i))e.attach(this);
        return this.plugins = Object.assign({}, this.plugins, i), this;
    }
    detachPlugins() {
        for(const t in this.plugins){
            let e;
            (e = this.plugins[t]) && "function" == typeof e.detach && e.detach(this);
        }
        return this.plugins = {}, this;
    }
}
const $c996c779fad8b3f3$var$c = {
    touch: !0,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: !1,
    lockAxis: !1,
    friction: .64,
    decelFriction: .88,
    zoomFriction: .74,
    bounceForce: .2,
    baseScale: 1,
    minScale: 1,
    maxScale: 2,
    step: .5,
    textSelection: !1,
    click: "toggleZoom",
    wheel: "zoom",
    wheelFactor: 42,
    wheelLimit: 5,
    draggableClass: "is-draggable",
    draggingClass: "is-dragging",
    ratio: 1
};
class $c996c779fad8b3f3$export$b704d075ddd20210 extends $c996c779fad8b3f3$var$l {
    constructor(t, i = {}){
        super($c996c779fad8b3f3$var$e(!0, {}, $c996c779fad8b3f3$var$c, i)), this.state = "init", this.$container = t;
        for (const t of [
            "onLoad",
            "onWheel",
            "onClick"
        ])this[t] = this[t].bind(this);
        this.initLayout(), this.resetValues(), this.attachPlugins($c996c779fad8b3f3$export$b704d075ddd20210.Plugins), this.trigger("init"), this.updateMetrics(), this.attachEvents(), this.trigger("ready"), !1 === this.option("centerOnStart") ? this.state = "ready" : this.panTo({
            friction: 0
        }), t.__Panzoom = this;
    }
    initLayout() {
        const t = this.$container;
        if (!(t instanceof HTMLElement)) throw new Error("Panzoom: Container not found");
        const e = this.option("content") || t.querySelector(".panzoom__content");
        if (!e) throw new Error("Panzoom: Content not found");
        this.$content = e;
        let i = this.option("viewport") || t.querySelector(".panzoom__viewport");
        i || !1 === this.option("wrapInner") || (i = document.createElement("div"), i.classList.add("panzoom__viewport"), i.append(...t.childNodes), t.appendChild(i)), this.$viewport = i || e.parentNode;
    }
    resetValues() {
        this.updateRate = this.option("updateRate", /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 250 : 24), this.container = {
            width: 0,
            height: 0
        }, this.viewport = {
            width: 0,
            height: 0
        }, this.content = {
            origWidth: 0,
            origHeight: 0,
            width: 0,
            height: 0,
            x: this.option("x", 0),
            y: this.option("y", 0),
            scale: this.option("baseScale")
        }, this.transform = {
            x: 0,
            y: 0,
            scale: 1
        }, this.resetDragPosition();
    }
    onLoad(t) {
        this.updateMetrics(), this.panTo({
            scale: this.option("baseScale"),
            friction: 0
        }), this.trigger("load", t);
    }
    onClick(t) {
        if (t.defaultPrevented) return;
        if (document.activeElement && document.activeElement.closest("[contenteditable]")) return;
        if (this.option("textSelection") && window.getSelection().toString().length && (!t.target || !t.target.hasAttribute("data-fancybox-close"))) return void t.stopPropagation();
        const e = this.$content.getClientRects()[0];
        if ("ready" !== this.state && (this.dragPosition.midPoint || Math.abs(e.top - this.dragStart.rect.top) > 1 || Math.abs(e.left - this.dragStart.rect.left) > 1)) return t.preventDefault(), void t.stopPropagation();
        !1 !== this.trigger("click", t) && this.option("zoom") && "toggleZoom" === this.option("click") && (t.preventDefault(), t.stopPropagation(), this.zoomWithClick(t));
    }
    onWheel(t) {
        !1 !== this.trigger("wheel", t) && this.option("zoom") && this.option("wheel") && this.zoomWithWheel(t);
    }
    zoomWithWheel(t) {
        void 0 === this.changedDelta && (this.changedDelta = 0);
        const e = Math.max(-1, Math.min(1, -t.deltaY || -t.deltaX || t.wheelDelta || -t.detail)), i = this.content.scale;
        let s = i * (100 + e * this.option("wheelFactor")) / 100;
        if (e < 0 && Math.abs(i - this.option("minScale")) < .01 || e > 0 && Math.abs(i - this.option("maxScale")) < .01 ? (this.changedDelta += Math.abs(e), s = i) : (this.changedDelta = 0, s = Math.max(Math.min(s, this.option("maxScale")), this.option("minScale"))), this.changedDelta > this.option("wheelLimit")) return;
        if (t.preventDefault(), s === i) return;
        const o = this.$content.getBoundingClientRect(), n = t.clientX - o.left, a = t.clientY - o.top;
        this.zoomTo(s, {
            x: n,
            y: a
        });
    }
    zoomWithClick(t) {
        const e = this.$content.getClientRects()[0], i = t.clientX - e.left, s = t.clientY - e.top;
        this.toggleZoom({
            x: i,
            y: s
        });
    }
    attachEvents() {
        this.$content.addEventListener("load", this.onLoad), this.$container.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.$container.addEventListener("click", this.onClick, {
            passive: !1
        }), this.initObserver();
        const t = new $c996c779fad8b3f3$var$h(this.$container, {
            start: (e, i)=>{
                if (!this.option("touch")) return !1;
                if (this.velocity.scale < 0) return !1;
                const o = i.composedPath()[0];
                if (!t.currentPointers.length) {
                    if (-1 !== [
                        "BUTTON",
                        "TEXTAREA",
                        "OPTION",
                        "INPUT",
                        "SELECT",
                        "VIDEO"
                    ].indexOf(o.nodeName)) return !1;
                    if (this.option("textSelection") && ((t, e, i)=>{
                        const s = t.childNodes, o = document.createRange();
                        for(let t = 0; t < s.length; t++){
                            const n = s[t];
                            if (n.nodeType !== Node.TEXT_NODE) continue;
                            o.selectNodeContents(n);
                            const a = o.getBoundingClientRect();
                            if (e >= a.left && i >= a.top && e <= a.right && i <= a.bottom) return n;
                        }
                        return !1;
                    })(o, e.clientX, e.clientY)) return !1;
                }
                return !$c996c779fad8b3f3$var$s(o) && !1 !== this.trigger("touchStart", i) && ("mousedown" === i.type && i.preventDefault(), this.state = "pointerdown", this.resetDragPosition(), this.dragPosition.midPoint = null, this.dragPosition.time = Date.now(), !0);
            },
            move: (e, i, s)=>{
                if ("pointerdown" !== this.state) return;
                if (!1 === this.trigger("touchMove", s)) return void s.preventDefault();
                if (i.length < 2 && !0 === this.option("panOnlyZoomed") && this.content.width <= this.viewport.width && this.content.height <= this.viewport.height && this.transform.scale <= this.option("baseScale")) return;
                if (i.length > 1 && (!this.option("zoom") || !1 === this.option("pinchToZoom"))) return;
                const o = $c996c779fad8b3f3$var$r(e[0], e[1]), n = $c996c779fad8b3f3$var$r(i[0], i[1]), h = n.clientX - o.clientX, l = n.clientY - o.clientY, c = $c996c779fad8b3f3$var$a(e[0], e[1]), d = $c996c779fad8b3f3$var$a(i[0], i[1]), u = c && d ? d / c : 1;
                this.dragOffset.x += h, this.dragOffset.y += l, this.dragOffset.scale *= u, this.dragOffset.time = Date.now() - this.dragPosition.time;
                const f = 1 === this.dragStart.scale && this.option("lockAxis");
                if (f && !this.lockAxis) {
                    if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void s.preventDefault();
                    const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                    this.lockAxis = t > 45 && t < 135 ? "y" : "x";
                }
                if ("xy" === f || "y" !== this.lockAxis) {
                    if (s.preventDefault(), s.stopPropagation(), s.stopImmediatePropagation(), this.lockAxis && (this.dragOffset["x" === this.lockAxis ? "y" : "x"] = 0), this.$container.classList.add(this.option("draggingClass")), this.transform.scale === this.option("baseScale") && "y" === this.lockAxis || (this.dragPosition.x = this.dragStart.x + this.dragOffset.x), this.transform.scale === this.option("baseScale") && "x" === this.lockAxis || (this.dragPosition.y = this.dragStart.y + this.dragOffset.y), this.dragPosition.scale = this.dragStart.scale * this.dragOffset.scale, i.length > 1) {
                        const e = $c996c779fad8b3f3$var$r(t.startPointers[0], t.startPointers[1]), i = e.clientX - this.dragStart.rect.x, s = e.clientY - this.dragStart.rect.y, { deltaX: o, deltaY: a } = this.getZoomDelta(this.content.scale * this.dragOffset.scale, i, s);
                        this.dragPosition.x -= o, this.dragPosition.y -= a, this.dragPosition.midPoint = n;
                    } else this.setDragResistance();
                    this.transform = {
                        x: this.dragPosition.x,
                        y: this.dragPosition.y,
                        scale: this.dragPosition.scale
                    }, this.startAnimation();
                }
            },
            end: (e, i)=>{
                if ("pointerdown" !== this.state) return;
                if (this._dragOffset = {
                    ...this.dragOffset
                }, t.currentPointers.length) return void this.resetDragPosition();
                if (this.state = "decel", this.friction = this.option("decelFriction"), this.recalculateTransform(), this.$container.classList.remove(this.option("draggingClass")), !1 === this.trigger("touchEnd", i)) return;
                if ("decel" !== this.state) return;
                const s = this.option("minScale");
                if (this.transform.scale < s) return void this.zoomTo(s, {
                    friction: .64
                });
                const o = this.option("maxScale");
                if (this.transform.scale - o > .01) {
                    const t = this.dragPosition.midPoint || e, i = this.$content.getClientRects()[0];
                    this.zoomTo(o, {
                        friction: .64,
                        x: t.clientX - i.left,
                        y: t.clientY - i.top
                    });
                }
            }
        });
        this.pointerTracker = t;
    }
    initObserver() {
        this.resizeObserver || (this.resizeObserver = new $c996c779fad8b3f3$var$o(()=>{
            this.updateTimer || (this.updateTimer = setTimeout(()=>{
                const t = this.$container.getBoundingClientRect();
                t.width && t.height ? ((Math.abs(t.width - this.container.width) > 1 || Math.abs(t.height - this.container.height) > 1) && (this.isAnimating() && this.endAnimation(!0), this.updateMetrics(), this.panTo({
                    x: this.content.x,
                    y: this.content.y,
                    scale: this.option("baseScale"),
                    friction: 0
                })), this.updateTimer = null) : this.updateTimer = null;
            }, this.updateRate));
        }), this.resizeObserver.observe(this.$container));
    }
    resetDragPosition() {
        this.lockAxis = null, this.friction = this.option("friction"), this.velocity = {
            x: 0,
            y: 0,
            scale: 0
        };
        const { x: t, y: e, scale: i } = this.content;
        this.dragStart = {
            rect: this.$content.getBoundingClientRect(),
            x: t,
            y: e,
            scale: i
        }, this.dragPosition = {
            ...this.dragPosition,
            x: t,
            y: e,
            scale: i
        }, this.dragOffset = {
            x: 0,
            y: 0,
            scale: 1,
            time: 0
        };
    }
    updateMetrics(t) {
        !0 !== t && this.trigger("beforeUpdate");
        const e = this.$container, s = this.$content, o = this.$viewport, n = s instanceof HTMLImageElement, a = this.option("zoom"), r = this.option("resizeParent", a);
        let h = this.option("width"), l = this.option("height"), c = h || (d = s, Math.max(parseFloat(d.naturalWidth || 0), parseFloat(d.width && d.width.baseVal && d.width.baseVal.value || 0), parseFloat(d.offsetWidth || 0), parseFloat(d.scrollWidth || 0)));
        var d;
        let u = l || ((t)=>Math.max(parseFloat(t.naturalHeight || 0), parseFloat(t.height && t.height.baseVal && t.height.baseVal.value || 0), parseFloat(t.offsetHeight || 0), parseFloat(t.scrollHeight || 0)))(s);
        Object.assign(s.style, {
            width: h ? `${h}px` : "",
            height: l ? `${l}px` : "",
            maxWidth: "",
            maxHeight: ""
        }), r && Object.assign(o.style, {
            width: "",
            height: ""
        });
        const f = this.option("ratio");
        c = $c996c779fad8b3f3$var$i(c * f), u = $c996c779fad8b3f3$var$i(u * f), h = c, l = u;
        const g = s.getBoundingClientRect(), p = o.getBoundingClientRect(), m = o == e ? p : e.getBoundingClientRect();
        let y = Math.max(o.offsetWidth, $c996c779fad8b3f3$var$i(p.width)), v = Math.max(o.offsetHeight, $c996c779fad8b3f3$var$i(p.height)), b = window.getComputedStyle(o);
        if (y -= parseFloat(b.paddingLeft) + parseFloat(b.paddingRight), v -= parseFloat(b.paddingTop) + parseFloat(b.paddingBottom), this.viewport.width = y, this.viewport.height = v, a) {
            if (Math.abs(c - g.width) > .1 || Math.abs(u - g.height) > .1) {
                const t = ((t, e, i, s)=>{
                    const o = Math.min(i / t || 0, s / e);
                    return {
                        width: t * o || 0,
                        height: e * o || 0
                    };
                })(c, u, Math.min(c, g.width), Math.min(u, g.height));
                h = $c996c779fad8b3f3$var$i(t.width), l = $c996c779fad8b3f3$var$i(t.height);
            }
            Object.assign(s.style, {
                width: `${h}px`,
                height: `${l}px`,
                transform: ""
            });
        }
        if (r && (Object.assign(o.style, {
            width: `${h}px`,
            height: `${l}px`
        }), this.viewport = {
            ...this.viewport,
            width: h,
            height: l
        }), n && a && "function" != typeof this.options.maxScale) {
            const t = this.option("maxScale");
            this.options.maxScale = function() {
                return this.content.origWidth > 0 && this.content.fitWidth > 0 ? this.content.origWidth / this.content.fitWidth : t;
            };
        }
        this.content = {
            ...this.content,
            origWidth: c,
            origHeight: u,
            fitWidth: h,
            fitHeight: l,
            width: h,
            height: l,
            scale: 1,
            isZoomable: a
        }, this.container = {
            width: m.width,
            height: m.height
        }, !0 !== t && this.trigger("afterUpdate");
    }
    zoomIn(t) {
        this.zoomTo(this.content.scale + (t || this.option("step")));
    }
    zoomOut(t) {
        this.zoomTo(this.content.scale - (t || this.option("step")));
    }
    toggleZoom(t = {}) {
        const e = this.option("maxScale"), i = this.option("baseScale"), s = this.content.scale > i + .5 * (e - i) ? i : e;
        this.zoomTo(s, t);
    }
    zoomTo(t = this.option("baseScale"), { x: e = null, y: s = null } = {}) {
        t = Math.max(Math.min(t, this.option("maxScale")), this.option("minScale"));
        const o = $c996c779fad8b3f3$var$i(this.content.scale / (this.content.width / this.content.fitWidth), 1e7);
        null === e && (e = this.content.width * o * .5), null === s && (s = this.content.height * o * .5);
        const { deltaX: n, deltaY: a } = this.getZoomDelta(t, e, s);
        e = this.content.x - n, s = this.content.y - a, this.panTo({
            x: e,
            y: s,
            scale: t,
            friction: this.option("zoomFriction")
        });
    }
    getZoomDelta(t, e = 0, i = 0) {
        const s = this.content.fitWidth * this.content.scale, o = this.content.fitHeight * this.content.scale, n = e > 0 && s ? e / s : 0, a = i > 0 && o ? i / o : 0;
        return {
            deltaX: (this.content.fitWidth * t - s) * n,
            deltaY: (this.content.fitHeight * t - o) * a
        };
    }
    panTo({ x: t = this.content.x, y: e = this.content.y, scale: i, friction: s = this.option("friction"), ignoreBounds: o = !1 } = {}) {
        if (i = i || this.content.scale || 1, !o) {
            const { boundX: s, boundY: o } = this.getBounds(i);
            s && (t = Math.max(Math.min(t, s.to), s.from)), o && (e = Math.max(Math.min(e, o.to), o.from));
        }
        this.friction = s, this.transform = {
            ...this.transform,
            x: t,
            y: e,
            scale: i
        }, s ? (this.state = "panning", this.velocity = {
            x: (1 / this.friction - 1) * (t - this.content.x),
            y: (1 / this.friction - 1) * (e - this.content.y),
            scale: (1 / this.friction - 1) * (i - this.content.scale)
        }, this.startAnimation()) : this.endAnimation();
    }
    startAnimation() {
        this.rAF ? cancelAnimationFrame(this.rAF) : this.trigger("startAnimation"), this.rAF = requestAnimationFrame(()=>this.animate());
    }
    animate() {
        if (this.setEdgeForce(), this.setDragForce(), this.velocity.x *= this.friction, this.velocity.y *= this.friction, this.velocity.scale *= this.friction, this.content.x += this.velocity.x, this.content.y += this.velocity.y, this.content.scale += this.velocity.scale, this.isAnimating()) this.setTransform();
        else if ("pointerdown" !== this.state) return void this.endAnimation();
        this.rAF = requestAnimationFrame(()=>this.animate());
    }
    getBounds(t) {
        let e = this.boundX, s = this.boundY;
        if (void 0 !== e && void 0 !== s) return {
            boundX: e,
            boundY: s
        };
        e = {
            from: 0,
            to: 0
        }, s = {
            from: 0,
            to: 0
        }, t = t || this.transform.scale;
        const o = this.content.fitWidth * t, n = this.content.fitHeight * t, a = this.viewport.width, r = this.viewport.height;
        if (o < a) {
            const t = $c996c779fad8b3f3$var$i(.5 * (a - o));
            e.from = t, e.to = t;
        } else e.from = $c996c779fad8b3f3$var$i(a - o);
        if (n < r) {
            const t = .5 * (r - n);
            s.from = t, s.to = t;
        } else s.from = $c996c779fad8b3f3$var$i(r - n);
        return {
            boundX: e,
            boundY: s
        };
    }
    setEdgeForce() {
        if ("decel" !== this.state) return;
        const t = this.option("bounceForce"), { boundX: e, boundY: i } = this.getBounds(Math.max(this.transform.scale, this.content.scale));
        let s, o, n, a;
        if (e && (s = this.content.x < e.from, o = this.content.x > e.to), i && (n = this.content.y < i.from, a = this.content.y > i.to), s || o) {
            let i = ((s ? e.from : e.to) - this.content.x) * t;
            const o = this.content.x + (this.velocity.x + i) / this.friction;
            o >= e.from && o <= e.to && (i += this.velocity.x), this.velocity.x = i, this.recalculateTransform();
        }
        if (n || a) {
            let e = ((n ? i.from : i.to) - this.content.y) * t;
            const s = this.content.y + (e + this.velocity.y) / this.friction;
            s >= i.from && s <= i.to && (e += this.velocity.y), this.velocity.y = e, this.recalculateTransform();
        }
    }
    setDragResistance() {
        if ("pointerdown" !== this.state) return;
        const { boundX: t, boundY: e } = this.getBounds(this.dragPosition.scale);
        let i, s, o, n;
        if (t && (i = this.dragPosition.x < t.from, s = this.dragPosition.x > t.to), e && (o = this.dragPosition.y < e.from, n = this.dragPosition.y > e.to), (i || s) && (!i || !s)) {
            const e = i ? t.from : t.to, s = e - this.dragPosition.x;
            this.dragPosition.x = e - .3 * s;
        }
        if ((o || n) && (!o || !n)) {
            const t = o ? e.from : e.to, i = t - this.dragPosition.y;
            this.dragPosition.y = t - .3 * i;
        }
    }
    setDragForce() {
        "pointerdown" === this.state && (this.velocity.x = this.dragPosition.x - this.content.x, this.velocity.y = this.dragPosition.y - this.content.y, this.velocity.scale = this.dragPosition.scale - this.content.scale);
    }
    recalculateTransform() {
        this.transform.x = this.content.x + this.velocity.x / (1 / this.friction - 1), this.transform.y = this.content.y + this.velocity.y / (1 / this.friction - 1), this.transform.scale = this.content.scale + this.velocity.scale / (1 / this.friction - 1);
    }
    isAnimating() {
        return !(!this.friction || !(Math.abs(this.velocity.x) > .05 || Math.abs(this.velocity.y) > .05 || Math.abs(this.velocity.scale) > .05));
    }
    setTransform(t) {
        let e, s, o;
        if (t ? (e = $c996c779fad8b3f3$var$i(this.transform.x), s = $c996c779fad8b3f3$var$i(this.transform.y), o = this.transform.scale, this.content = {
            ...this.content,
            x: e,
            y: s,
            scale: o
        }) : (e = $c996c779fad8b3f3$var$i(this.content.x), s = $c996c779fad8b3f3$var$i(this.content.y), o = this.content.scale / (this.content.width / this.content.fitWidth), this.content = {
            ...this.content,
            x: e,
            y: s
        }), this.trigger("beforeTransform"), e = $c996c779fad8b3f3$var$i(this.content.x), s = $c996c779fad8b3f3$var$i(this.content.y), t && this.option("zoom")) {
            let t, n;
            t = $c996c779fad8b3f3$var$i(this.content.fitWidth * o), n = $c996c779fad8b3f3$var$i(this.content.fitHeight * o), this.content.width = t, this.content.height = n, this.transform = {
                ...this.transform,
                width: t,
                height: n,
                scale: o
            }, Object.assign(this.$content.style, {
                width: `${t}px`,
                height: `${n}px`,
                maxWidth: "none",
                maxHeight: "none",
                transform: `translate3d(${e}px, ${s}px, 0) scale(1)`
            });
        } else this.$content.style.transform = `translate3d(${e}px, ${s}px, 0) scale(${o})`;
        this.trigger("afterTransform");
    }
    endAnimation(t) {
        cancelAnimationFrame(this.rAF), this.rAF = null, this.velocity = {
            x: 0,
            y: 0,
            scale: 0
        }, this.setTransform(!0), this.state = "ready", this.handleCursor(), !0 !== t && this.trigger("endAnimation");
    }
    handleCursor() {
        const t = this.option("draggableClass");
        t && this.option("touch") && (1 == this.option("panOnlyZoomed") && this.content.width <= this.viewport.width && this.content.height <= this.viewport.height && this.transform.scale <= this.option("baseScale") ? this.$container.classList.remove(t) : this.$container.classList.add(t));
    }
    detachEvents() {
        this.$content.removeEventListener("load", this.onLoad), this.$container.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.$container.removeEventListener("click", this.onClick, {
            passive: !1
        }), this.pointerTracker && (this.pointerTracker.stop(), this.pointerTracker = null), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
    }
    destroy() {
        "destroy" !== this.state && (this.state = "destroy", clearTimeout(this.updateTimer), this.updateTimer = null, cancelAnimationFrame(this.rAF), this.rAF = null, this.detachEvents(), this.detachPlugins(), this.resetDragPosition());
    }
}
$c996c779fad8b3f3$export$b704d075ddd20210.version = "4.0.31", $c996c779fad8b3f3$export$b704d075ddd20210.Plugins = {};
const $c996c779fad8b3f3$var$u = (t, e)=>{
    let i = 0;
    return function(...s) {
        const o = (new Date).getTime();
        if (!(o - i < e)) return i = o, t(...s);
    };
};
class $c996c779fad8b3f3$var$f {
    constructor(t){
        this.$container = null, this.$prev = null, this.$next = null, this.carousel = t, this.onRefresh = this.onRefresh.bind(this);
    }
    option(t) {
        return this.carousel.option(`Navigation.${t}`);
    }
    createButton(t) {
        const e = document.createElement("button");
        e.setAttribute("title", this.carousel.localize(`{{${t.toUpperCase()}}}`));
        const i = this.option("classNames.button") + " " + this.option(`classNames.${t}`);
        return e.classList.add(...i.split(" ")), e.setAttribute("tabindex", "0"), e.innerHTML = this.carousel.localize(this.option(`${t}Tpl`)), e.addEventListener("click", (e)=>{
            e.preventDefault(), e.stopPropagation(), this.carousel["slide" + ("next" === t ? "Next" : "Prev")]();
        }), e;
    }
    build() {
        this.$container || (this.$container = document.createElement("div"), this.$container.classList.add(...this.option("classNames.main").split(" ")), this.carousel.$container.appendChild(this.$container)), this.$next || (this.$next = this.createButton("next"), this.$container.appendChild(this.$next)), this.$prev || (this.$prev = this.createButton("prev"), this.$container.appendChild(this.$prev));
    }
    onRefresh() {
        const t = this.carousel.pages.length;
        t <= 1 || t > 1 && this.carousel.elemDimWidth < this.carousel.wrapDimWidth && !Number.isInteger(this.carousel.option("slidesPerPage")) ? this.cleanup() : (this.build(), this.$prev.removeAttribute("disabled"), this.$next.removeAttribute("disabled"), this.carousel.option("infiniteX", this.carousel.option("infinite")) || (this.carousel.page <= 0 && this.$prev.setAttribute("disabled", ""), this.carousel.page >= t - 1 && this.$next.setAttribute("disabled", "")));
    }
    cleanup() {
        this.$prev && this.$prev.remove(), this.$prev = null, this.$next && this.$next.remove(), this.$next = null, this.$container && this.$container.remove(), this.$container = null;
    }
    attach() {
        this.carousel.on("refresh change", this.onRefresh);
    }
    detach() {
        this.carousel.off("refresh change", this.onRefresh), this.cleanup();
    }
}
$c996c779fad8b3f3$var$f.defaults = {
    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
    classNames: {
        main: "carousel__nav",
        button: "carousel__button",
        next: "is-next",
        prev: "is-prev"
    }
};
class $c996c779fad8b3f3$var$g {
    constructor(t){
        this.carousel = t, this.selectedIndex = null, this.friction = 0, this.onNavReady = this.onNavReady.bind(this), this.onNavClick = this.onNavClick.bind(this), this.onNavCreateSlide = this.onNavCreateSlide.bind(this), this.onTargetChange = this.onTargetChange.bind(this);
    }
    addAsTargetFor(t) {
        this.target = this.carousel, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.target = t, this.nav = this.carousel, this.attachEvents();
    }
    attachEvents() {
        this.nav.options.initialSlide = this.target.options.initialPage, this.nav.on("ready", this.onNavReady), this.nav.on("createSlide", this.onNavCreateSlide), this.nav.on("Panzoom.click", this.onNavClick), this.target.on("change", this.onTargetChange), this.target.on("Panzoom.afterUpdate", this.onTargetChange);
    }
    onNavReady() {
        this.onTargetChange(!0);
    }
    onNavClick(t, e, i) {
        const s = i.target.closest(".carousel__slide");
        if (!s) return;
        i.stopPropagation();
        const o = parseInt(s.dataset.index, 10), n = this.target.findPageForSlide(o);
        this.target.page !== n && this.target.slideTo(n, {
            friction: this.friction
        }), this.markSelectedSlide(o);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        const t = this.target.pages[this.target.page].indexes[0], e = this.nav.findPageForSlide(t);
        this.nav.slideTo(e), this.markSelectedSlide(t);
    }
    markSelectedSlide(t) {
        this.selectedIndex = t, [
            ...this.nav.slides
        ].filter((t)=>t.$el && t.$el.classList.remove("is-nav-selected"));
        const e = this.nav.slides[t];
        e && e.$el && e.$el.classList.add("is-nav-selected");
    }
    attach(t) {
        const e = t.options.Sync;
        (e.target || e.nav) && (e.target ? this.addAsNavFor(e.target) : e.nav && this.addAsTargetFor(e.nav), this.friction = e.friction);
    }
    detach() {
        this.nav && (this.nav.off("ready", this.onNavReady), this.nav.off("Panzoom.click", this.onNavClick), this.nav.off("createSlide", this.onNavCreateSlide)), this.target && (this.target.off("Panzoom.afterUpdate", this.onTargetChange), this.target.off("change", this.onTargetChange));
    }
}
$c996c779fad8b3f3$var$g.defaults = {
    friction: .92
};
const $c996c779fad8b3f3$var$p = {
    Navigation: $c996c779fad8b3f3$var$f,
    Dots: class {
        constructor(t){
            this.carousel = t, this.$list = null, this.events = {
                change: this.onChange.bind(this),
                refresh: this.onRefresh.bind(this)
            };
        }
        buildList() {
            if (this.carousel.pages.length < this.carousel.option("Dots.minSlideCount")) return;
            const t = document.createElement("ol");
            return t.classList.add("carousel__dots"), t.addEventListener("click", (t)=>{
                if (!("page" in t.target.dataset)) return;
                t.preventDefault(), t.stopPropagation();
                const e = parseInt(t.target.dataset.page, 10), i = this.carousel;
                e !== i.page && (i.pages.length < 3 && i.option("infinite") ? i[0 == e ? "slidePrev" : "slideNext"]() : i.slideTo(e));
            }), this.$list = t, this.carousel.$container.appendChild(t), this.carousel.$container.classList.add("has-dots"), t;
        }
        removeList() {
            this.$list && (this.$list.parentNode.removeChild(this.$list), this.$list = null), this.carousel.$container.classList.remove("has-dots");
        }
        rebuildDots() {
            let t = this.$list;
            const e = !!t, i = this.carousel.pages.length;
            if (i < 2) return void (e && this.removeList());
            e || (t = this.buildList());
            const s = this.$list.children.length;
            if (s > i) for(let t = i; t < s; t++)this.$list.removeChild(this.$list.lastChild);
            else {
                for(let t = s; t < i; t++){
                    const e = document.createElement("li");
                    e.classList.add("carousel__dot"), e.dataset.page = t, e.setAttribute("role", "button"), e.setAttribute("tabindex", "0"), e.setAttribute("title", this.carousel.localize("{{GOTO}}", [
                        [
                            "%d",
                            t + 1
                        ]
                    ])), e.addEventListener("keydown", (t)=>{
                        const i = t.code;
                        let s;
                        "Enter" === i || "NumpadEnter" === i ? s = e : "ArrowRight" === i ? s = e.nextSibling : "ArrowLeft" === i && (s = e.previousSibling), s && s.click();
                    }), this.$list.appendChild(e);
                }
                this.setActiveDot();
            }
        }
        setActiveDot() {
            if (!this.$list) return;
            this.$list.childNodes.forEach((t)=>{
                t.classList.remove("is-selected");
            });
            const t = this.$list.childNodes[this.carousel.page];
            t && t.classList.add("is-selected");
        }
        onChange() {
            this.setActiveDot();
        }
        onRefresh() {
            this.rebuildDots();
        }
        attach() {
            this.carousel.on(this.events);
        }
        detach() {
            this.removeList(), this.carousel.off(this.events), this.carousel = null;
        }
    },
    Sync: $c996c779fad8b3f3$var$g
};
const $c996c779fad8b3f3$var$m = {
    slides: [],
    preload: 0,
    slidesPerPage: "auto",
    initialPage: null,
    initialSlide: null,
    friction: .92,
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    prefix: "",
    classNames: {
        viewport: "carousel__viewport",
        track: "carousel__track",
        slide: "carousel__slide",
        slideSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
class $c996c779fad8b3f3$export$144901db2ea8e967 extends $c996c779fad8b3f3$var$l {
    constructor(t, i = {}){
        if (super(i = $c996c779fad8b3f3$var$e(!0, {}, $c996c779fad8b3f3$var$m, i)), this.state = "init", this.$container = t, !(this.$container instanceof HTMLElement)) throw new Error("No root element provided");
        this.slideNext = $c996c779fad8b3f3$var$u(this.slideNext.bind(this), 250), this.slidePrev = $c996c779fad8b3f3$var$u(this.slidePrev.bind(this), 250), this.init(), t.__Carousel = this;
    }
    init() {
        this.pages = [], this.page = this.pageIndex = null, this.prevPage = this.prevPageIndex = null, this.attachPlugins($c996c779fad8b3f3$export$144901db2ea8e967.Plugins), this.trigger("init"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.$track && this.pages.length && (this.$track.style.transform = `translate3d(${-1 * this.pages[this.page].left}px, 0px, 0) scale(1)`), this.manageSlideVisiblity(), this.initPanzoom(), this.state = "ready", this.trigger("ready");
    }
    initLayout() {
        const t = this.option("prefix"), e = this.option("classNames");
        this.$viewport = this.option("viewport") || this.$container.querySelector(`.${t}${e.viewport}`), this.$viewport || (this.$viewport = document.createElement("div"), this.$viewport.classList.add(...(t + e.viewport).split(" ")), this.$viewport.append(...this.$container.childNodes), this.$container.appendChild(this.$viewport)), this.$track = this.option("track") || this.$container.querySelector(`.${t}${e.track}`), this.$track || (this.$track = document.createElement("div"), this.$track.classList.add(...(t + e.track).split(" ")), this.$track.append(...this.$viewport.childNodes), this.$viewport.appendChild(this.$track));
    }
    initSlides() {
        this.slides = [];
        this.$viewport.querySelectorAll(`.${this.option("prefix")}${this.option("classNames.slide")}`).forEach((t)=>{
            const e = {
                $el: t,
                isDom: !0
            };
            this.slides.push(e), this.trigger("createSlide", e, this.slides.length);
        }), Array.isArray(this.options.slides) && (this.slides = $c996c779fad8b3f3$var$e(!0, [
            ...this.slides
        ], this.options.slides));
    }
    updateMetrics() {
        let t, e = 0, s = [];
        this.slides.forEach((i, o)=>{
            const n = i.$el, a = i.isDom || !t ? this.getSlideMetrics(n) : t;
            i.index = o, i.width = a, i.left = e, t = a, e += a, s.push(o);
        });
        let o = Math.max(this.$track.offsetWidth, $c996c779fad8b3f3$var$i(this.$track.getBoundingClientRect().width)), n = getComputedStyle(this.$track);
        o -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight), this.contentWidth = e, this.viewportWidth = o;
        const a = [], r = this.option("slidesPerPage");
        if (Number.isInteger(r) && e > o) for(let t = 0; t < this.slides.length; t += r)a.push({
            indexes: s.slice(t, t + r),
            slides: this.slides.slice(t, t + r)
        });
        else {
            let t = 0, e = 0;
            for(let i = 0; i < this.slides.length; i += 1){
                let s = this.slides[i];
                (!a.length || e + s.width > o) && (a.push({
                    indexes: [],
                    slides: []
                }), t = a.length - 1, e = 0), e += s.width, a[t].indexes.push(i), a[t].slides.push(s);
            }
        }
        const h = this.option("center"), l = this.option("fill");
        a.forEach((t, i)=>{
            t.index = i, t.width = t.slides.reduce((t, e)=>t + e.width, 0), t.left = t.slides[0].left, h && (t.left += .5 * (o - t.width) * -1), l && !this.option("infiniteX", this.option("infinite")) && e > o && (t.left = Math.max(t.left, 0), t.left = Math.min(t.left, e - o));
        });
        const c = [];
        let d;
        a.forEach((t)=>{
            const e = {
                ...t
            };
            d && e.left === d.left ? (d.width += e.width, d.slides = [
                ...d.slides,
                ...e.slides
            ], d.indexes = [
                ...d.indexes,
                ...e.indexes
            ]) : (e.index = c.length, d = e, c.push(e));
        }), this.pages = c;
        let u = this.page;
        if (null === u) {
            const t = this.option("initialSlide");
            u = null !== t ? this.findPageForSlide(t) : parseInt(this.option("initialPage", 0), 10) || 0, c[u] || (u = c.length && u > c.length ? c[c.length - 1].index : 0), this.page = u, this.pageIndex = u;
        }
        this.updatePanzoom(), this.trigger("refresh");
    }
    getSlideMetrics(t) {
        if (!t) {
            const e = this.slides[0];
            (t = document.createElement("div")).dataset.isTestEl = 1, t.style.visibility = "hidden", t.classList.add(...(this.option("prefix") + this.option("classNames.slide")).split(" ")), e.customClass && t.classList.add(...e.customClass.split(" ")), this.$track.prepend(t);
        }
        let e = Math.max(t.offsetWidth, $c996c779fad8b3f3$var$i(t.getBoundingClientRect().width));
        const s = t.currentStyle || window.getComputedStyle(t);
        return e = e + (parseFloat(s.marginLeft) || 0) + (parseFloat(s.marginRight) || 0), t.dataset.isTestEl && t.remove(), e;
    }
    findPageForSlide(t) {
        t = parseInt(t, 10) || 0;
        const e = this.pages.find((e)=>e.indexes.indexOf(t) > -1);
        return e ? e.index : null;
    }
    slideNext() {
        this.slideTo(this.pageIndex + 1);
    }
    slidePrev() {
        this.slideTo(this.pageIndex - 1);
    }
    slideTo(t, e = {}) {
        const { x: i = -1 * this.setPage(t, !0), y: s = 0, friction: o = this.option("friction") } = e;
        this.Panzoom.content.x === i && !this.Panzoom.velocity.x && o || (this.Panzoom.panTo({
            x: i,
            y: s,
            friction: o,
            ignoreBounds: !0
        }), "ready" === this.state && "ready" === this.Panzoom.state && this.trigger("settle"));
    }
    initPanzoom() {
        this.Panzoom && this.Panzoom.destroy();
        const t = $c996c779fad8b3f3$var$e(!0, {}, {
            content: this.$track,
            wrapInner: !1,
            resizeParent: !1,
            zoom: !1,
            click: !1,
            lockAxis: "x",
            x: this.pages.length ? -1 * this.pages[this.page].left : 0,
            centerOnStart: !1,
            textSelection: ()=>this.option("textSelection", !1),
            panOnlyZoomed: function() {
                return this.content.width <= this.viewport.width;
            }
        }, this.option("Panzoom"));
        this.Panzoom = new $c996c779fad8b3f3$export$b704d075ddd20210(this.$container, t), this.Panzoom.on({
            "*": (t, ...e)=>this.trigger(`Panzoom.${t}`, ...e),
            afterUpdate: ()=>{
                this.updatePage();
            },
            beforeTransform: this.onBeforeTransform.bind(this),
            touchEnd: this.onTouchEnd.bind(this),
            endAnimation: ()=>{
                this.trigger("settle");
            }
        }), this.updateMetrics(), this.manageSlideVisiblity();
    }
    updatePanzoom() {
        this.Panzoom && (this.Panzoom.content = {
            ...this.Panzoom.content,
            fitWidth: this.contentWidth,
            origWidth: this.contentWidth,
            width: this.contentWidth
        }, this.pages.length > 1 && this.option("infiniteX", this.option("infinite")) ? this.Panzoom.boundX = null : this.pages.length && (this.Panzoom.boundX = {
            from: -1 * this.pages[this.pages.length - 1].left,
            to: -1 * this.pages[0].left
        }), this.option("infiniteY", this.option("infinite")) ? this.Panzoom.boundY = null : this.Panzoom.boundY = {
            from: 0,
            to: 0
        }, this.Panzoom.handleCursor());
    }
    manageSlideVisiblity() {
        const t = this.contentWidth, e = this.viewportWidth;
        let i = this.Panzoom ? -1 * this.Panzoom.content.x : this.pages.length ? this.pages[this.page].left : 0;
        const s = this.option("preload"), o = this.option("infiniteX", this.option("infinite")), n = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-left")), a = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-right"));
        this.slides.forEach((r)=>{
            let h, l, c = 0;
            h = i - n, l = i + e + a, h -= s * (e + n + a), l += s * (e + n + a);
            const d = r.left + r.width > h && r.left < l;
            h = i + t - n, l = i + t + e + a, h -= s * (e + n + a);
            const u = o && r.left + r.width > h && r.left < l;
            h = i - t - n, l = i - t + e + a, h -= s * (e + n + a);
            const f = o && r.left + r.width > h && r.left < l;
            u || d || f ? (this.createSlideEl(r), d && (c = 0), u && (c = -1), f && (c = 1), r.left + r.width > i && r.left <= i + e + a && (c = 0)) : this.removeSlideEl(r), r.hasDiff = c;
        });
        let r = 0, h = 0;
        this.slides.forEach((e, i)=>{
            let s = 0;
            e.$el ? (i !== r || e.hasDiff ? s = h + e.hasDiff * t : h = 0, e.$el.style.left = Math.abs(s) > .1 ? `${h + e.hasDiff * t}px` : "", r++) : h += e.width;
        }), this.markSelectedSlides();
    }
    createSlideEl(t) {
        if (!t) return;
        if (t.$el) {
            let e = t.$el.dataset.index;
            if (!e || parseInt(e, 10) !== t.index) {
                let e;
                t.$el.dataset.index = t.index, t.$el.querySelectorAll("[data-lazy-srcset]").forEach((t)=>{
                    t.srcset = t.dataset.lazySrcset;
                }), t.$el.querySelectorAll("[data-lazy-src]").forEach((t)=>{
                    let e = t.dataset.lazySrc;
                    t instanceof HTMLImageElement ? t.src = e : t.style.backgroundImage = `url('${e}')`;
                }), (e = t.$el.dataset.lazySrc) && (t.$el.style.backgroundImage = `url('${e}')`), t.state = "ready";
            }
            return;
        }
        const e = document.createElement("div");
        e.dataset.index = t.index, e.classList.add(...(this.option("prefix") + this.option("classNames.slide")).split(" ")), t.customClass && e.classList.add(...t.customClass.split(" ")), t.html && (e.innerHTML = t.html);
        const i = [];
        this.slides.forEach((t, e)=>{
            t.$el && i.push(e);
        });
        const s = t.index;
        let o = null;
        if (i.length) {
            let t = i.reduce((t, e)=>Math.abs(e - s) < Math.abs(t - s) ? e : t);
            o = this.slides[t];
        }
        return this.$track.insertBefore(e, o && o.$el ? o.index < t.index ? o.$el.nextSibling : o.$el : null), t.$el = e, this.trigger("createSlide", t, s), t;
    }
    removeSlideEl(t) {
        t.$el && !t.isDom && (this.trigger("removeSlide", t), t.$el.remove(), t.$el = null);
    }
    markSelectedSlides() {
        const t = this.option("classNames.slideSelected"), e = "aria-hidden";
        this.slides.forEach((i, s)=>{
            const o = i.$el;
            if (!o) return;
            const n = this.pages[this.page];
            n && n.indexes && n.indexes.indexOf(s) > -1 ? (t && !o.classList.contains(t) && (o.classList.add(t), this.trigger("selectSlide", i)), o.removeAttribute(e)) : (t && o.classList.contains(t) && (o.classList.remove(t), this.trigger("unselectSlide", i)), o.setAttribute(e, !0));
        });
    }
    updatePage() {
        this.updateMetrics(), this.slideTo(this.page, {
            friction: 0
        });
    }
    onBeforeTransform() {
        this.option("infiniteX", this.option("infinite")) && this.manageInfiniteTrack(), this.manageSlideVisiblity();
    }
    manageInfiniteTrack() {
        const t = this.contentWidth, e = this.viewportWidth;
        if (!this.option("infiniteX", this.option("infinite")) || this.pages.length < 2 || t < e) return;
        const i = this.Panzoom;
        let s = !1;
        return i.content.x < -1 * (t - e) && (i.content.x += t, this.pageIndex = this.pageIndex - this.pages.length, s = !0), i.content.x > e && (i.content.x -= t, this.pageIndex = this.pageIndex + this.pages.length, s = !0), s && "pointerdown" === i.state && i.resetDragPosition(), s;
    }
    onTouchEnd(t, e) {
        const i = this.option("dragFree");
        if (!i && this.pages.length > 1 && t.dragOffset.time < 350 && Math.abs(t.dragOffset.y) < 1 && Math.abs(t.dragOffset.x) > 5) this[t.dragOffset.x < 0 ? "slideNext" : "slidePrev"]();
        else if (i) {
            const [, e] = this.getPageFromPosition(-1 * t.transform.x);
            this.setPage(e);
        } else this.slideToClosest();
    }
    slideToClosest(t = {}) {
        let [, e] = this.getPageFromPosition(-1 * this.Panzoom.content.x);
        this.slideTo(e, t);
    }
    getPageFromPosition(t) {
        const e = this.pages.length;
        this.option("center") && (t += .5 * this.viewportWidth);
        const i = Math.floor(t / this.contentWidth);
        t -= i * this.contentWidth;
        let s = this.slides.find((e)=>e.left <= t && e.left + e.width > t);
        if (s) {
            let t = this.findPageForSlide(s.index);
            return [
                t,
                t + i * e
            ];
        }
        return [
            0,
            0
        ];
    }
    setPage(t, e) {
        let i = 0, s = parseInt(t, 10) || 0;
        const o = this.page, n = this.pageIndex, a = this.pages.length, r = this.contentWidth, h = this.viewportWidth;
        if (t = (s % a + a) % a, this.option("infiniteX", this.option("infinite")) && r > h) {
            const o = Math.floor(s / a) || 0, n = r;
            if (i = this.pages[t].left + o * n, !0 === e && a > 2) {
                let t = -1 * this.Panzoom.content.x;
                const e = i - n, o = i + n, r = Math.abs(t - i), h = Math.abs(t - e), l = Math.abs(t - o);
                l < r && l <= h ? (i = o, s += a) : h < r && h < l && (i = e, s -= a);
            }
        } else t = s = Math.max(0, Math.min(s, a - 1)), i = this.pages.length ? this.pages[t].left : 0;
        return this.page = t, this.pageIndex = s, null !== o && t !== o && (this.prevPage = o, this.prevPageIndex = n, this.trigger("change", t, o)), i;
    }
    destroy() {
        this.state = "destroy", this.slides.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.slides = [], this.Panzoom.destroy(), this.detachPlugins();
    }
}
$c996c779fad8b3f3$export$144901db2ea8e967.version = "4.0.31", $c996c779fad8b3f3$export$144901db2ea8e967.Plugins = $c996c779fad8b3f3$var$p;
const $c996c779fad8b3f3$var$v = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $c996c779fad8b3f3$var$b = null;
const $c996c779fad8b3f3$var$x = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
], $c996c779fad8b3f3$var$w = (t)=>{
    if (t && $c996c779fad8b3f3$var$v) {
        null === $c996c779fad8b3f3$var$b && document.createElement("div").focus({
            get preventScroll () {
                return $c996c779fad8b3f3$var$b = !0, !1;
            }
        });
        try {
            if (t.setActive) t.setActive();
            else if ($c996c779fad8b3f3$var$b) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.pageXOffset || document.body.scrollTop, i = window.pageYOffset || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
};
const $c996c779fad8b3f3$var$$ = {
    minSlideCount: 2,
    minScreenHeight: 500,
    autoStart: !0,
    key: "t",
    Carousel: {},
    tpl: '<div class="fancybox__thumb" style="background-image:url(\'{{src}}\')"></div>'
};
class $c996c779fad8b3f3$var$C {
    constructor(t){
        this.fancybox = t, this.$container = null, this.state = "init";
        for (const t of [
            "onPrepare",
            "onClosing",
            "onKeydown"
        ])this[t] = this[t].bind(this);
        this.events = {
            prepare: this.onPrepare,
            closing: this.onClosing,
            keydown: this.onKeydown
        };
    }
    onPrepare() {
        this.getSlides().length < this.fancybox.option("Thumbs.minSlideCount") ? this.state = "disabled" : !0 === this.fancybox.option("Thumbs.autoStart") && this.fancybox.Carousel.Panzoom.content.height >= this.fancybox.option("Thumbs.minScreenHeight") && this.build();
    }
    onClosing() {
        this.Carousel && this.Carousel.Panzoom.detachEvents();
    }
    onKeydown(t, e) {
        e === t.option("Thumbs.key") && this.toggle();
    }
    build() {
        if (this.$container) return;
        const t = document.createElement("div");
        t.classList.add("fancybox__thumbs"), this.fancybox.$carousel.parentNode.insertBefore(t, this.fancybox.$carousel.nextSibling), this.Carousel = new $c996c779fad8b3f3$export$144901db2ea8e967(t, $c996c779fad8b3f3$var$e(!0, {
            Dots: !1,
            Navigation: !1,
            Sync: {
                friction: 0
            },
            infinite: !1,
            center: !0,
            fill: !0,
            dragFree: !0,
            slidesPerPage: 1,
            preload: 1
        }, this.fancybox.option("Thumbs.Carousel"), {
            Sync: {
                target: this.fancybox.Carousel
            },
            slides: this.getSlides()
        })), this.Carousel.Panzoom.on("wheel", (t, e)=>{
            e.preventDefault(), this.fancybox[e.deltaY < 0 ? "prev" : "next"]();
        }), this.$container = t, this.state = "visible";
    }
    getSlides() {
        const t = [];
        for (const e of this.fancybox.items){
            const i = e.thumb;
            i && t.push({
                html: this.fancybox.option("Thumbs.tpl").replace(/\{\{src\}\}/gi, i),
                customClass: `has-thumb has-${e.type || "image"}`
            });
        }
        return t;
    }
    toggle() {
        "visible" === this.state ? this.hide() : "hidden" === this.state ? this.show() : this.build();
    }
    show() {
        "hidden" === this.state && (this.$container.style.display = "", this.Carousel.Panzoom.attachEvents(), this.state = "visible");
    }
    hide() {
        "visible" === this.state && (this.Carousel.Panzoom.detachEvents(), this.$container.style.display = "none", this.state = "hidden");
    }
    cleanup() {
        this.Carousel && (this.Carousel.destroy(), this.Carousel = null), this.$container && (this.$container.remove(), this.$container = null), this.state = "init";
    }
    attach() {
        this.fancybox.on(this.events);
    }
    detach() {
        this.fancybox.off(this.events), this.cleanup();
    }
}
$c996c779fad8b3f3$var$C.defaults = $c996c779fad8b3f3$var$$;
const $c996c779fad8b3f3$var$S = (t, e)=>{
    const i = new URL(t), s = new URLSearchParams(i.search);
    let o = new URLSearchParams;
    for (const [t, i] of [
        ...s,
        ...Object.entries(e)
    ])"t" === t ? o.set("start", parseInt(i)) : o.set(t, i);
    o = o.toString();
    let n = t.match(/#t=((.*)?\d+s)/);
    return n && (o += `#t=${n[1]}`), o;
}, $c996c779fad8b3f3$var$E = {
    video: {
        autoplay: !0,
        ratio: 16 / 9
    },
    youtube: {
        autohide: 1,
        fs: 1,
        rel: 0,
        hd: 1,
        wmode: "transparent",
        enablejsapi: 1,
        html5: 1
    },
    vimeo: {
        hd: 1,
        show_title: 1,
        show_byline: 1,
        show_portrait: 0,
        fullscreen: 1
    },
    html5video: {
        tpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
        format: ""
    }
};
class $c996c779fad8b3f3$var$P {
    constructor(t){
        this.fancybox = t;
        for (const t of [
            "onInit",
            "onReady",
            "onCreateSlide",
            "onRemoveSlide",
            "onSelectSlide",
            "onUnselectSlide",
            "onRefresh",
            "onMessage"
        ])this[t] = this[t].bind(this);
        this.events = {
            init: this.onInit,
            ready: this.onReady,
            "Carousel.createSlide": this.onCreateSlide,
            "Carousel.removeSlide": this.onRemoveSlide,
            "Carousel.selectSlide": this.onSelectSlide,
            "Carousel.unselectSlide": this.onUnselectSlide,
            "Carousel.refresh": this.onRefresh
        };
    }
    onInit() {
        for (const t of this.fancybox.items)this.processType(t);
    }
    processType(t) {
        if (t.html) return t.src = t.html, t.type = "html", void delete t.html;
        const i = t.src || "";
        let s = t.type || this.fancybox.options.type, o = null;
        if (!i || "string" == typeof i) {
            if (o = i.match(/(?:youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
                const e = $c996c779fad8b3f3$var$S(i, this.fancybox.option("Html.youtube")), n = encodeURIComponent(o[1]);
                t.videoId = n, t.src = `https://www.youtube-nocookie.com/embed/${n}?${e}`, t.thumb = t.thumb || `https://i.ytimg.com/vi/${n}/mqdefault.jpg`, t.vendor = "youtube", s = "video";
            } else if (o = i.match(/^.+vimeo.com\/(?:\/)?([\d]+)(.*)?/)) {
                const e = $c996c779fad8b3f3$var$S(i, this.fancybox.option("Html.vimeo")), n = encodeURIComponent(o[1]);
                t.videoId = n, t.src = `https://player.vimeo.com/video/${n}?${e}`, t.vendor = "vimeo", s = "video";
            } else (o = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `//maps.google.${o[1]}/?ll=${(o[2] ? o[2] + "&z=" + Math.floor(o[3]) + (o[4] ? o[4].replace(/^\//, "&") : "") : o[4] + "").replace(/\?/, "&")}&output=${o[4] && o[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, s = "map") : (o = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `//maps.google.${o[1]}/maps?q=${o[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, s = "map");
            s || ("#" === i.charAt(0) ? s = "inline" : (o = i.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (s = "html5video", t.format = t.format || "video/" + ("ogv" === o[1] ? "ogg" : o[1])) : i.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? s = "image" : i.match(/\.(pdf)((\?|#).*)?$/i) && (s = "pdf")), t.type = s || this.fancybox.option("defaultType", "image"), "html5video" !== s && "video" !== s || (t.video = $c996c779fad8b3f3$var$e({}, this.fancybox.option("Html.video"), t.video), t._width && t._height ? t.ratio = parseFloat(t._width) / parseFloat(t._height) : t.ratio = t.ratio || t.video.ratio || $c996c779fad8b3f3$var$E.video.ratio);
        }
    }
    onReady() {
        this.fancybox.Carousel.slides.forEach((t)=>{
            t.$el && (this.setContent(t), t.index === this.fancybox.getSlide().index && this.playVideo(t));
        });
    }
    onCreateSlide(t, e, i) {
        "ready" === this.fancybox.state && this.setContent(i);
    }
    loadInlineContent(t) {
        let e;
        if (t.src instanceof HTMLElement) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2), s = 2 === i.length && "" === i[0] ? i[1] : i[0];
            e = document.getElementById(s);
        }
        if (e) {
            if ("clone" === t.type || e.$placeHolder) {
                e = e.cloneNode(!0);
                let i = e.getAttribute("id");
                i = i ? `${i}--clone` : `clone-${this.fancybox.id}-${t.index}`, e.setAttribute("id", i);
            } else {
                const t = document.createElement("div");
                t.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(t, e), e.$placeHolder = t;
            }
            this.fancybox.setContent(t, e);
        } else this.fancybox.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    loadAjaxContent(t) {
        const e = this.fancybox, i = new XMLHttpRequest;
        e.showLoading(t), i.onreadystatechange = function() {
            i.readyState === XMLHttpRequest.DONE && "ready" === e.state && (e.hideLoading(t), 200 === i.status ? e.setContent(t, i.responseText) : e.setError(t, 404 === i.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        i.open(s ? "POST" : "GET", t.src), i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.send(s), t.xhr = i;
    }
    loadIframeContent(t) {
        const e = this.fancybox, i = document.createElement("iframe");
        if (i.className = "fancybox__iframe", i.setAttribute("id", `fancybox__iframe_${e.id}_${t.index}`), i.setAttribute("allow", "autoplay; fullscreen"), i.setAttribute("scrolling", "auto"), t.$iframe = i, "iframe" !== t.type || !1 === t.preload) return i.setAttribute("src", t.src), this.fancybox.setContent(t, i), void this.resizeIframe(t);
        e.showLoading(t);
        const s = document.createElement("div");
        s.style.visibility = "hidden", this.fancybox.setContent(t, s), s.appendChild(i), i.onerror = ()=>{
            e.setError(t, "{{IFRAME_ERROR}}");
        }, i.onload = ()=>{
            e.hideLoading(t);
            let s = !1;
            i.isReady || (i.isReady = !0, s = !0), i.src.length && (i.parentNode.style.visibility = "", this.resizeIframe(t), s && e.revealContent(t));
        }, i.setAttribute("src", t.src);
    }
    setAspectRatio(t) {
        const e = t.$content, i = t.ratio;
        if (!e) return;
        let s = t._width, o = t._height;
        if (i || s && o) {
            Object.assign(e.style, {
                width: s && o ? "100%" : "",
                height: s && o ? "100%" : "",
                maxWidth: "",
                maxHeight: ""
            });
            let t = e.offsetWidth, n = e.offsetHeight;
            if (s = s || t, o = o || n, s > t || o > n) {
                let e = Math.min(t / s, n / o);
                s *= e, o *= e;
            }
            Math.abs(s / o - i) > .01 && (i < s / o ? s = o * i : o = s / i), Object.assign(e.style, {
                width: `${s}px`,
                height: `${o}px`
            });
        }
    }
    resizeIframe(t) {
        const e = t.$iframe;
        if (!e) return;
        let i = t._width || 0, s = t._height || 0;
        i && s && (t.autoSize = !1);
        const o = e.parentNode, n = o && o.style;
        if (!1 !== t.preload && !1 !== t.autoSize && n) try {
            const t = window.getComputedStyle(o), a = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), r = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), h = e.contentWindow.document, l = h.getElementsByTagName("html")[0], c = h.body;
            n.width = "", c.style.overflow = "hidden", i = i || l.scrollWidth + a, n.width = `${i}px`, c.style.overflow = "", n.flex = "0 0 auto", n.height = `${c.scrollHeight}px`, s = l.scrollHeight + r;
        } catch (t) {}
        if (i || s) {
            const t = {
                flex: "0 1 auto"
            };
            i && (t.width = `${i}px`), s && (t.height = `${s}px`), Object.assign(n, t);
        }
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.$el && (t.$iframe && this.resizeIframe(t), t.ratio && this.setAspectRatio(t));
        });
    }
    setContent(t) {
        if (t && !t.isDom) {
            switch(t.type){
                case "html":
                    this.fancybox.setContent(t, t.src);
                    break;
                case "html5video":
                    this.fancybox.setContent(t, this.fancybox.option("Html.html5video.tpl").replace(/\{\{src\}\}/gi, t.src).replace("{{format}}", t.format || t.html5video && t.html5video.format || "").replace("{{poster}}", t.poster || t.thumb || ""));
                    break;
                case "inline":
                case "clone":
                    this.loadInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case "video":
                case "map":
                    t.preload = !1;
                case "iframe":
                    this.loadIframeContent(t);
            }
            t.ratio && this.setAspectRatio(t);
        }
    }
    onSelectSlide(t, e, i) {
        "ready" === t.state && this.playVideo(i);
    }
    playVideo(t) {
        if ("html5video" === t.type && t.video.autoplay) try {
            const e = t.$el.querySelector("video");
            if (e) {
                const t = e.play();
                void 0 !== t && t.then(()=>{}).catch((t)=>{
                    e.muted = !0, e.play();
                });
            }
        } catch (t) {}
        if ("video" !== t.type || !t.$iframe || !t.$iframe.contentWindow) return;
        const e = ()=>{
            if ("done" === t.state && t.$iframe && t.$iframe.contentWindow) {
                let e;
                if (t.$iframe.isReady) return t.video && t.video.autoplay && (e = "youtube" == t.vendor ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }), void (e && t.$iframe.contentWindow.postMessage(JSON.stringify(e), "*"));
                "youtube" === t.vendor && (e = {
                    event: "listening",
                    id: t.$iframe.getAttribute("id")
                }, t.$iframe.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(e, 250);
        };
        e();
    }
    onUnselectSlide(t, e, i) {
        if ("html5video" === i.type) {
            try {
                i.$el.querySelector("video").pause();
            } catch (t) {}
            return;
        }
        let s = !1;
        "vimeo" == i.vendor ? s = {
            method: "pause",
            value: "true"
        } : "youtube" === i.vendor && (s = {
            event: "command",
            func: "pauseVideo"
        }), s && i.$iframe && i.$iframe.contentWindow && i.$iframe.contentWindow.postMessage(JSON.stringify(s), "*"), clearTimeout(i.poller);
    }
    onRemoveSlide(t, e, i) {
        i.xhr && (i.xhr.abort(), i.xhr = null), i.$iframe && (i.$iframe.onload = i.$iframe.onerror = null, i.$iframe.src = "//about:blank", i.$iframe = null);
        const s = i.$content;
        "inline" === i.type && s && (s.classList.remove("fancybox__content"), "none" !== s.style.display && (s.style.display = "none")), i.$closeButton && (i.$closeButton.remove(), i.$closeButton = null);
        const o = s && s.$placeHolder;
        o && (o.parentNode.insertBefore(s, o), o.remove(), s.$placeHolder = null);
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of document.getElementsByClassName("fancybox__iframe"))e.contentWindow === t.source && (e.isReady = 1);
            } else "https://www.youtube-nocookie.com" === t.origin && "onReady" === e.event && (document.getElementById(e.id).isReady = 1);
        } catch (t) {}
    }
    attach() {
        this.fancybox.on(this.events), window.addEventListener("message", this.onMessage, !1);
    }
    detach() {
        this.fancybox.off(this.events), window.removeEventListener("message", this.onMessage, !1);
    }
}
$c996c779fad8b3f3$var$P.defaults = $c996c779fad8b3f3$var$E;
class $c996c779fad8b3f3$var$T {
    constructor(t){
        this.fancybox = t;
        for (const t of [
            "onReady",
            "onClosing",
            "onDone",
            "onPageChange",
            "onCreateSlide",
            "onRemoveSlide",
            "onImageStatusChange"
        ])this[t] = this[t].bind(this);
        this.events = {
            ready: this.onReady,
            closing: this.onClosing,
            done: this.onDone,
            "Carousel.change": this.onPageChange,
            "Carousel.createSlide": this.onCreateSlide,
            "Carousel.removeSlide": this.onRemoveSlide
        };
    }
    onReady() {
        this.fancybox.Carousel.slides.forEach((t)=>{
            t.$el && this.setContent(t);
        });
    }
    onDone(t, e) {
        this.handleCursor(e);
    }
    onClosing(t) {
        clearTimeout(this.clickTimer), this.clickTimer = null, t.Carousel.slides.forEach((t)=>{
            t.$image && (t.state = "destroy"), t.Panzoom && t.Panzoom.detachEvents();
        }), "closing" === this.fancybox.state && this.canZoom(t.getSlide()) && this.zoomOut();
    }
    onCreateSlide(t, e, i) {
        "ready" === this.fancybox.state && this.setContent(i);
    }
    onRemoveSlide(t, e, i) {
        i.$image && (i.$el.classList.remove(t.option("Image.canZoomInClass")), i.$image.remove(), i.$image = null), i.Panzoom && (i.Panzoom.destroy(), i.Panzoom = null), i.$el && i.$el.dataset && delete i.$el.dataset.imageFit;
    }
    setContent(t) {
        if (t.isDom || t.html || t.type && "image" !== t.type) return;
        if (t.$image) return;
        t.type = "image", t.state = "loading";
        const e = document.createElement("div");
        e.style.visibility = "hidden";
        const i = document.createElement("img");
        i.addEventListener("load", (e)=>{
            e.stopImmediatePropagation(), this.onImageStatusChange(t);
        }), i.addEventListener("error", ()=>{
            this.onImageStatusChange(t);
        }), i.src = t.src, i.alt = "", i.draggable = !1, i.classList.add("fancybox__image"), t.srcset && i.setAttribute("srcset", t.srcset), t.sizes && i.setAttribute("sizes", t.sizes), t.$image = i;
        const s = this.fancybox.option("Image.wrap");
        if (s) {
            const o = document.createElement("div");
            o.classList.add("string" == typeof s ? s : "fancybox__image-wrap"), o.appendChild(i), e.appendChild(o), t.$wrap = o;
        } else e.appendChild(i);
        t.$el.dataset.imageFit = this.fancybox.option("Image.fit"), this.fancybox.setContent(t, e), i.complete || i.error ? this.onImageStatusChange(t) : this.fancybox.showLoading(t);
    }
    onImageStatusChange(t) {
        const e = t.$image;
        e && "loading" === t.state && (e.complete && e.naturalWidth && e.naturalHeight ? (this.fancybox.hideLoading(t), "contain" === this.fancybox.option("Image.fit") && this.initSlidePanzoom(t), t.$el.addEventListener("wheel", (e)=>this.onWheel(t, e), {
            passive: !1
        }), t.$content.addEventListener("click", (e)=>this.onClick(t, e), {
            passive: !1
        }), this.revealContent(t)) : this.fancybox.setError(t, "{{IMAGE_ERROR}}"));
    }
    initSlidePanzoom(t) {
        t.Panzoom || (t.Panzoom = new $c996c779fad8b3f3$export$b704d075ddd20210(t.$el, $c996c779fad8b3f3$var$e(!0, this.fancybox.option("Image.Panzoom", {}), {
            viewport: t.$wrap,
            content: t.$image,
            width: t._width,
            height: t._height,
            wrapInner: !1,
            textSelection: !0,
            touch: this.fancybox.option("Image.touch"),
            panOnlyZoomed: !0,
            click: !1,
            wheel: !1
        })), t.Panzoom.on("startAnimation", ()=>{
            this.fancybox.trigger("Image.startAnimation", t);
        }), t.Panzoom.on("endAnimation", ()=>{
            "zoomIn" === t.state && this.fancybox.done(t), this.handleCursor(t), this.fancybox.trigger("Image.endAnimation", t);
        }), t.Panzoom.on("afterUpdate", ()=>{
            this.handleCursor(t), this.fancybox.trigger("Image.afterUpdate", t);
        }));
    }
    revealContent(t) {
        null === this.fancybox.Carousel.prevPage && t.index === this.fancybox.options.startIndex && this.canZoom(t) ? this.zoomIn() : this.fancybox.revealContent(t);
    }
    getZoomInfo(t) {
        const e = t.$thumb.getBoundingClientRect(), i = e.width, s = e.height, o = t.$content.getBoundingClientRect(), n = o.width, a = o.height, r = o.top - e.top, h = o.left - e.left;
        let l = this.fancybox.option("Image.zoomOpacity");
        return "auto" === l && (l = Math.abs(i / s - n / a) > .1), {
            top: r,
            left: h,
            scale: n && i ? i / n : 1,
            opacity: l
        };
    }
    canZoom(t) {
        const e = this.fancybox, i = e.$container;
        if (window.visualViewport && 1 !== window.visualViewport.scale) return !1;
        if (t.Panzoom && !t.Panzoom.content.width) return !1;
        if (!e.option("Image.zoom") || "contain" !== e.option("Image.fit")) return !1;
        const s = t.$thumb;
        if (!s || "loading" === t.state) return !1;
        i.classList.add("fancybox__no-click");
        const o = s.getBoundingClientRect();
        let n;
        if (this.fancybox.option("Image.ignoreCoveredThumbnail")) {
            const t = document.elementFromPoint(o.left + 1, o.top + 1) === s, e = document.elementFromPoint(o.right - 1, o.bottom - 1) === s;
            n = t && e;
        } else n = document.elementFromPoint(o.left + .5 * o.width, o.top + .5 * o.height) === s;
        return i.classList.remove("fancybox__no-click"), n;
    }
    zoomIn() {
        const t = this.fancybox, e = t.getSlide(), i = e.Panzoom, { top: s, left: o, scale: n, opacity: a } = this.getZoomInfo(e);
        t.trigger("reveal", e), i.panTo({
            x: -1 * o,
            y: -1 * s,
            scale: n,
            friction: 0,
            ignoreBounds: !0
        }), e.$content.style.visibility = "", e.state = "zoomIn", !0 === a && i.on("afterTransform", (t)=>{
            "zoomIn" !== e.state && "zoomOut" !== e.state || (t.$content.style.opacity = Math.min(1, 1 - (1 - t.content.scale) / (1 - n)));
        }), i.panTo({
            x: 0,
            y: 0,
            scale: 1,
            friction: this.fancybox.option("Image.zoomFriction")
        });
    }
    zoomOut() {
        const t = this.fancybox, e = t.getSlide(), i = e.Panzoom;
        if (!i) return;
        e.state = "zoomOut", t.state = "customClosing", e.$caption && (e.$caption.style.visibility = "hidden");
        let s = this.fancybox.option("Image.zoomFriction");
        const o = (t)=>{
            const { top: o, left: n, scale: a, opacity: r } = this.getZoomInfo(e);
            t || r || (s *= .82), i.panTo({
                x: -1 * n,
                y: -1 * o,
                scale: a,
                friction: s,
                ignoreBounds: !0
            }), s *= .98;
        };
        window.addEventListener("scroll", o), i.once("endAnimation", ()=>{
            window.removeEventListener("scroll", o), t.destroy();
        }), o();
    }
    handleCursor(t) {
        if ("image" !== t.type || !t.$el) return;
        const e = t.Panzoom, i = this.fancybox.option("Image.click", !1, t), s = this.fancybox.option("Image.touch"), o = t.$el.classList, n = this.fancybox.option("Image.canZoomInClass"), a = this.fancybox.option("Image.canZoomOutClass");
        if (o.remove(a), o.remove(n), e && "toggleZoom" === i) e && 1 === e.content.scale && e.option("maxScale") - e.content.scale > .01 ? o.add(n) : e.content.scale > 1 && !s && o.add(a);
        else "close" === i && o.add(a);
    }
    onWheel(t, e) {
        if ("ready" === this.fancybox.state && !1 !== this.fancybox.trigger("Image.wheel", e)) switch(this.fancybox.option("Image.wheel")){
            case "zoom":
                "done" === t.state && t.Panzoom && t.Panzoom.zoomWithWheel(e);
                break;
            case "close":
                this.fancybox.close();
                break;
            case "slide":
                this.fancybox[e.deltaY < 0 ? "prev" : "next"]();
        }
    }
    onClick(t, e) {
        if ("ready" !== this.fancybox.state) return;
        const i = t.Panzoom;
        if (i && (i.dragPosition.midPoint || 0 !== i.dragOffset.x || 0 !== i.dragOffset.y || 1 !== i.dragOffset.scale)) return;
        if (this.fancybox.Carousel.Panzoom.lockAxis) return !1;
        const s = (i)=>{
            switch(i){
                case "toggleZoom":
                    e.stopPropagation(), t.Panzoom && t.Panzoom.zoomWithClick(e);
                    break;
                case "close":
                    this.fancybox.close();
                    break;
                case "next":
                    e.stopPropagation(), this.fancybox.next();
            }
        }, o = this.fancybox.option("Image.click"), n = this.fancybox.option("Image.doubleClick");
        n ? this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null, s(n)) : this.clickTimer = setTimeout(()=>{
            this.clickTimer = null, s(o);
        }, 300) : s(o);
    }
    onPageChange(t, e) {
        const i = t.getSlide();
        e.slides.forEach((t)=>{
            t.Panzoom && "done" === t.state && t.index !== i.index && t.Panzoom.panTo({
                x: 0,
                y: 0,
                scale: 1,
                friction: .8
            });
        });
    }
    attach() {
        this.fancybox.on(this.events);
    }
    detach() {
        this.fancybox.off(this.events);
    }
}
$c996c779fad8b3f3$var$T.defaults = {
    canZoomInClass: "can-zoom_in",
    canZoomOutClass: "can-zoom_out",
    zoom: !0,
    zoomOpacity: "auto",
    zoomFriction: .82,
    ignoreCoveredThumbnail: !1,
    touch: !0,
    click: "toggleZoom",
    doubleClick: null,
    wheel: "zoom",
    fit: "contain",
    wrap: !1,
    Panzoom: {
        ratio: 1
    }
};
class $c996c779fad8b3f3$var$L {
    constructor(t){
        this.fancybox = t;
        for (const t of [
            "onChange",
            "onClosing"
        ])this[t] = this[t].bind(this);
        this.events = {
            initCarousel: this.onChange,
            "Carousel.change": this.onChange,
            closing: this.onClosing
        }, this.hasCreatedHistory = !1, this.origHash = "", this.timer = null;
    }
    onChange(t) {
        const e = t.Carousel;
        this.timer && clearTimeout(this.timer);
        const i = null === e.prevPage, s = t.getSlide(), o = new URL(document.URL).hash;
        let n = !1;
        if (s.slug) n = "#" + s.slug;
        else {
            const i = s.$trigger && s.$trigger.dataset, o = t.option("slug") || i && i.fancybox;
            o && o.length && "true" !== o && (n = "#" + o + (e.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
        i && (this.origHash = o !== n ? o : ""), n && o !== n && (this.timer = setTimeout(()=>{
            try {
                window.history[i ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + n), i && (this.hasCreatedHistory = !0);
            } catch (t) {}
        }, 300));
    }
    onClosing() {
        if (this.timer && clearTimeout(this.timer), !0 !== this.hasSilentClose) try {
            return void window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
        } catch (t) {}
    }
    attach(t) {
        t.on(this.events);
    }
    detach(t) {
        t.off(this.events);
    }
    static startFromUrl() {
        const t = $c996c779fad8b3f3$var$L.Fancybox;
        if (!t || t.getInstance() || !1 === t.defaults.Hash) return;
        const { hash: e, slug: i, index: s } = $c996c779fad8b3f3$var$L.getParsedURL();
        if (!i) return;
        let o = document.querySelector(`[data-slug="${e}"]`);
        if (o && o.dispatchEvent(new CustomEvent("click", {
            bubbles: !0,
            cancelable: !0
        })), t.getInstance()) return;
        const n = document.querySelectorAll(`[data-fancybox="${i}"]`);
        n.length && (null === s && 1 === n.length ? o = n[0] : s && (o = n[s - 1]), o && o.dispatchEvent(new CustomEvent("click", {
            bubbles: !0,
            cancelable: !0
        })));
    }
    static onHashChange() {
        const { slug: t, index: e } = $c996c779fad8b3f3$var$L.getParsedURL(), i = $c996c779fad8b3f3$var$L.Fancybox, s = i && i.getInstance();
        if (s && s.plugins.Hash) {
            if (t) {
                const i = s.Carousel;
                if (t === s.option("slug")) return i.slideTo(e - 1);
                for (let e of i.slides)if (e.slug && e.slug === t) return i.slideTo(e.index);
                const o = s.getSlide(), n = o.$trigger && o.$trigger.dataset;
                if (n && n.fancybox === t) return i.slideTo(e - 1);
            }
            s.plugins.Hash.hasSilentClose = !0, s.close();
        }
        $c996c779fad8b3f3$var$L.startFromUrl();
    }
    static create(t) {
        function e() {
            window.addEventListener("hashchange", $c996c779fad8b3f3$var$L.onHashChange, !1), $c996c779fad8b3f3$var$L.startFromUrl();
        }
        $c996c779fad8b3f3$var$L.Fancybox = t, $c996c779fad8b3f3$var$v && window.requestAnimationFrame(()=>{
            /complete|interactive|loaded/.test(document.readyState) ? e() : document.addEventListener("DOMContentLoaded", e);
        });
    }
    static destroy() {
        window.removeEventListener("hashchange", $c996c779fad8b3f3$var$L.onHashChange, !1);
    }
    static getParsedURL() {
        const t = window.location.hash.substr(1), e = t.split("-"), i = e.length > 1 && /^\+?\d+$/.test(e[e.length - 1]) && parseInt(e.pop(-1), 10) || null;
        return {
            hash: t,
            slug: e.join("-"),
            index: i
        };
    }
}
const $c996c779fad8b3f3$var$_ = {
    pageXOffset: 0,
    pageYOffset: 0,
    element: ()=>document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement,
    activate (t) {
        $c996c779fad8b3f3$var$_.pageXOffset = window.pageXOffset, $c996c779fad8b3f3$var$_.pageYOffset = window.pageYOffset, t.requestFullscreen ? t.requestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.webkitRequestFullscreen ? t.webkitRequestFullscreen() : t.msRequestFullscreen && t.msRequestFullscreen();
    },
    deactivate () {
        document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
    }
};
class $c996c779fad8b3f3$var$A {
    constructor(t){
        this.fancybox = t, this.active = !1, this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    isActive() {
        return this.active;
    }
    setTimer() {
        if (!this.active || this.timer) return;
        const t = this.fancybox.option("slideshow.delay", 3e3);
        this.timer = setTimeout(()=>{
            this.timer = null, this.fancybox.option("infinite") || this.fancybox.getSlide().index !== this.fancybox.Carousel.slides.length - 1 ? this.fancybox.next() : this.fancybox.jumpTo(0, {
                friction: 0
            });
        }, t);
        let e = this.$progress;
        e || (e = document.createElement("div"), e.classList.add("fancybox__progress"), this.fancybox.$carousel.parentNode.insertBefore(e, this.fancybox.$carousel), this.$progress = e, e.offsetHeight), e.style.transitionDuration = `${t}ms`, e.style.transform = "scaleX(1)";
    }
    clearTimer() {
        clearTimeout(this.timer), this.timer = null, this.$progress && (this.$progress.style.transitionDuration = "", this.$progress.style.transform = "", this.$progress.offsetHeight);
    }
    activate() {
        this.active || (this.active = !0, this.fancybox.$container.classList.add("has-slideshow"), "done" === this.fancybox.getSlide().state && this.setTimer(), document.addEventListener("visibilitychange", this.handleVisibilityChange, !1));
    }
    handleVisibilityChange() {
        this.deactivate();
    }
    deactivate() {
        this.active = !1, this.clearTimer(), this.fancybox.$container.classList.remove("has-slideshow"), document.removeEventListener("visibilitychange", this.handleVisibilityChange, !1);
    }
    toggle() {
        this.active ? this.deactivate() : this.fancybox.Carousel.slides.length > 1 && this.activate();
    }
}
const $c996c779fad8b3f3$var$z = {
    display: [
        "counter",
        "zoom",
        "slideshow",
        "fullscreen",
        "thumbs",
        "close"
    ],
    autoEnable: !0,
    items: {
        counter: {
            position: "left",
            type: "div",
            class: "fancybox__counter",
            html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
            attr: {
                tabindex: -1
            }
        },
        prev: {
            type: "button",
            class: "fancybox__button--prev",
            label: "PREV",
            html: '<svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg>',
            attr: {
                "data-fancybox-prev": ""
            }
        },
        next: {
            type: "button",
            class: "fancybox__button--next",
            label: "NEXT",
            html: '<svg viewBox="0 0 24 24"><path d="M8 4l8 8-8 8"/></svg>',
            attr: {
                "data-fancybox-next": ""
            }
        },
        fullscreen: {
            type: "button",
            class: "fancybox__button--fullscreen",
            label: "TOGGLE_FULLSCREEN",
            html: '<svg viewBox="0 0 24 24">\n                <g><path d="M3 8 V3h5"></path><path d="M21 8V3h-5"></path><path d="M8 21H3v-5"></path><path d="M16 21h5v-5"></path></g>\n                <g><path d="M7 2v5H2M17 2v5h5M2 17h5v5M22 17h-5v5"/></g>\n            </svg>',
            click: function(t) {
                t.preventDefault(), $c996c779fad8b3f3$var$_.element() ? $c996c779fad8b3f3$var$_.deactivate() : $c996c779fad8b3f3$var$_.activate(this.fancybox.$container);
            }
        },
        slideshow: {
            type: "button",
            class: "fancybox__button--slideshow",
            label: "TOGGLE_SLIDESHOW",
            html: '<svg viewBox="0 0 24 24">\n                <g><path d="M6 4v16"/><path d="M20 12L6 20"/><path d="M20 12L6 4"/></g>\n                <g><path d="M7 4v15M17 4v15"/></g>\n            </svg>',
            click: function(t) {
                t.preventDefault(), this.Slideshow.toggle();
            }
        },
        zoom: {
            type: "button",
            class: "fancybox__button--zoom",
            label: "TOGGLE_ZOOM",
            html: '<svg viewBox="0 0 24 24"><circle cx="10" cy="10" r="7"></circle><path d="M16 16 L21 21"></svg>',
            click: function(t) {
                t.preventDefault();
                const e = this.fancybox.getSlide().Panzoom;
                e && e.toggleZoom();
            }
        },
        download: {
            type: "link",
            label: "DOWNLOAD",
            class: "fancybox__button--download",
            html: '<svg viewBox="0 0 24 24"><path d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.62 2.48A2 2 0 004.56 21h14.88a2 2 0 001.94-1.51L22 17"/></svg>',
            click: function(t) {
                t.stopPropagation();
            }
        },
        thumbs: {
            type: "button",
            label: "TOGGLE_THUMBS",
            class: "fancybox__button--thumbs",
            html: '<svg viewBox="0 0 24 24"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
            click: function(t) {
                t.stopPropagation();
                const e = this.fancybox.plugins.Thumbs;
                e && e.toggle();
            }
        },
        close: {
            type: "button",
            label: "CLOSE",
            class: "fancybox__button--close",
            html: '<svg viewBox="0 0 24 24"><path d="M20 20L4 4m16 0L4 20"></path></svg>',
            attr: {
                "data-fancybox-close": "",
                tabindex: 0
            }
        }
    }
};
class $c996c779fad8b3f3$var$k {
    constructor(t){
        this.fancybox = t, this.$container = null, this.state = "init";
        for (const t of [
            "onInit",
            "onPrepare",
            "onDone",
            "onKeydown",
            "onClosing",
            "onChange",
            "onSettle",
            "onRefresh"
        ])this[t] = this[t].bind(this);
        this.events = {
            init: this.onInit,
            prepare: this.onPrepare,
            done: this.onDone,
            keydown: this.onKeydown,
            closing: this.onClosing,
            "Carousel.change": this.onChange,
            "Carousel.settle": this.onSettle,
            "Carousel.Panzoom.touchStart": ()=>this.onRefresh(),
            "Image.startAnimation": (t, e)=>this.onRefresh(e),
            "Image.afterUpdate": (t, e)=>this.onRefresh(e)
        };
    }
    onInit() {
        if (this.fancybox.option("Toolbar.autoEnable")) {
            let t = !1;
            for (const e of this.fancybox.items)if ("image" === e.type) {
                t = !0;
                break;
            }
            if (!t) return void (this.state = "disabled");
        }
        for (const e of this.fancybox.option("Toolbar.display"))if ("close" === ($c996c779fad8b3f3$var$t(e) ? e.id : e)) {
            this.fancybox.options.closeButton = !1;
            break;
        }
    }
    onPrepare() {
        const t = this.fancybox;
        if ("init" === this.state && (this.build(), this.update(), this.Slideshow = new $c996c779fad8b3f3$var$A(t), !t.Carousel.prevPage && (t.option("slideshow.autoStart") && this.Slideshow.activate(), t.option("fullscreen.autoStart") && !$c996c779fad8b3f3$var$_.element()))) try {
            $c996c779fad8b3f3$var$_.activate(t.$container);
        } catch (t) {}
    }
    onFsChange() {
        window.scrollTo($c996c779fad8b3f3$var$_.pageXOffset, $c996c779fad8b3f3$var$_.pageYOffset);
    }
    onSettle() {
        const t = this.fancybox, e = this.Slideshow;
        e && e.isActive() && (t.getSlide().index !== t.Carousel.slides.length - 1 || t.option("infinite") ? "done" === t.getSlide().state && e.setTimer() : e.deactivate());
    }
    onChange() {
        this.update(), this.Slideshow && this.Slideshow.isActive() && this.Slideshow.clearTimer();
    }
    onDone(t, e) {
        const i = this.Slideshow;
        e.index === t.getSlide().index && (this.update(), i && i.isActive() && (t.option("infinite") || e.index !== t.Carousel.slides.length - 1 ? i.setTimer() : i.deactivate()));
    }
    onRefresh(t) {
        t && t.index !== this.fancybox.getSlide().index || (this.update(), !this.Slideshow || !this.Slideshow.isActive() || t && "done" !== t.state || this.Slideshow.deactivate());
    }
    onKeydown(t, e, i) {
        " " === e && this.Slideshow && (this.Slideshow.toggle(), i.preventDefault());
    }
    onClosing() {
        this.Slideshow && this.Slideshow.deactivate(), document.removeEventListener("fullscreenchange", this.onFsChange);
    }
    createElement(t) {
        let e;
        "div" === t.type ? e = document.createElement("div") : (e = document.createElement("link" === t.type ? "a" : "button"), e.classList.add("carousel__button")), e.innerHTML = t.html, e.setAttribute("tabindex", t.tabindex || 0), t.class && e.classList.add(...t.class.split(" "));
        for(const i in t.attr)e.setAttribute(i, t.attr[i]);
        t.label && e.setAttribute("title", this.fancybox.localize(`{{${t.label}}}`)), t.click && e.addEventListener("click", t.click.bind(this)), "prev" === t.id && e.setAttribute("data-fancybox-prev", ""), "next" === t.id && e.setAttribute("data-fancybox-next", "");
        const i = e.querySelector("svg");
        return i && (i.setAttribute("role", "img"), i.setAttribute("tabindex", "-1"), i.setAttribute("xmlns", "http://www.w3.org/2000/svg")), e;
    }
    build() {
        this.cleanup();
        const i = this.fancybox.option("Toolbar.items"), s = [
            {
                position: "left",
                items: []
            },
            {
                position: "center",
                items: []
            },
            {
                position: "right",
                items: []
            }
        ], o = this.fancybox.plugins.Thumbs;
        for (const n of this.fancybox.option("Toolbar.display")){
            let a, r;
            if ($c996c779fad8b3f3$var$t(n) ? (a = n.id, r = $c996c779fad8b3f3$var$e({}, i[a], n)) : (a = n, r = i[a]), [
                "counter",
                "next",
                "prev",
                "slideshow"
            ].includes(a) && this.fancybox.items.length < 2) continue;
            if ("fullscreen" === a) {
                if (!document.fullscreenEnabled || window.fullScreen) continue;
                document.addEventListener("fullscreenchange", this.onFsChange);
            }
            if ("thumbs" === a && (!o || "disabled" === o.state)) continue;
            if (!r) continue;
            let h = r.position || "right", l = s.find((t)=>t.position === h);
            l && l.items.push(r);
        }
        const n = document.createElement("div");
        n.classList.add("fancybox__toolbar");
        for (const t of s)if (t.items.length) {
            const e = document.createElement("div");
            e.classList.add("fancybox__toolbar__items"), e.classList.add(`fancybox__toolbar__items--${t.position}`);
            for (const i of t.items)e.appendChild(this.createElement(i));
            n.appendChild(e);
        }
        this.fancybox.$carousel.parentNode.insertBefore(n, this.fancybox.$carousel), this.$container = n;
    }
    update() {
        const t = this.fancybox.getSlide(), e = t.index, i = this.fancybox.items.length, s = t.downloadSrc || ("image" !== t.type || t.error ? null : t.src);
        for (const t of this.fancybox.$container.querySelectorAll("a.fancybox__button--download"))s ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex"), t.setAttribute("href", s), t.setAttribute("download", s), t.setAttribute("target", "_blank")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", -1), t.removeAttribute("href"), t.removeAttribute("download"));
        const o = t.Panzoom, n = o && o.option("maxScale") > o.option("baseScale");
        for (const t of this.fancybox.$container.querySelectorAll(".fancybox__button--zoom"))n ? t.removeAttribute("disabled") : t.setAttribute("disabled", "");
        for (const e of this.fancybox.$container.querySelectorAll("[data-fancybox-index]"))e.innerHTML = t.index + 1;
        for (const t of this.fancybox.$container.querySelectorAll("[data-fancybox-count]"))t.innerHTML = i;
        if (!this.fancybox.option("infinite")) {
            for (const t of this.fancybox.$container.querySelectorAll("[data-fancybox-prev]"))0 === e ? t.setAttribute("disabled", "") : t.removeAttribute("disabled");
            for (const t of this.fancybox.$container.querySelectorAll("[data-fancybox-next]"))e === i - 1 ? t.setAttribute("disabled", "") : t.removeAttribute("disabled");
        }
    }
    cleanup() {
        this.Slideshow && this.Slideshow.isActive() && this.Slideshow.clearTimer(), this.$container && this.$container.remove(), this.$container = null;
    }
    attach() {
        this.fancybox.on(this.events);
    }
    detach() {
        this.fancybox.off(this.events), this.cleanup();
    }
}
$c996c779fad8b3f3$var$k.defaults = $c996c779fad8b3f3$var$z;
const $c996c779fad8b3f3$var$O = {
    ScrollLock: class {
        constructor(t){
            this.fancybox = t, this.viewport = null, this.pendingUpdate = null;
            for (const t of [
                "onReady",
                "onResize",
                "onTouchstart",
                "onTouchmove"
            ])this[t] = this[t].bind(this);
        }
        onReady() {
            const t = window.visualViewport;
            t && (this.viewport = t, this.startY = 0, t.addEventListener("resize", this.onResize), this.updateViewport()), window.addEventListener("touchstart", this.onTouchstart, {
                passive: !1
            }), window.addEventListener("touchmove", this.onTouchmove, {
                passive: !1
            }), window.addEventListener("wheel", this.onWheel, {
                passive: !1
            });
        }
        onResize() {
            this.updateViewport();
        }
        updateViewport() {
            const t = this.fancybox, e = this.viewport, i = e.scale || 1, s = t.$container;
            if (!s) return;
            let o = "", n = "", a = "";
            i - 1 > .1 && (o = e.width * i + "px", n = e.height * i + "px", a = `translate3d(${e.offsetLeft}px, ${e.offsetTop}px, 0) scale(${1 / i})`), s.style.width = o, s.style.height = n, s.style.transform = a;
        }
        onTouchstart(t) {
            this.startY = t.touches ? t.touches[0].screenY : t.screenY;
        }
        onTouchmove(t) {
            const e = this.startY, i = window.innerWidth / window.document.documentElement.clientWidth;
            if (!t.cancelable) return;
            if (t.touches.length > 1 || 1 !== i) return;
            const o = $c996c779fad8b3f3$var$s(t.composedPath()[0]);
            if (!o) return void t.preventDefault();
            const n = window.getComputedStyle(o), a = parseInt(n.getPropertyValue("height"), 10), r = t.touches ? t.touches[0].screenY : t.screenY, h = e <= r && 0 === o.scrollTop, l = e >= r && o.scrollHeight - o.scrollTop === a;
            (h || l) && t.preventDefault();
        }
        onWheel(t) {
            $c996c779fad8b3f3$var$s(t.composedPath()[0]) || t.preventDefault();
        }
        cleanup() {
            this.pendingUpdate && (cancelAnimationFrame(this.pendingUpdate), this.pendingUpdate = null);
            const t = this.viewport;
            t && (t.removeEventListener("resize", this.onResize), this.viewport = null), window.removeEventListener("touchstart", this.onTouchstart, !1), window.removeEventListener("touchmove", this.onTouchmove, !1), window.removeEventListener("wheel", this.onWheel, {
                passive: !1
            });
        }
        attach() {
            this.fancybox.on("initLayout", this.onReady);
        }
        detach() {
            this.fancybox.off("initLayout", this.onReady), this.cleanup();
        }
    },
    Thumbs: $c996c779fad8b3f3$var$C,
    Html: $c996c779fad8b3f3$var$P,
    Toolbar: $c996c779fad8b3f3$var$k,
    Image: $c996c779fad8b3f3$var$T,
    Hash: $c996c779fad8b3f3$var$L
};
const $c996c779fad8b3f3$var$M = {
    startIndex: 0,
    preload: 1,
    infinite: !0,
    showClass: "fancybox-zoomInUp",
    hideClass: "fancybox-fadeOut",
    animated: !0,
    hideScrollbar: !0,
    parentEl: null,
    mainClass: null,
    autoFocus: !0,
    trapFocus: !0,
    placeFocusBack: !0,
    click: "close",
    closeButton: "inside",
    dragToClose: !0,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "next",
        ArrowDown: "prev",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    template: {
        closeButton: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg>',
        spinner: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="25 25 50 50" tabindex="-1"><circle cx="50" cy="50" r="20"/></svg>',
        main: null
    },
    l10n: {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }
}, $c996c779fad8b3f3$var$I = new Map;
let $c996c779fad8b3f3$var$F = 0;
class $c996c779fad8b3f3$export$cb45b08d97cdc4fd extends $c996c779fad8b3f3$var$l {
    constructor(t, i = {}){
        t = t.map((t)=>(t.width && (t._width = t.width), t.height && (t._height = t.height), t)), super($c996c779fad8b3f3$var$e(!0, {}, $c996c779fad8b3f3$var$M, i)), this.bindHandlers(), this.state = "init", this.setItems(t), this.attachPlugins($c996c779fad8b3f3$export$cb45b08d97cdc4fd.Plugins), this.trigger("init"), !0 === this.option("hideScrollbar") && this.hideScrollbar(), this.initLayout(), this.initCarousel(), this.attachEvents(), $c996c779fad8b3f3$var$I.set(this.id, this), this.trigger("prepare"), this.state = "ready", this.trigger("ready"), this.$container.setAttribute("aria-hidden", "false"), this.option("trapFocus") && this.focus();
    }
    option(t, ...e) {
        const i = this.getSlide();
        let s = i ? i[t] : void 0;
        return void 0 !== s ? ("function" == typeof s && (s = s.call(this, this, ...e)), s) : super.option(t, ...e);
    }
    bindHandlers() {
        for (const t of [
            "onMousedown",
            "onKeydown",
            "onClick",
            "onFocus",
            "onCreateSlide",
            "onSettle",
            "onTouchMove",
            "onTouchEnd",
            "onTransform"
        ])this[t] = this[t].bind(this);
    }
    attachEvents() {
        document.addEventListener("mousedown", this.onMousedown), document.addEventListener("keydown", this.onKeydown, !0), this.option("trapFocus") && document.addEventListener("focus", this.onFocus, !0), this.$container.addEventListener("click", this.onClick);
    }
    detachEvents() {
        document.removeEventListener("mousedown", this.onMousedown), document.removeEventListener("keydown", this.onKeydown, !0), document.removeEventListener("focus", this.onFocus, !0), this.$container.removeEventListener("click", this.onClick);
    }
    initLayout() {
        this.$root = this.option("parentEl") || document.body;
        let t = this.option("template.main");
        t && (this.$root.insertAdjacentHTML("beforeend", this.localize(t)), this.$container = this.$root.querySelector(".fancybox__container")), this.$container || (this.$container = document.createElement("div"), this.$root.appendChild(this.$container)), this.$container.onscroll = ()=>(this.$container.scrollLeft = 0, !1), Object.entries({
            class: "fancybox__container",
            role: "dialog",
            tabIndex: "-1",
            "aria-modal": "true",
            "aria-hidden": "true",
            "aria-label": this.localize("{{MODAL}}")
        }).forEach((t)=>this.$container.setAttribute(...t)), this.option("animated") && this.$container.classList.add("is-animated"), this.$backdrop = this.$container.querySelector(".fancybox__backdrop"), this.$backdrop || (this.$backdrop = document.createElement("div"), this.$backdrop.classList.add("fancybox__backdrop"), this.$container.appendChild(this.$backdrop)), this.$carousel = this.$container.querySelector(".fancybox__carousel"), this.$carousel || (this.$carousel = document.createElement("div"), this.$carousel.classList.add("fancybox__carousel"), this.$container.appendChild(this.$carousel)), this.$container.Fancybox = this, this.id = this.$container.getAttribute("id"), this.id || (this.id = this.options.id || ++$c996c779fad8b3f3$var$F, this.$container.setAttribute("id", "fancybox-" + this.id));
        const e = this.option("mainClass");
        return e && this.$container.classList.add(...e.split(" ")), document.documentElement.classList.add("with-fancybox"), this.trigger("initLayout"), this;
    }
    setItems(t) {
        const e = [];
        for (const i of t){
            const t = i.$trigger;
            if (t) {
                const e = t.dataset || {};
                i.src = e.src || t.getAttribute("href") || i.src, i.type = e.type || i.type, !i.src && t instanceof HTMLImageElement && (i.src = t.currentSrc || i.$trigger.src);
            }
            let s = i.$thumb;
            if (!s) {
                let t = i.$trigger && i.$trigger.origTarget;
                t && (s = t instanceof HTMLImageElement ? t : t.querySelector("img:not([aria-hidden])")), !s && i.$trigger && (s = i.$trigger instanceof HTMLImageElement ? i.$trigger : i.$trigger.querySelector("img:not([aria-hidden])"));
            }
            i.$thumb = s || null;
            let o = i.thumb;
            !o && s && (o = s.currentSrc || s.src, !o && s.dataset && (o = s.dataset.lazySrc || s.dataset.src)), o || "image" !== i.type || (o = i.src), i.thumb = o || null, i.caption = i.caption || "", e.push(i);
        }
        this.items = e;
    }
    initCarousel() {
        return this.Carousel = new $c996c779fad8b3f3$export$144901db2ea8e967(this.$carousel, $c996c779fad8b3f3$var$e(!0, {}, {
            prefix: "",
            classNames: {
                viewport: "fancybox__viewport",
                track: "fancybox__track",
                slide: "fancybox__slide"
            },
            textSelection: !0,
            preload: this.option("preload"),
            friction: .88,
            slides: this.items,
            initialPage: this.options.startIndex,
            slidesPerPage: 1,
            infiniteX: this.option("infinite"),
            infiniteY: !0,
            l10n: this.option("l10n"),
            Dots: !1,
            Navigation: {
                classNames: {
                    main: "fancybox__nav",
                    button: "carousel__button",
                    next: "is-next",
                    prev: "is-prev"
                }
            },
            Panzoom: {
                textSelection: !0,
                panOnlyZoomed: ()=>this.Carousel && this.Carousel.pages && this.Carousel.pages.length < 2 && !this.option("dragToClose"),
                lockAxis: ()=>{
                    if (this.Carousel) {
                        let t = "x";
                        return this.option("dragToClose") && (t += "y"), t;
                    }
                }
            },
            on: {
                "*": (t, ...e)=>this.trigger(`Carousel.${t}`, ...e),
                init: (t)=>this.Carousel = t,
                createSlide: this.onCreateSlide,
                settle: this.onSettle
            }
        }, this.option("Carousel"))), this.option("dragToClose") && this.Carousel.Panzoom.on({
            touchMove: this.onTouchMove,
            afterTransform: this.onTransform,
            touchEnd: this.onTouchEnd
        }), this.trigger("initCarousel"), this;
    }
    onCreateSlide(t, e) {
        let i = e.caption || "";
        if ("function" == typeof this.options.caption && (i = this.options.caption.call(this, this, this.Carousel, e)), "string" == typeof i && i.length) {
            const t = document.createElement("div"), s = `fancybox__caption_${this.id}_${e.index}`;
            t.className = "fancybox__caption", t.innerHTML = i, t.setAttribute("id", s), e.$caption = e.$el.appendChild(t), e.$el.classList.add("has-caption"), e.$el.setAttribute("aria-labelledby", s);
        }
    }
    onSettle() {
        this.option("autoFocus") && this.focus();
    }
    onFocus(t) {
        this.isTopmost() && this.focus(t);
    }
    onClick(t) {
        if (t.defaultPrevented) return;
        let e = t.composedPath()[0];
        if (e.matches("[data-fancybox-close]")) return t.preventDefault(), void $c996c779fad8b3f3$export$cb45b08d97cdc4fd.close(!1, t);
        if (e.matches("[data-fancybox-next]")) return t.preventDefault(), void $c996c779fad8b3f3$export$cb45b08d97cdc4fd.next();
        if (e.matches("[data-fancybox-prev]")) return t.preventDefault(), void $c996c779fad8b3f3$export$cb45b08d97cdc4fd.prev();
        const i = document.activeElement;
        if (i) {
            if (i.closest("[contenteditable]")) return;
            e.matches($c996c779fad8b3f3$var$x) || i.blur();
        }
        if (e.closest(".fancybox__content")) return;
        if (getSelection().toString().length) return;
        if (!1 === this.trigger("click", t)) return;
        switch(this.option("click")){
            case "close":
                this.close();
                break;
            case "next":
                this.next();
        }
    }
    onTouchMove() {
        const t = this.getSlide().Panzoom;
        return !t || 1 === t.content.scale;
    }
    onTouchEnd(t) {
        const e = t.dragOffset.y;
        Math.abs(e) >= 150 || Math.abs(e) >= 35 && t.dragOffset.time < 350 ? (this.option("hideClass") && (this.getSlide().hideClass = "fancybox-throwOut" + (t.content.y < 0 ? "Up" : "Down")), this.close()) : "y" === t.lockAxis && t.panTo({
            y: 0
        });
    }
    onTransform(t) {
        if (this.$backdrop) {
            const e = Math.abs(t.content.y), i = e < 1 ? "" : Math.max(.33, Math.min(1, 1 - e / t.content.fitHeight * 1.5));
            this.$container.style.setProperty("--fancybox-ts", i ? "0s" : ""), this.$container.style.setProperty("--fancybox-opacity", i);
        }
    }
    onMousedown() {
        "ready" === this.state && document.body.classList.add("is-using-mouse");
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        document.body.classList.remove("is-using-mouse");
        const e = t.key, i = this.option("keyboard");
        if (!i || t.ctrlKey || t.altKey || t.shiftKey) return;
        const s = t.composedPath()[0], o = document.activeElement && document.activeElement.classList, n = o && o.contains("carousel__button");
        if ("Escape" !== e && !n) {
            if (t.target.isContentEditable || -1 !== [
                "BUTTON",
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(s.nodeName)) return;
        }
        if (!1 === this.trigger("keydown", e, t)) return;
        const a = i[e];
        "function" == typeof this[a] && this[a]();
    }
    getSlide() {
        const t = this.Carousel;
        if (!t) return null;
        const e = null === t.page ? t.option("initialPage") : t.page, i = t.pages || [];
        return i.length && i[e] ? i[e].slides[0] : null;
    }
    focus(t) {
        if ($c996c779fad8b3f3$export$cb45b08d97cdc4fd.ignoreFocusChange) return;
        if ([
            "init",
            "closing",
            "customClosing",
            "destroy"
        ].indexOf(this.state) > -1) return;
        const e = this.$container, i = this.getSlide(), s = "done" === i.state ? i.$el : null;
        if (s && s.contains(document.activeElement)) return;
        t && t.preventDefault(), $c996c779fad8b3f3$export$cb45b08d97cdc4fd.ignoreFocusChange = !0;
        const o = Array.from(e.querySelectorAll($c996c779fad8b3f3$var$x));
        let n, a = [];
        for (let t of o){
            const e = t.offsetParent, i = s && s.contains(t), o = !this.Carousel.$viewport.contains(t);
            e && (i || o) ? (a.push(t), void 0 !== t.dataset.origTabindex && (t.tabIndex = t.dataset.origTabindex, t.removeAttribute("data-orig-tabindex")), (t.hasAttribute("autoFocus") || !n && i && !t.classList.contains("carousel__button")) && (n = t)) : (t.dataset.origTabindex = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") : t.dataset.origTabindex, t.tabIndex = -1);
        }
        t ? a.indexOf(t.target) > -1 ? this.lastFocus = t.target : this.lastFocus === e ? $c996c779fad8b3f3$var$w(a[a.length - 1]) : $c996c779fad8b3f3$var$w(e) : this.option("autoFocus") && n ? $c996c779fad8b3f3$var$w(n) : a.indexOf(document.activeElement) < 0 && $c996c779fad8b3f3$var$w(e), this.lastFocus = document.activeElement, $c996c779fad8b3f3$export$cb45b08d97cdc4fd.ignoreFocusChange = !1;
    }
    hideScrollbar() {
        if (!$c996c779fad8b3f3$var$v) return;
        const t = window.innerWidth - document.documentElement.getBoundingClientRect().width, e = "fancybox-style-noscroll";
        let i = document.getElementById(e);
        i || t > 0 && (i = document.createElement("style"), i.id = e, i.type = "text/css", i.innerHTML = `.compensate-for-scrollbar {padding-right: ${t}px;}`, document.getElementsByTagName("head")[0].appendChild(i), document.body.classList.add("compensate-for-scrollbar"));
    }
    revealScrollbar() {
        document.body.classList.remove("compensate-for-scrollbar");
        const t = document.getElementById("fancybox-style-noscroll");
        t && t.remove();
    }
    clearContent(t) {
        this.Carousel.trigger("removeSlide", t), t.$content && (t.$content.remove(), t.$content = null), t.$closeButton && (t.$closeButton.remove(), t.$closeButton = null), t._className && t.$el.classList.remove(t._className);
    }
    setContent(t, e, i = {}) {
        let s;
        const o = t.$el;
        if (e instanceof HTMLElement) [
            "img",
            "iframe",
            "video",
            "audio"
        ].indexOf(e.nodeName.toLowerCase()) > -1 ? (s = document.createElement("div"), s.appendChild(e)) : s = e;
        else {
            const t = document.createRange().createContextualFragment(e);
            s = document.createElement("div"), s.appendChild(t);
        }
        if (t.filter && !t.error && (s = s.querySelector(t.filter)), s instanceof Element) return t._className = `has-${i.suffix || t.type || "unknown"}`, o.classList.add(t._className), s.classList.add("fancybox__content"), "none" !== s.style.display && "none" !== getComputedStyle(s).getPropertyValue("display") || (s.style.display = t.display || this.option("defaultDisplay") || "flex"), t.id && s.setAttribute("id", t.id), t.$content = s, o.prepend(s), this.manageCloseButton(t), "loading" !== t.state && this.revealContent(t), s;
        this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    manageCloseButton(t) {
        const e = void 0 === t.closeButton ? this.option("closeButton") : t.closeButton;
        if (!e || "top" === e && this.$closeButton) return;
        const i = document.createElement("button");
        i.classList.add("carousel__button", "is-close"), i.setAttribute("title", this.options.l10n.CLOSE), i.innerHTML = this.option("template.closeButton"), i.addEventListener("click", (t)=>this.close(t)), "inside" === e ? (t.$closeButton && t.$closeButton.remove(), t.$closeButton = t.$content.appendChild(i)) : this.$closeButton = this.$container.insertBefore(i, this.$container.firstChild);
    }
    revealContent(t) {
        this.trigger("reveal", t), t.$content.style.visibility = "";
        let e = !1;
        t.error || "loading" === t.state || null !== this.Carousel.prevPage || t.index !== this.options.startIndex || (e = void 0 === t.showClass ? this.option("showClass") : t.showClass), e ? (t.state = "animating", this.animateCSS(t.$content, e, ()=>{
            this.done(t);
        })) : this.done(t);
    }
    animateCSS(t, e, i) {
        if (t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !0,
            cancelable: !0
        })), !t || !e) return void ("function" == typeof i && i());
        const s = function(o) {
            o.currentTarget === this && (t.removeEventListener("animationend", s), i && i(), t.classList.remove(e));
        };
        t.addEventListener("animationend", s), t.classList.add(e);
    }
    done(t) {
        t.state = "done", this.trigger("done", t);
        const e = this.getSlide();
        e && t.index === e.index && this.option("autoFocus") && this.focus();
    }
    setError(t, e) {
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const i = document.createElement("div");
        i.classList.add("fancybox-error"), i.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, i, {
            suffix: "error"
        });
    }
    showLoading(t) {
        t.state = "loading", t.$el.classList.add("is-loading");
        let e = t.$el.querySelector(".fancybox__spinner");
        e || (e = document.createElement("div"), e.classList.add("fancybox__spinner"), e.innerHTML = this.option("template.spinner"), e.addEventListener("click", ()=>{
            this.Carousel.Panzoom.velocity || this.close();
        }), t.$el.prepend(e));
    }
    hideLoading(t) {
        const e = t.$el && t.$el.querySelector(".fancybox__spinner");
        e && (e.remove(), t.$el.classList.remove("is-loading")), "loading" === t.state && (this.trigger("load", t), t.state = "ready");
    }
    next() {
        const t = this.Carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.Carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.Carousel && this.Carousel.slideTo(...t);
    }
    isClosing() {
        return [
            "closing",
            "customClosing",
            "destroy"
        ].includes(this.state);
    }
    isTopmost() {
        return $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance().id == this.id;
    }
    close(t) {
        if (t && t.preventDefault(), this.isClosing()) return;
        if (!1 === this.trigger("shouldClose", t)) return;
        if (this.state = "closing", this.Carousel.Panzoom.destroy(), this.detachEvents(), this.trigger("closing", t), "destroy" === this.state) return;
        this.$container.setAttribute("aria-hidden", "true"), this.$container.classList.add("is-closing");
        const e = this.getSlide();
        if (this.Carousel.slides.forEach((t)=>{
            t.$content && t.index !== e.index && this.Carousel.trigger("removeSlide", t);
        }), "closing" === this.state) {
            const t = void 0 === e.hideClass ? this.option("hideClass") : e.hideClass;
            this.animateCSS(e.$content, t, ()=>{
                this.destroy();
            }, !0);
        }
    }
    destroy() {
        if ("destroy" === this.state) return;
        this.state = "destroy", this.trigger("destroy");
        const t = this.option("placeFocusBack") ? this.option("triggerTarget", this.getSlide().$trigger) : null;
        this.Carousel.destroy(), this.detachPlugins(), this.Carousel = null, this.options = {}, this.events = {}, this.$container.remove(), this.$container = this.$backdrop = this.$carousel = null, t && $c996c779fad8b3f3$var$w(t), $c996c779fad8b3f3$var$I.delete(this.id);
        const e = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance();
        e ? e.focus() : (document.documentElement.classList.remove("with-fancybox"), document.body.classList.remove("is-using-mouse"), this.revealScrollbar());
    }
    static show(t, e = {}) {
        return new $c996c779fad8b3f3$export$cb45b08d97cdc4fd(t, e);
    }
    static fromEvent(t, e = {}) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        const i = t.composedPath()[0];
        let s, o, n, a = i;
        if ((a.matches("[data-fancybox-trigger]") || (a = a.closest("[data-fancybox-trigger]"))) && (e.triggerTarget = a, s = a && a.dataset && a.dataset.fancyboxTrigger), s) {
            const t = document.querySelectorAll(`[data-fancybox="${s}"]`), e = parseInt(a.dataset.fancyboxIndex, 10) || 0;
            a = t.length ? t[e] : a;
        }
        Array.from($c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers.keys()).reverse().some((e)=>{
            n = a || i;
            let s = !1;
            try {
                n instanceof Element && ("string" == typeof e || e instanceof String) && (s = n.matches(e) || (n = n.closest(e)));
            } catch (t) {}
            return !!s && (t.preventDefault(), o = e, !0);
        });
        let r = !1;
        if (o) {
            e.event = t, e.target = n, n.origTarget = i, r = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.fromOpener(o, e);
            const s = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance();
            s && "ready" === s.state && t.detail && document.body.classList.add("is-using-mouse");
        }
        return r;
    }
    static fromOpener(t, i = {}) {
        let s = [], o = i.startIndex || 0, n = i.target || null;
        const a = void 0 !== (i = $c996c779fad8b3f3$var$e({}, i, $c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers.get(t))).groupAll && i.groupAll, r = void 0 === i.groupAttr ? "data-fancybox" : i.groupAttr, h = r && n ? n.getAttribute(`${r}`) : "";
        if (!n || h || a) {
            const e = i.root || (n ? n.getRootNode() : document.body);
            s = [].slice.call(e.querySelectorAll(t));
        }
        if (n && !a && (s = h ? s.filter((t)=>t.getAttribute(`${r}`) === h) : [
            n
        ]), !s.length) return !1;
        const l = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance();
        return !(l && s.indexOf(l.options.$trigger) > -1) && (o = n ? s.indexOf(n) : o, s = s.map(function(t) {
            const e = [
                "false",
                "0",
                "no",
                "null",
                "undefined"
            ], i = [
                "true",
                "1",
                "yes"
            ], s = Object.assign({}, t.dataset), o = {};
            for (let [t, n] of Object.entries(s))if ("fancybox" !== t) {
                if ("width" === t || "height" === t) o[`_${t}`] = n;
                else if ("string" == typeof n || n instanceof String) {
                    if (e.indexOf(n) > -1) o[t] = !1;
                    else if (i.indexOf(o[t]) > -1) o[t] = !0;
                    else try {
                        o[t] = JSON.parse(n);
                    } catch (e) {
                        o[t] = n;
                    }
                } else o[t] = n;
            }
            return t instanceof Element && (o.$trigger = t), o;
        }), new $c996c779fad8b3f3$export$cb45b08d97cdc4fd(s, $c996c779fad8b3f3$var$e({}, i, {
            startIndex: o,
            $trigger: n
        })));
    }
    static bind(t, e = {}) {
        function i() {
            document.body.addEventListener("click", $c996c779fad8b3f3$export$cb45b08d97cdc4fd.fromEvent, !1);
        }
        $c996c779fad8b3f3$var$v && ($c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers.size || (/complete|interactive|loaded/.test(document.readyState) ? i() : document.addEventListener("DOMContentLoaded", i)), $c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers.set(t, e));
    }
    static unbind(t) {
        $c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers.delete(t), $c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers.size || $c996c779fad8b3f3$export$cb45b08d97cdc4fd.destroy();
    }
    static destroy() {
        let t;
        for(; t = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        $c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers = new Map, document.body.removeEventListener("click", $c996c779fad8b3f3$export$cb45b08d97cdc4fd.fromEvent, !1);
    }
    static getInstance(t) {
        if (t) return $c996c779fad8b3f3$var$I.get(t);
        return Array.from($c996c779fad8b3f3$var$I.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static close(t = !0, e) {
        if (t) for (const t of $c996c779fad8b3f3$var$I.values())t.close(e);
        else {
            const t = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(e);
        }
    }
    static next() {
        const t = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $c996c779fad8b3f3$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
}
$c996c779fad8b3f3$export$cb45b08d97cdc4fd.version = "4.0.31", $c996c779fad8b3f3$export$cb45b08d97cdc4fd.defaults = $c996c779fad8b3f3$var$M, $c996c779fad8b3f3$export$cb45b08d97cdc4fd.openers = new Map, $c996c779fad8b3f3$export$cb45b08d97cdc4fd.Plugins = $c996c779fad8b3f3$var$O, $c996c779fad8b3f3$export$cb45b08d97cdc4fd.bind("[data-fancybox]");
for (const [t, e] of Object.entries($c996c779fad8b3f3$export$cb45b08d97cdc4fd.Plugins || {}))"function" == typeof e.create && e.create($c996c779fad8b3f3$export$cb45b08d97cdc4fd);


// packages/alpinejs/src/scheduler.js
var $095eca2286a8ad72$var$flushPending = false;
var $095eca2286a8ad72$var$flushing = false;
var $095eca2286a8ad72$var$queue = [];
var $095eca2286a8ad72$var$lastFlushedIndex = -1;
var $095eca2286a8ad72$var$transactionActive = false;
function $095eca2286a8ad72$var$scheduler(callback) {
    $095eca2286a8ad72$var$queueJob(callback);
}
function $095eca2286a8ad72$var$startTransaction() {
    $095eca2286a8ad72$var$transactionActive = true;
}
function $095eca2286a8ad72$var$commitTransaction() {
    $095eca2286a8ad72$var$transactionActive = false;
    $095eca2286a8ad72$var$queueFlush();
}
function $095eca2286a8ad72$var$queueJob(job) {
    if (!$095eca2286a8ad72$var$queue.includes(job)) $095eca2286a8ad72$var$queue.push(job);
    $095eca2286a8ad72$var$queueFlush();
}
function $095eca2286a8ad72$var$dequeueJob(job) {
    let index = $095eca2286a8ad72$var$queue.indexOf(job);
    if (index !== -1 && index > $095eca2286a8ad72$var$lastFlushedIndex) $095eca2286a8ad72$var$queue.splice(index, 1);
}
function $095eca2286a8ad72$var$queueFlush() {
    if (!$095eca2286a8ad72$var$flushing && !$095eca2286a8ad72$var$flushPending) {
        if ($095eca2286a8ad72$var$transactionActive) return;
        $095eca2286a8ad72$var$flushPending = true;
        queueMicrotask($095eca2286a8ad72$var$flushJobs);
    }
}
function $095eca2286a8ad72$var$flushJobs() {
    $095eca2286a8ad72$var$flushPending = false;
    $095eca2286a8ad72$var$flushing = true;
    for(let i = 0; i < $095eca2286a8ad72$var$queue.length; i++){
        $095eca2286a8ad72$var$queue[i]();
        $095eca2286a8ad72$var$lastFlushedIndex = i;
    }
    $095eca2286a8ad72$var$queue.length = 0;
    $095eca2286a8ad72$var$lastFlushedIndex = -1;
    $095eca2286a8ad72$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $095eca2286a8ad72$var$reactive;
var $095eca2286a8ad72$var$effect;
var $095eca2286a8ad72$var$release;
var $095eca2286a8ad72$var$raw;
var $095eca2286a8ad72$var$shouldSchedule = true;
function $095eca2286a8ad72$var$disableEffectScheduling(callback) {
    $095eca2286a8ad72$var$shouldSchedule = false;
    callback();
    $095eca2286a8ad72$var$shouldSchedule = true;
}
function $095eca2286a8ad72$var$setReactivityEngine(engine) {
    $095eca2286a8ad72$var$reactive = engine.reactive;
    $095eca2286a8ad72$var$release = engine.release;
    $095eca2286a8ad72$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($095eca2286a8ad72$var$shouldSchedule) $095eca2286a8ad72$var$scheduler(task);
                else task();
            }
        });
    $095eca2286a8ad72$var$raw = engine.raw;
}
function $095eca2286a8ad72$var$overrideEffect(override) {
    $095eca2286a8ad72$var$effect = override;
}
function $095eca2286a8ad72$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $095eca2286a8ad72$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $095eca2286a8ad72$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $095eca2286a8ad72$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $095eca2286a8ad72$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>$095eca2286a8ad72$var$release(effectReference);
}
async function $095eca2286a8ad72$var$transaction(callback) {
    $095eca2286a8ad72$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $095eca2286a8ad72$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $095eca2286a8ad72$var$onAttributeAddeds = [];
var $095eca2286a8ad72$var$onElRemoveds = [];
var $095eca2286a8ad72$var$onElAddeds = [];
function $095eca2286a8ad72$var$onElAdded(callback) {
    $095eca2286a8ad72$var$onElAddeds.push(callback);
}
function $095eca2286a8ad72$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $095eca2286a8ad72$var$onElRemoveds.push(callback);
    }
}
function $095eca2286a8ad72$var$onAttributesAdded(callback) {
    $095eca2286a8ad72$var$onAttributeAddeds.push(callback);
}
function $095eca2286a8ad72$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $095eca2286a8ad72$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $095eca2286a8ad72$var$cleanupElement(el) {
    el._x_effects?.forEach($095eca2286a8ad72$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $095eca2286a8ad72$var$observer = new MutationObserver($095eca2286a8ad72$var$onMutate);
var $095eca2286a8ad72$var$currentlyObserving = false;
function $095eca2286a8ad72$var$startObservingMutations() {
    $095eca2286a8ad72$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $095eca2286a8ad72$var$currentlyObserving = true;
}
function $095eca2286a8ad72$var$stopObservingMutations() {
    $095eca2286a8ad72$var$flushObserver();
    $095eca2286a8ad72$var$observer.disconnect();
    $095eca2286a8ad72$var$currentlyObserving = false;
}
var $095eca2286a8ad72$var$queuedMutations = [];
function $095eca2286a8ad72$var$flushObserver() {
    let records = $095eca2286a8ad72$var$observer.takeRecords();
    $095eca2286a8ad72$var$queuedMutations.push(()=>records.length > 0 && $095eca2286a8ad72$var$onMutate(records));
    let queueLengthWhenTriggered = $095eca2286a8ad72$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($095eca2286a8ad72$var$queuedMutations.length === queueLengthWhenTriggered) while($095eca2286a8ad72$var$queuedMutations.length > 0)$095eca2286a8ad72$var$queuedMutations.shift()();
    });
}
function $095eca2286a8ad72$var$mutateDom(callback) {
    if (!$095eca2286a8ad72$var$currentlyObserving) return callback();
    $095eca2286a8ad72$var$stopObservingMutations();
    let result = callback();
    $095eca2286a8ad72$var$startObservingMutations();
    return result;
}
var $095eca2286a8ad72$var$isCollecting = false;
var $095eca2286a8ad72$var$deferredMutations = [];
function $095eca2286a8ad72$var$deferMutations() {
    $095eca2286a8ad72$var$isCollecting = true;
}
function $095eca2286a8ad72$var$flushAndStopDeferringMutations() {
    $095eca2286a8ad72$var$isCollecting = false;
    $095eca2286a8ad72$var$onMutate($095eca2286a8ad72$var$deferredMutations);
    $095eca2286a8ad72$var$deferredMutations = [];
}
function $095eca2286a8ad72$var$onMutate(mutations) {
    if ($095eca2286a8ad72$var$isCollecting) {
        $095eca2286a8ad72$var$deferredMutations = $095eca2286a8ad72$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $095eca2286a8ad72$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $095eca2286a8ad72$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $095eca2286a8ad72$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $095eca2286a8ad72$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $095eca2286a8ad72$var$scope(node) {
    return $095eca2286a8ad72$var$mergeProxies($095eca2286a8ad72$var$closestDataStack(node));
}
function $095eca2286a8ad72$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$095eca2286a8ad72$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $095eca2286a8ad72$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $095eca2286a8ad72$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $095eca2286a8ad72$var$closestDataStack(node.parentNode);
}
function $095eca2286a8ad72$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $095eca2286a8ad72$var$mergeProxyTrap);
}
function $095eca2286a8ad72$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $095eca2286a8ad72$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $095eca2286a8ad72$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $095eca2286a8ad72$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $095eca2286a8ad72$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $095eca2286a8ad72$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $095eca2286a8ad72$var$initInterceptors(data2) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $095eca2286a8ad72$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$095eca2286a8ad72$var$get(data2, path), (value)=>$095eca2286a8ad72$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $095eca2286a8ad72$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $095eca2286a8ad72$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $095eca2286a8ad72$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $095eca2286a8ad72$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $095eca2286a8ad72$var$magics = {};
function $095eca2286a8ad72$var$magic(name, callback) {
    $095eca2286a8ad72$var$magics[name] = callback;
}
function $095eca2286a8ad72$var$injectMagics(obj, el) {
    let memoizedUtilities = $095eca2286a8ad72$var$getUtilities(el);
    Object.entries($095eca2286a8ad72$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $095eca2286a8ad72$var$getUtilities(el) {
    let [utilities, cleanup2] = $095eca2286a8ad72$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $095eca2286a8ad72$var$interceptor,
        ...utilities
    };
    $095eca2286a8ad72$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $095eca2286a8ad72$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $095eca2286a8ad72$var$handleError(e, el, expression);
    }
}
function $095eca2286a8ad72$var$handleError(...args) {
    return $095eca2286a8ad72$var$errorHandler(...args);
}
var $095eca2286a8ad72$var$errorHandler = $095eca2286a8ad72$var$normalErrorHandler;
function $095eca2286a8ad72$var$setErrorHandler(handler4) {
    $095eca2286a8ad72$var$errorHandler = handler4;
}
function $095eca2286a8ad72$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $095eca2286a8ad72$var$shouldAutoEvaluateFunctions = true;
function $095eca2286a8ad72$var$dontAutoEvaluateFunctions(callback) {
    let cache = $095eca2286a8ad72$var$shouldAutoEvaluateFunctions;
    $095eca2286a8ad72$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $095eca2286a8ad72$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $095eca2286a8ad72$var$evaluate(el, expression, extras = {}) {
    let result;
    $095eca2286a8ad72$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $095eca2286a8ad72$var$evaluateLater(...args) {
    return $095eca2286a8ad72$var$theEvaluatorFunction(...args);
}
var $095eca2286a8ad72$var$theEvaluatorFunction = ()=>{};
function $095eca2286a8ad72$var$setEvaluator(newEvaluator) {
    $095eca2286a8ad72$var$theEvaluatorFunction = newEvaluator;
}
var $095eca2286a8ad72$var$theRawEvaluatorFunction;
function $095eca2286a8ad72$var$setRawEvaluator(newEvaluator) {
    $095eca2286a8ad72$var$theRawEvaluatorFunction = newEvaluator;
}
function $095eca2286a8ad72$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $095eca2286a8ad72$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$095eca2286a8ad72$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $095eca2286a8ad72$var$generateEvaluatorFromFunction(dataStack, expression) : $095eca2286a8ad72$var$generateEvaluatorFromString(dataStack, expression, el);
    return $095eca2286a8ad72$var$tryCatch.bind(null, el, expression, evaluator);
}
function $095eca2286a8ad72$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$095eca2286a8ad72$var$shouldAutoEvaluateFunctions) {
            $095eca2286a8ad72$var$runIfTypeOfFunction(receiver, func, $095eca2286a8ad72$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($095eca2286a8ad72$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $095eca2286a8ad72$var$runIfTypeOfFunction(receiver, result);
    };
}
var $095eca2286a8ad72$var$evaluatorMemo = {};
function $095eca2286a8ad72$var$generateFunctionFromString(expression, el) {
    if ($095eca2286a8ad72$var$evaluatorMemo[expression]) return $095eca2286a8ad72$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $095eca2286a8ad72$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $095eca2286a8ad72$var$evaluatorMemo[expression] = func;
    return func;
}
function $095eca2286a8ad72$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $095eca2286a8ad72$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $095eca2286a8ad72$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$095eca2286a8ad72$var$handleError(error2, el, expression));
            if (func.finished) {
                $095eca2286a8ad72$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $095eca2286a8ad72$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$095eca2286a8ad72$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $095eca2286a8ad72$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($095eca2286a8ad72$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$095eca2286a8ad72$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$095eca2286a8ad72$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $095eca2286a8ad72$var$evaluateRaw(...args) {
    return $095eca2286a8ad72$var$theRawEvaluatorFunction(...args);
}
function $095eca2286a8ad72$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $095eca2286a8ad72$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$095eca2286a8ad72$var$closestDataStack(el)
    ];
    let scope2 = $095eca2286a8ad72$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $095eca2286a8ad72$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $095eca2286a8ad72$var$prefixAsString = "x-";
function $095eca2286a8ad72$var$prefix(subject = "") {
    return $095eca2286a8ad72$var$prefixAsString + subject;
}
function $095eca2286a8ad72$var$setPrefix(newPrefix) {
    $095eca2286a8ad72$var$prefixAsString = newPrefix;
}
var $095eca2286a8ad72$var$directiveHandlers = {};
function $095eca2286a8ad72$var$directive(name, callback) {
    $095eca2286a8ad72$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$095eca2286a8ad72$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $095eca2286a8ad72$var$directiveOrder.indexOf(directive2);
            $095eca2286a8ad72$var$directiveOrder.splice(pos >= 0 ? pos : $095eca2286a8ad72$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $095eca2286a8ad72$var$directiveExists(name) {
    return Object.keys($095eca2286a8ad72$var$directiveHandlers).includes(name);
}
function $095eca2286a8ad72$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $095eca2286a8ad72$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($095eca2286a8ad72$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($095eca2286a8ad72$var$outNonAlpineAttributes).map($095eca2286a8ad72$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($095eca2286a8ad72$var$byPriority);
    return directives2.map((directive2)=>{
        return $095eca2286a8ad72$var$getDirectiveHandler(el, directive2);
    });
}
function $095eca2286a8ad72$var$attributesOnly(attributes) {
    return Array.from(attributes).map($095eca2286a8ad72$var$toTransformedAttributes()).filter((attr)=>!$095eca2286a8ad72$var$outNonAlpineAttributes(attr));
}
var $095eca2286a8ad72$var$isDeferringHandlers = false;
var $095eca2286a8ad72$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $095eca2286a8ad72$var$currentHandlerStackKey = Symbol();
function $095eca2286a8ad72$var$deferHandlingDirectives(callback) {
    $095eca2286a8ad72$var$isDeferringHandlers = true;
    let key = Symbol();
    $095eca2286a8ad72$var$currentHandlerStackKey = key;
    $095eca2286a8ad72$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($095eca2286a8ad72$var$directiveHandlerStacks.get(key).length)$095eca2286a8ad72$var$directiveHandlerStacks.get(key).shift()();
        $095eca2286a8ad72$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $095eca2286a8ad72$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $095eca2286a8ad72$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $095eca2286a8ad72$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $095eca2286a8ad72$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $095eca2286a8ad72$var$evaluateLater.bind($095eca2286a8ad72$var$evaluateLater, el),
        evaluate: $095eca2286a8ad72$var$evaluate.bind($095eca2286a8ad72$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $095eca2286a8ad72$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $095eca2286a8ad72$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $095eca2286a8ad72$var$getElementBoundUtilities(el);
    $095eca2286a8ad72$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $095eca2286a8ad72$var$isDeferringHandlers ? $095eca2286a8ad72$var$directiveHandlerStacks.get($095eca2286a8ad72$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $095eca2286a8ad72$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $095eca2286a8ad72$var$into = (i)=>i;
function $095eca2286a8ad72$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $095eca2286a8ad72$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $095eca2286a8ad72$var$attributeTransformers = [];
function $095eca2286a8ad72$var$mapAttributes(callback) {
    $095eca2286a8ad72$var$attributeTransformers.push(callback);
}
function $095eca2286a8ad72$var$outNonAlpineAttributes({ name: name }) {
    return $095eca2286a8ad72$var$alpineAttributeRegex().test(name);
}
var $095eca2286a8ad72$var$alpineAttributeRegex = ()=>new RegExp(`^${$095eca2286a8ad72$var$prefixAsString}([^:^.]+)\\b`);
function $095eca2286a8ad72$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($095eca2286a8ad72$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $095eca2286a8ad72$var$DEFAULT = "DEFAULT";
var $095eca2286a8ad72$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $095eca2286a8ad72$var$DEFAULT,
    "teleport"
];
function $095eca2286a8ad72$var$byPriority(a, b) {
    let typeA = $095eca2286a8ad72$var$directiveOrder.indexOf(a.type) === -1 ? $095eca2286a8ad72$var$DEFAULT : a.type;
    let typeB = $095eca2286a8ad72$var$directiveOrder.indexOf(b.type) === -1 ? $095eca2286a8ad72$var$DEFAULT : b.type;
    return $095eca2286a8ad72$var$directiveOrder.indexOf(typeA) - $095eca2286a8ad72$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $095eca2286a8ad72$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/walk.js
function $095eca2286a8ad72$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$095eca2286a8ad72$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $095eca2286a8ad72$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $095eca2286a8ad72$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $095eca2286a8ad72$var$started = false;
function $095eca2286a8ad72$var$start() {
    if ($095eca2286a8ad72$var$started) $095eca2286a8ad72$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $095eca2286a8ad72$var$started = true;
    if (!document.body) $095eca2286a8ad72$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $095eca2286a8ad72$var$dispatch(document, "alpine:init");
    $095eca2286a8ad72$var$dispatch(document, "alpine:initializing");
    $095eca2286a8ad72$var$startObservingMutations();
    $095eca2286a8ad72$var$onElAdded((el)=>$095eca2286a8ad72$var$initTree(el, $095eca2286a8ad72$var$walk));
    $095eca2286a8ad72$var$onElRemoved((el)=>$095eca2286a8ad72$var$destroyTree(el));
    $095eca2286a8ad72$var$onAttributesAdded((el, attrs)=>{
        $095eca2286a8ad72$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$095eca2286a8ad72$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($095eca2286a8ad72$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $095eca2286a8ad72$var$initTree(el);
    });
    $095eca2286a8ad72$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $095eca2286a8ad72$var$warnAboutMissingPlugins();
    });
}
var $095eca2286a8ad72$var$rootSelectorCallbacks = [];
var $095eca2286a8ad72$var$initSelectorCallbacks = [];
function $095eca2286a8ad72$var$rootSelectors() {
    return $095eca2286a8ad72$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $095eca2286a8ad72$var$allSelectors() {
    return $095eca2286a8ad72$var$rootSelectorCallbacks.concat($095eca2286a8ad72$var$initSelectorCallbacks).map((fn)=>fn());
}
function $095eca2286a8ad72$var$addRootSelector(selectorCallback) {
    $095eca2286a8ad72$var$rootSelectorCallbacks.push(selectorCallback);
}
function $095eca2286a8ad72$var$addInitSelector(selectorCallback) {
    $095eca2286a8ad72$var$initSelectorCallbacks.push(selectorCallback);
}
function $095eca2286a8ad72$var$closestRoot(el, includeInitSelectors = false) {
    return $095eca2286a8ad72$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $095eca2286a8ad72$var$allSelectors() : $095eca2286a8ad72$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $095eca2286a8ad72$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $095eca2286a8ad72$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $095eca2286a8ad72$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $095eca2286a8ad72$var$findClosest(el.parentElement, callback);
}
function $095eca2286a8ad72$var$isRoot(el) {
    return $095eca2286a8ad72$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $095eca2286a8ad72$var$initInterceptors2 = [];
function $095eca2286a8ad72$var$interceptInit(callback) {
    $095eca2286a8ad72$var$initInterceptors2.push(callback);
}
var $095eca2286a8ad72$var$markerDispenser = 1;
function $095eca2286a8ad72$var$initTree(el, walker = $095eca2286a8ad72$var$walk, intercept = ()=>{}) {
    if ($095eca2286a8ad72$var$findClosest(el, (i)=>i._x_ignore)) return;
    $095eca2286a8ad72$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $095eca2286a8ad72$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $095eca2286a8ad72$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $095eca2286a8ad72$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $095eca2286a8ad72$var$destroyTree(root, walker = $095eca2286a8ad72$var$walk) {
    walker(root, (el)=>{
        $095eca2286a8ad72$var$cleanupElement(el);
        $095eca2286a8ad72$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $095eca2286a8ad72$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($095eca2286a8ad72$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $095eca2286a8ad72$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $095eca2286a8ad72$var$tickStack = [];
var $095eca2286a8ad72$var$isHolding = false;
function $095eca2286a8ad72$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $095eca2286a8ad72$var$isHolding || setTimeout(()=>{
            $095eca2286a8ad72$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $095eca2286a8ad72$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $095eca2286a8ad72$var$releaseNextTicks() {
    $095eca2286a8ad72$var$isHolding = false;
    while($095eca2286a8ad72$var$tickStack.length)$095eca2286a8ad72$var$tickStack.shift()();
}
function $095eca2286a8ad72$var$holdNextTicks() {
    $095eca2286a8ad72$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $095eca2286a8ad72$var$setClasses(el, value) {
    if (Array.isArray(value)) return $095eca2286a8ad72$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $095eca2286a8ad72$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $095eca2286a8ad72$var$setClasses(el, value());
    return $095eca2286a8ad72$var$setClassesFromString(el, value);
}
function $095eca2286a8ad72$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $095eca2286a8ad72$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$095eca2286a8ad72$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $095eca2286a8ad72$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $095eca2286a8ad72$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $095eca2286a8ad72$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $095eca2286a8ad72$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $095eca2286a8ad72$var$setStylesFromObject(el, value);
    return $095eca2286a8ad72$var$setStylesFromString(el, value);
}
function $095eca2286a8ad72$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $095eca2286a8ad72$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $095eca2286a8ad72$var$setStyles(el, previousStyles);
    };
}
function $095eca2286a8ad72$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $095eca2286a8ad72$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $095eca2286a8ad72$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$095eca2286a8ad72$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $095eca2286a8ad72$var$registerTransitionsFromHelper(el, modifiers, value);
    else $095eca2286a8ad72$var$registerTransitionsFromClassString(el, expression, value);
});
function $095eca2286a8ad72$var$registerTransitionsFromClassString(el, classString, stage) {
    $095eca2286a8ad72$var$registerTransitionObject(el, $095eca2286a8ad72$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $095eca2286a8ad72$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $095eca2286a8ad72$var$registerTransitionObject(el, $095eca2286a8ad72$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $095eca2286a8ad72$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $095eca2286a8ad72$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $095eca2286a8ad72$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $095eca2286a8ad72$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $095eca2286a8ad72$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $095eca2286a8ad72$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $095eca2286a8ad72$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $095eca2286a8ad72$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $095eca2286a8ad72$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $095eca2286a8ad72$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $095eca2286a8ad72$var$closestHide(parent);
}
function $095eca2286a8ad72$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $095eca2286a8ad72$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $095eca2286a8ad72$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $095eca2286a8ad72$var$once(()=>{
        $095eca2286a8ad72$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $095eca2286a8ad72$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $095eca2286a8ad72$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $095eca2286a8ad72$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $095eca2286a8ad72$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $095eca2286a8ad72$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $095eca2286a8ad72$var$mutateDom(()=>{
                stages.end();
            });
            $095eca2286a8ad72$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $095eca2286a8ad72$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $095eca2286a8ad72$var$isCloning = false;
function $095eca2286a8ad72$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$095eca2286a8ad72$var$isCloning ? fallback(...args) : callback(...args);
}
function $095eca2286a8ad72$var$onlyDuringClone(callback) {
    return (...args)=>$095eca2286a8ad72$var$isCloning && callback(...args);
}
var $095eca2286a8ad72$var$interceptors = [];
function $095eca2286a8ad72$var$interceptClone(callback) {
    $095eca2286a8ad72$var$interceptors.push(callback);
}
function $095eca2286a8ad72$var$cloneNode(from, to) {
    $095eca2286a8ad72$var$interceptors.forEach((i)=>i(from, to));
    $095eca2286a8ad72$var$isCloning = true;
    $095eca2286a8ad72$var$dontRegisterReactiveSideEffects(()=>{
        $095eca2286a8ad72$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $095eca2286a8ad72$var$isCloning = false;
}
var $095eca2286a8ad72$var$isCloningLegacy = false;
function $095eca2286a8ad72$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $095eca2286a8ad72$var$isCloning = true;
    $095eca2286a8ad72$var$isCloningLegacy = true;
    $095eca2286a8ad72$var$dontRegisterReactiveSideEffects(()=>{
        $095eca2286a8ad72$var$cloneTree(newEl);
    });
    $095eca2286a8ad72$var$isCloning = false;
    $095eca2286a8ad72$var$isCloningLegacy = false;
}
function $095eca2286a8ad72$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $095eca2286a8ad72$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $095eca2286a8ad72$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $095eca2286a8ad72$var$initTree(el, shallowWalker);
}
function $095eca2286a8ad72$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $095eca2286a8ad72$var$effect;
    $095eca2286a8ad72$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $095eca2286a8ad72$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $095eca2286a8ad72$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $095eca2286a8ad72$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $095eca2286a8ad72$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $095eca2286a8ad72$var$camelCase(name) : name;
    switch(name){
        case "value":
            $095eca2286a8ad72$var$bindInputValue(el, value);
            break;
        case "style":
            $095eca2286a8ad72$var$bindStyles(el, value);
            break;
        case "class":
            $095eca2286a8ad72$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $095eca2286a8ad72$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $095eca2286a8ad72$var$bindAttribute(el, name, value);
            break;
    }
}
function $095eca2286a8ad72$var$bindInputValue(el, value) {
    if ($095eca2286a8ad72$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($095eca2286a8ad72$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$095eca2286a8ad72$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $095eca2286a8ad72$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $095eca2286a8ad72$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $095eca2286a8ad72$var$setClasses(el, value);
}
function $095eca2286a8ad72$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $095eca2286a8ad72$var$setStyles(el, value);
}
function $095eca2286a8ad72$var$bindAttributeAndProperty(el, name, value) {
    $095eca2286a8ad72$var$bindAttribute(el, name, value);
    $095eca2286a8ad72$var$setPropertyIfChanged(el, name, value);
}
function $095eca2286a8ad72$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $095eca2286a8ad72$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($095eca2286a8ad72$var$isBooleanAttr(name)) value = name;
        $095eca2286a8ad72$var$setIfChanged(el, name, value);
    }
}
function $095eca2286a8ad72$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $095eca2286a8ad72$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $095eca2286a8ad72$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $095eca2286a8ad72$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $095eca2286a8ad72$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $095eca2286a8ad72$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $095eca2286a8ad72$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $095eca2286a8ad72$var$isBooleanAttr(attrName) {
    return $095eca2286a8ad72$var$booleanAttributes.has(attrName);
}
function $095eca2286a8ad72$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $095eca2286a8ad72$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $095eca2286a8ad72$var$getAttributeBinding(el, name, fallback);
}
function $095eca2286a8ad72$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $095eca2286a8ad72$var$dontAutoEvaluateFunctions(()=>{
            return $095eca2286a8ad72$var$evaluate(el, binding.expression);
        });
    }
    return $095eca2286a8ad72$var$getAttributeBinding(el, name, fallback);
}
function $095eca2286a8ad72$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($095eca2286a8ad72$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $095eca2286a8ad72$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $095eca2286a8ad72$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $095eca2286a8ad72$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $095eca2286a8ad72$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $095eca2286a8ad72$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $095eca2286a8ad72$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($095eca2286a8ad72$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($095eca2286a8ad72$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($095eca2286a8ad72$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $095eca2286a8ad72$var$release(reference);
    };
}
function $095eca2286a8ad72$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $095eca2286a8ad72$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($095eca2286a8ad72$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $095eca2286a8ad72$var$stores = {};
var $095eca2286a8ad72$var$isReactive = false;
function $095eca2286a8ad72$var$store(name, value) {
    if (!$095eca2286a8ad72$var$isReactive) {
        $095eca2286a8ad72$var$stores = $095eca2286a8ad72$var$reactive($095eca2286a8ad72$var$stores);
        $095eca2286a8ad72$var$isReactive = true;
    }
    if (value === void 0) return $095eca2286a8ad72$var$stores[name];
    $095eca2286a8ad72$var$stores[name] = value;
    $095eca2286a8ad72$var$initInterceptors($095eca2286a8ad72$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $095eca2286a8ad72$var$stores[name].init();
}
function $095eca2286a8ad72$var$getStores() {
    return $095eca2286a8ad72$var$stores;
}
// packages/alpinejs/src/binds.js
var $095eca2286a8ad72$var$binds = {};
function $095eca2286a8ad72$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $095eca2286a8ad72$var$applyBindingsObject(name, getBindings());
    else $095eca2286a8ad72$var$binds[name] = getBindings;
    return ()=>{};
}
function $095eca2286a8ad72$var$injectBindingProviders(obj) {
    Object.entries($095eca2286a8ad72$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $095eca2286a8ad72$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $095eca2286a8ad72$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $095eca2286a8ad72$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $095eca2286a8ad72$var$datas = {};
function $095eca2286a8ad72$var$data(name, callback) {
    $095eca2286a8ad72$var$datas[name] = callback;
}
function $095eca2286a8ad72$var$injectDataProviders(obj, context) {
    Object.entries($095eca2286a8ad72$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $095eca2286a8ad72$var$Alpine = {
    get reactive () {
        return $095eca2286a8ad72$var$reactive;
    },
    get release () {
        return $095eca2286a8ad72$var$release;
    },
    get effect () {
        return $095eca2286a8ad72$var$effect;
    },
    get raw () {
        return $095eca2286a8ad72$var$raw;
    },
    get transaction () {
        return $095eca2286a8ad72$var$transaction;
    },
    version: "3.15.12",
    flushAndStopDeferringMutations: $095eca2286a8ad72$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $095eca2286a8ad72$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $095eca2286a8ad72$var$disableEffectScheduling,
    startObservingMutations: $095eca2286a8ad72$var$startObservingMutations,
    stopObservingMutations: $095eca2286a8ad72$var$stopObservingMutations,
    setReactivityEngine: $095eca2286a8ad72$var$setReactivityEngine,
    onAttributeRemoved: $095eca2286a8ad72$var$onAttributeRemoved,
    onAttributesAdded: $095eca2286a8ad72$var$onAttributesAdded,
    closestDataStack: $095eca2286a8ad72$var$closestDataStack,
    skipDuringClone: $095eca2286a8ad72$var$skipDuringClone,
    onlyDuringClone: $095eca2286a8ad72$var$onlyDuringClone,
    addRootSelector: $095eca2286a8ad72$var$addRootSelector,
    addInitSelector: $095eca2286a8ad72$var$addInitSelector,
    setErrorHandler: $095eca2286a8ad72$var$setErrorHandler,
    interceptClone: $095eca2286a8ad72$var$interceptClone,
    addScopeToNode: $095eca2286a8ad72$var$addScopeToNode,
    deferMutations: $095eca2286a8ad72$var$deferMutations,
    mapAttributes: $095eca2286a8ad72$var$mapAttributes,
    evaluateLater: $095eca2286a8ad72$var$evaluateLater,
    interceptInit: $095eca2286a8ad72$var$interceptInit,
    initInterceptors: $095eca2286a8ad72$var$initInterceptors,
    injectMagics: $095eca2286a8ad72$var$injectMagics,
    setEvaluator: $095eca2286a8ad72$var$setEvaluator,
    setRawEvaluator: $095eca2286a8ad72$var$setRawEvaluator,
    mergeProxies: $095eca2286a8ad72$var$mergeProxies,
    extractProp: $095eca2286a8ad72$var$extractProp,
    findClosest: $095eca2286a8ad72$var$findClosest,
    onElRemoved: $095eca2286a8ad72$var$onElRemoved,
    closestRoot: $095eca2286a8ad72$var$closestRoot,
    destroyTree: $095eca2286a8ad72$var$destroyTree,
    interceptor: $095eca2286a8ad72$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $095eca2286a8ad72$var$transition,
    setStyles: // INTERNAL
    $095eca2286a8ad72$var$setStyles,
    mutateDom: // INTERNAL
    $095eca2286a8ad72$var$mutateDom,
    directive: $095eca2286a8ad72$var$directive,
    entangle: $095eca2286a8ad72$var$entangle,
    throttle: $095eca2286a8ad72$var$throttle,
    debounce: $095eca2286a8ad72$var$debounce,
    evaluate: $095eca2286a8ad72$var$evaluate,
    evaluateRaw: $095eca2286a8ad72$var$evaluateRaw,
    initTree: $095eca2286a8ad72$var$initTree,
    nextTick: $095eca2286a8ad72$var$nextTick,
    prefixed: $095eca2286a8ad72$var$prefix,
    prefix: $095eca2286a8ad72$var$setPrefix,
    plugin: $095eca2286a8ad72$var$plugin,
    magic: $095eca2286a8ad72$var$magic,
    store: $095eca2286a8ad72$var$store,
    start: $095eca2286a8ad72$var$start,
    clone: $095eca2286a8ad72$var$clone,
    cloneNode: // INTERNAL
    $095eca2286a8ad72$var$cloneNode,
    // INTERNAL
    bound: $095eca2286a8ad72$var$getBinding,
    $data: $095eca2286a8ad72$var$scope,
    watch: $095eca2286a8ad72$var$watch,
    walk: $095eca2286a8ad72$var$walk,
    data: $095eca2286a8ad72$var$data,
    bind: $095eca2286a8ad72$var$bind2
};
var $095eca2286a8ad72$var$alpine_default = $095eca2286a8ad72$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $095eca2286a8ad72$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $095eca2286a8ad72$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $095eca2286a8ad72$var$isBooleanAttr2 = /* @__PURE__ */ $095eca2286a8ad72$var$makeMap($095eca2286a8ad72$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $095eca2286a8ad72$var$EMPTY_OBJ = Object.freeze({});
var $095eca2286a8ad72$var$EMPTY_ARR = Object.freeze([]);
var $095eca2286a8ad72$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $095eca2286a8ad72$var$hasOwn = (val, key)=>$095eca2286a8ad72$var$hasOwnProperty.call(val, key);
var $095eca2286a8ad72$var$isArray = Array.isArray;
var $095eca2286a8ad72$var$isMap = (val)=>$095eca2286a8ad72$var$toTypeString(val) === "[object Map]";
var $095eca2286a8ad72$var$isString = (val)=>typeof val === "string";
var $095eca2286a8ad72$var$isSymbol = (val)=>typeof val === "symbol";
var $095eca2286a8ad72$var$isObject = (val)=>val !== null && typeof val === "object";
var $095eca2286a8ad72$var$objectToString = Object.prototype.toString;
var $095eca2286a8ad72$var$toTypeString = (value)=>$095eca2286a8ad72$var$objectToString.call(value);
var $095eca2286a8ad72$var$toRawType = (value)=>{
    return $095eca2286a8ad72$var$toTypeString(value).slice(8, -1);
};
var $095eca2286a8ad72$var$isIntegerKey = (key)=>$095eca2286a8ad72$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $095eca2286a8ad72$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $095eca2286a8ad72$var$camelizeRE = /-(\w)/g;
var $095eca2286a8ad72$var$camelize = $095eca2286a8ad72$var$cacheStringFunction((str)=>{
    return str.replace($095eca2286a8ad72$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $095eca2286a8ad72$var$hyphenateRE = /\B([A-Z])/g;
var $095eca2286a8ad72$var$hyphenate = $095eca2286a8ad72$var$cacheStringFunction((str)=>str.replace($095eca2286a8ad72$var$hyphenateRE, "-$1").toLowerCase());
var $095eca2286a8ad72$var$capitalize = $095eca2286a8ad72$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $095eca2286a8ad72$var$toHandlerKey = $095eca2286a8ad72$var$cacheStringFunction((str)=>str ? `on${$095eca2286a8ad72$var$capitalize(str)}` : ``);
var $095eca2286a8ad72$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $095eca2286a8ad72$var$targetMap = /* @__PURE__ */ new WeakMap();
var $095eca2286a8ad72$var$effectStack = [];
var $095eca2286a8ad72$var$activeEffect;
var $095eca2286a8ad72$var$ITERATE_KEY = Symbol("iterate");
var $095eca2286a8ad72$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $095eca2286a8ad72$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $095eca2286a8ad72$var$effect2(fn, options = $095eca2286a8ad72$var$EMPTY_OBJ) {
    if ($095eca2286a8ad72$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $095eca2286a8ad72$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $095eca2286a8ad72$var$stop(effect3) {
    if (effect3.active) {
        $095eca2286a8ad72$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $095eca2286a8ad72$var$uid = 0;
function $095eca2286a8ad72$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$095eca2286a8ad72$var$effectStack.includes(effect3)) {
            $095eca2286a8ad72$var$cleanup(effect3);
            try {
                $095eca2286a8ad72$var$enableTracking();
                $095eca2286a8ad72$var$effectStack.push(effect3);
                $095eca2286a8ad72$var$activeEffect = effect3;
                return fn();
            } finally{
                $095eca2286a8ad72$var$effectStack.pop();
                $095eca2286a8ad72$var$resetTracking();
                $095eca2286a8ad72$var$activeEffect = $095eca2286a8ad72$var$effectStack[$095eca2286a8ad72$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $095eca2286a8ad72$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $095eca2286a8ad72$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $095eca2286a8ad72$var$shouldTrack = true;
var $095eca2286a8ad72$var$trackStack = [];
function $095eca2286a8ad72$var$pauseTracking() {
    $095eca2286a8ad72$var$trackStack.push($095eca2286a8ad72$var$shouldTrack);
    $095eca2286a8ad72$var$shouldTrack = false;
}
function $095eca2286a8ad72$var$enableTracking() {
    $095eca2286a8ad72$var$trackStack.push($095eca2286a8ad72$var$shouldTrack);
    $095eca2286a8ad72$var$shouldTrack = true;
}
function $095eca2286a8ad72$var$resetTracking() {
    const last = $095eca2286a8ad72$var$trackStack.pop();
    $095eca2286a8ad72$var$shouldTrack = last === void 0 ? true : last;
}
function $095eca2286a8ad72$var$track(target, type, key) {
    if (!$095eca2286a8ad72$var$shouldTrack || $095eca2286a8ad72$var$activeEffect === void 0) return;
    let depsMap = $095eca2286a8ad72$var$targetMap.get(target);
    if (!depsMap) $095eca2286a8ad72$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($095eca2286a8ad72$var$activeEffect)) {
        dep.add($095eca2286a8ad72$var$activeEffect);
        $095eca2286a8ad72$var$activeEffect.deps.push(dep);
        if ($095eca2286a8ad72$var$activeEffect.options.onTrack) $095eca2286a8ad72$var$activeEffect.options.onTrack({
            effect: $095eca2286a8ad72$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $095eca2286a8ad72$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $095eca2286a8ad72$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $095eca2286a8ad72$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $095eca2286a8ad72$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$095eca2286a8ad72$var$isArray(target)) {
                    add2(depsMap.get($095eca2286a8ad72$var$ITERATE_KEY));
                    if ($095eca2286a8ad72$var$isMap(target)) add2(depsMap.get($095eca2286a8ad72$var$MAP_KEY_ITERATE_KEY));
                } else if ($095eca2286a8ad72$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$095eca2286a8ad72$var$isArray(target)) {
                    add2(depsMap.get($095eca2286a8ad72$var$ITERATE_KEY));
                    if ($095eca2286a8ad72$var$isMap(target)) add2(depsMap.get($095eca2286a8ad72$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($095eca2286a8ad72$var$isMap(target)) add2(depsMap.get($095eca2286a8ad72$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $095eca2286a8ad72$var$isNonTrackableKeys = /* @__PURE__ */ $095eca2286a8ad72$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $095eca2286a8ad72$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($095eca2286a8ad72$var$isSymbol));
var $095eca2286a8ad72$var$get2 = /* @__PURE__ */ $095eca2286a8ad72$var$createGetter();
var $095eca2286a8ad72$var$readonlyGet = /* @__PURE__ */ $095eca2286a8ad72$var$createGetter(true);
var $095eca2286a8ad72$var$arrayInstrumentations = /* @__PURE__ */ $095eca2286a8ad72$var$createArrayInstrumentations();
function $095eca2286a8ad72$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $095eca2286a8ad72$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$095eca2286a8ad72$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($095eca2286a8ad72$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $095eca2286a8ad72$var$pauseTracking();
            const res = $095eca2286a8ad72$var$toRaw(this)[key].apply(this, args);
            $095eca2286a8ad72$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $095eca2286a8ad72$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $095eca2286a8ad72$var$shallowReadonlyMap : $095eca2286a8ad72$var$readonlyMap : shallow ? $095eca2286a8ad72$var$shallowReactiveMap : $095eca2286a8ad72$var$reactiveMap).get(target)) return target;
        const targetIsArray = $095eca2286a8ad72$var$isArray(target);
        if (!isReadonly && targetIsArray && $095eca2286a8ad72$var$hasOwn($095eca2286a8ad72$var$arrayInstrumentations, key)) return Reflect.get($095eca2286a8ad72$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($095eca2286a8ad72$var$isSymbol(key) ? $095eca2286a8ad72$var$builtInSymbols.has(key) : $095eca2286a8ad72$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $095eca2286a8ad72$var$track(target, "get", key);
        if (shallow) return res;
        if ($095eca2286a8ad72$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$095eca2286a8ad72$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($095eca2286a8ad72$var$isObject(res)) return isReadonly ? $095eca2286a8ad72$var$readonly(res) : $095eca2286a8ad72$var$reactive2(res);
        return res;
    };
}
var $095eca2286a8ad72$var$set2 = /* @__PURE__ */ $095eca2286a8ad72$var$createSetter();
function $095eca2286a8ad72$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $095eca2286a8ad72$var$toRaw(value);
            oldValue = $095eca2286a8ad72$var$toRaw(oldValue);
            if (!$095eca2286a8ad72$var$isArray(target) && $095eca2286a8ad72$var$isRef(oldValue) && !$095eca2286a8ad72$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $095eca2286a8ad72$var$isArray(target) && $095eca2286a8ad72$var$isIntegerKey(key) ? Number(key) < target.length : $095eca2286a8ad72$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $095eca2286a8ad72$var$toRaw(receiver)) {
            if (!hadKey) $095eca2286a8ad72$var$trigger(target, "add", key, value);
            else if ($095eca2286a8ad72$var$hasChanged(value, oldValue)) $095eca2286a8ad72$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $095eca2286a8ad72$var$deleteProperty(target, key) {
    const hadKey = $095eca2286a8ad72$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $095eca2286a8ad72$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $095eca2286a8ad72$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$095eca2286a8ad72$var$isSymbol(key) || !$095eca2286a8ad72$var$builtInSymbols.has(key)) $095eca2286a8ad72$var$track(target, "has", key);
    return result;
}
function $095eca2286a8ad72$var$ownKeys(target) {
    $095eca2286a8ad72$var$track(target, "iterate", $095eca2286a8ad72$var$isArray(target) ? "length" : $095eca2286a8ad72$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $095eca2286a8ad72$var$mutableHandlers = {
    get: $095eca2286a8ad72$var$get2,
    set: $095eca2286a8ad72$var$set2,
    deleteProperty: $095eca2286a8ad72$var$deleteProperty,
    has: $095eca2286a8ad72$var$has,
    ownKeys: $095eca2286a8ad72$var$ownKeys
};
var $095eca2286a8ad72$var$readonlyHandlers = {
    get: $095eca2286a8ad72$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $095eca2286a8ad72$var$toReactive = (value)=>$095eca2286a8ad72$var$isObject(value) ? $095eca2286a8ad72$var$reactive2(value) : value;
var $095eca2286a8ad72$var$toReadonly = (value)=>$095eca2286a8ad72$var$isObject(value) ? $095eca2286a8ad72$var$readonly(value) : value;
var $095eca2286a8ad72$var$toShallow = (value)=>value;
var $095eca2286a8ad72$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $095eca2286a8ad72$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $095eca2286a8ad72$var$toRaw(target);
    const rawKey = $095eca2286a8ad72$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $095eca2286a8ad72$var$track(rawTarget, "get", key);
    !isReadonly && $095eca2286a8ad72$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $095eca2286a8ad72$var$getProto(rawTarget);
    const wrap = isShallow ? $095eca2286a8ad72$var$toShallow : isReadonly ? $095eca2286a8ad72$var$toReadonly : $095eca2286a8ad72$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $095eca2286a8ad72$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $095eca2286a8ad72$var$toRaw(target);
    const rawKey = $095eca2286a8ad72$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $095eca2286a8ad72$var$track(rawTarget, "has", key);
    !isReadonly && $095eca2286a8ad72$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $095eca2286a8ad72$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $095eca2286a8ad72$var$track($095eca2286a8ad72$var$toRaw(target), "iterate", $095eca2286a8ad72$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $095eca2286a8ad72$var$add(value) {
    value = $095eca2286a8ad72$var$toRaw(value);
    const target = $095eca2286a8ad72$var$toRaw(this);
    const proto = $095eca2286a8ad72$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $095eca2286a8ad72$var$trigger(target, "add", value, value);
    }
    return this;
}
function $095eca2286a8ad72$var$set$1(key, value) {
    value = $095eca2286a8ad72$var$toRaw(value);
    const target = $095eca2286a8ad72$var$toRaw(this);
    const { has: has2, get: get3 } = $095eca2286a8ad72$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $095eca2286a8ad72$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $095eca2286a8ad72$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $095eca2286a8ad72$var$trigger(target, "add", key, value);
    else if ($095eca2286a8ad72$var$hasChanged(value, oldValue)) $095eca2286a8ad72$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $095eca2286a8ad72$var$deleteEntry(key) {
    const target = $095eca2286a8ad72$var$toRaw(this);
    const { has: has2, get: get3 } = $095eca2286a8ad72$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $095eca2286a8ad72$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $095eca2286a8ad72$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $095eca2286a8ad72$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $095eca2286a8ad72$var$clear() {
    const target = $095eca2286a8ad72$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $095eca2286a8ad72$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $095eca2286a8ad72$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $095eca2286a8ad72$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $095eca2286a8ad72$var$toRaw(target);
        const wrap = isShallow ? $095eca2286a8ad72$var$toShallow : isReadonly ? $095eca2286a8ad72$var$toReadonly : $095eca2286a8ad72$var$toReactive;
        !isReadonly && $095eca2286a8ad72$var$track(rawTarget, "iterate", $095eca2286a8ad72$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $095eca2286a8ad72$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $095eca2286a8ad72$var$toRaw(target);
        const targetIsMap = $095eca2286a8ad72$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $095eca2286a8ad72$var$toShallow : isReadonly ? $095eca2286a8ad72$var$toReadonly : $095eca2286a8ad72$var$toReactive;
        !isReadonly && $095eca2286a8ad72$var$track(rawTarget, "iterate", isKeyOnly ? $095eca2286a8ad72$var$MAP_KEY_ITERATE_KEY : $095eca2286a8ad72$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $095eca2286a8ad72$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$095eca2286a8ad72$var$capitalize(type)} operation ${key}failed: target is readonly.`, $095eca2286a8ad72$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $095eca2286a8ad72$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $095eca2286a8ad72$var$get$1(this, key);
        },
        get size () {
            return $095eca2286a8ad72$var$size(this);
        },
        has: $095eca2286a8ad72$var$has$1,
        add: $095eca2286a8ad72$var$add,
        set: $095eca2286a8ad72$var$set$1,
        delete: $095eca2286a8ad72$var$deleteEntry,
        clear: $095eca2286a8ad72$var$clear,
        forEach: $095eca2286a8ad72$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $095eca2286a8ad72$var$get$1(this, key, false, true);
        },
        get size () {
            return $095eca2286a8ad72$var$size(this);
        },
        has: $095eca2286a8ad72$var$has$1,
        add: $095eca2286a8ad72$var$add,
        set: $095eca2286a8ad72$var$set$1,
        delete: $095eca2286a8ad72$var$deleteEntry,
        clear: $095eca2286a8ad72$var$clear,
        forEach: $095eca2286a8ad72$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $095eca2286a8ad72$var$get$1(this, key, true);
        },
        get size () {
            return $095eca2286a8ad72$var$size(this, true);
        },
        has (key) {
            return $095eca2286a8ad72$var$has$1.call(this, key, true);
        },
        add: $095eca2286a8ad72$var$createReadonlyMethod("add"),
        set: $095eca2286a8ad72$var$createReadonlyMethod("set"),
        delete: $095eca2286a8ad72$var$createReadonlyMethod("delete"),
        clear: $095eca2286a8ad72$var$createReadonlyMethod("clear"),
        forEach: $095eca2286a8ad72$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $095eca2286a8ad72$var$get$1(this, key, true, true);
        },
        get size () {
            return $095eca2286a8ad72$var$size(this, true);
        },
        has (key) {
            return $095eca2286a8ad72$var$has$1.call(this, key, true);
        },
        add: $095eca2286a8ad72$var$createReadonlyMethod("add"),
        set: $095eca2286a8ad72$var$createReadonlyMethod("set"),
        delete: $095eca2286a8ad72$var$createReadonlyMethod("delete"),
        clear: $095eca2286a8ad72$var$createReadonlyMethod("clear"),
        forEach: $095eca2286a8ad72$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $095eca2286a8ad72$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $095eca2286a8ad72$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $095eca2286a8ad72$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $095eca2286a8ad72$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$095eca2286a8ad72$var$mutableInstrumentations, $095eca2286a8ad72$var$readonlyInstrumentations, $095eca2286a8ad72$var$shallowInstrumentations, $095eca2286a8ad72$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $095eca2286a8ad72$var$createInstrumentations();
function $095eca2286a8ad72$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $095eca2286a8ad72$var$shallowReadonlyInstrumentations : $095eca2286a8ad72$var$shallowInstrumentations : isReadonly ? $095eca2286a8ad72$var$readonlyInstrumentations : $095eca2286a8ad72$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($095eca2286a8ad72$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $095eca2286a8ad72$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $095eca2286a8ad72$var$createInstrumentationGetter(false, false)
};
var $095eca2286a8ad72$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $095eca2286a8ad72$var$createInstrumentationGetter(true, false)
};
function $095eca2286a8ad72$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $095eca2286a8ad72$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $095eca2286a8ad72$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $095eca2286a8ad72$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $095eca2286a8ad72$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $095eca2286a8ad72$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $095eca2286a8ad72$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $095eca2286a8ad72$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $095eca2286a8ad72$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $095eca2286a8ad72$var$targetTypeMap($095eca2286a8ad72$var$toRawType(value));
}
function $095eca2286a8ad72$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $095eca2286a8ad72$var$createReactiveObject(target, false, $095eca2286a8ad72$var$mutableHandlers, $095eca2286a8ad72$var$mutableCollectionHandlers, $095eca2286a8ad72$var$reactiveMap);
}
function $095eca2286a8ad72$var$readonly(target) {
    return $095eca2286a8ad72$var$createReactiveObject(target, true, $095eca2286a8ad72$var$readonlyHandlers, $095eca2286a8ad72$var$readonlyCollectionHandlers, $095eca2286a8ad72$var$readonlyMap);
}
function $095eca2286a8ad72$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$095eca2286a8ad72$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $095eca2286a8ad72$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $095eca2286a8ad72$var$toRaw(observed) {
    return observed && $095eca2286a8ad72$var$toRaw(observed["__v_raw"]) || observed;
}
function $095eca2286a8ad72$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$095eca2286a8ad72$var$magic("nextTick", ()=>$095eca2286a8ad72$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$095eca2286a8ad72$var$magic("dispatch", (el)=>$095eca2286a8ad72$var$dispatch.bind($095eca2286a8ad72$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$095eca2286a8ad72$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $095eca2286a8ad72$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$095eca2286a8ad72$var$magic("store", $095eca2286a8ad72$var$getStores);
// packages/alpinejs/src/magics/$data.js
$095eca2286a8ad72$var$magic("data", (el)=>$095eca2286a8ad72$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$095eca2286a8ad72$var$magic("root", (el)=>$095eca2286a8ad72$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$095eca2286a8ad72$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $095eca2286a8ad72$var$mergeProxies($095eca2286a8ad72$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $095eca2286a8ad72$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $095eca2286a8ad72$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $095eca2286a8ad72$var$globalIdMemo = {};
function $095eca2286a8ad72$var$findAndIncrementId(name) {
    if (!$095eca2286a8ad72$var$globalIdMemo[name]) $095eca2286a8ad72$var$globalIdMemo[name] = 0;
    return ++$095eca2286a8ad72$var$globalIdMemo[name];
}
function $095eca2286a8ad72$var$closestIdRoot(el, name) {
    return $095eca2286a8ad72$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $095eca2286a8ad72$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $095eca2286a8ad72$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$095eca2286a8ad72$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $095eca2286a8ad72$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $095eca2286a8ad72$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $095eca2286a8ad72$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$095eca2286a8ad72$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $095eca2286a8ad72$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$095eca2286a8ad72$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$095eca2286a8ad72$var$warnMissingPluginMagic("Focus", "focus", "focus");
$095eca2286a8ad72$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $095eca2286a8ad72$var$warnMissingPluginMagic(name, magicName, slug) {
    $095eca2286a8ad72$var$magic(magicName, (el)=>$095eca2286a8ad72$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$095eca2286a8ad72$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $095eca2286a8ad72$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$095eca2286a8ad72$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $095eca2286a8ad72$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $095eca2286a8ad72$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $095eca2286a8ad72$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $095eca2286a8ad72$var$mutateDom(()=>{
        $095eca2286a8ad72$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $095eca2286a8ad72$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $095eca2286a8ad72$var$getTarget(expression);
        $095eca2286a8ad72$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$095eca2286a8ad72$var$mutateDom(()=>{
            clone2.remove();
            $095eca2286a8ad72$var$destroyTree(clone2);
        }));
});
var $095eca2286a8ad72$var$teleportContainerDuringClone = document.createElement("div");
function $095eca2286a8ad72$var$getTarget(expression) {
    let target = $095eca2286a8ad72$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $095eca2286a8ad72$var$teleportContainerDuringClone;
    })();
    if (!target) $095eca2286a8ad72$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $095eca2286a8ad72$var$handler = ()=>{};
$095eca2286a8ad72$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$095eca2286a8ad72$var$directive("ignore", $095eca2286a8ad72$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$095eca2286a8ad72$var$directive("effect", $095eca2286a8ad72$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($095eca2286a8ad72$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $095eca2286a8ad72$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $095eca2286a8ad72$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $095eca2286a8ad72$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $095eca2286a8ad72$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($095eca2286a8ad72$var$isKeyEvent(event) || $095eca2286a8ad72$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($095eca2286a8ad72$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $095eca2286a8ad72$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $095eca2286a8ad72$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $095eca2286a8ad72$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $095eca2286a8ad72$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $095eca2286a8ad72$var$throttle(handler4, wait);
    }
    return handler4;
}
function $095eca2286a8ad72$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $095eca2286a8ad72$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $095eca2286a8ad72$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $095eca2286a8ad72$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $095eca2286a8ad72$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $095eca2286a8ad72$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $095eca2286a8ad72$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $095eca2286a8ad72$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $095eca2286a8ad72$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $095eca2286a8ad72$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($095eca2286a8ad72$var$isClickEvent(e.type)) return false;
            if ($095eca2286a8ad72$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $095eca2286a8ad72$var$keyToModifiers(key) {
    if (!key) return [];
    key = $095eca2286a8ad72$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$095eca2286a8ad72$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $095eca2286a8ad72$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $095eca2286a8ad72$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $095eca2286a8ad72$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $095eca2286a8ad72$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $095eca2286a8ad72$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($095eca2286a8ad72$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $095eca2286a8ad72$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($095eca2286a8ad72$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($095eca2286a8ad72$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($095eca2286a8ad72$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($095eca2286a8ad72$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($095eca2286a8ad72$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $095eca2286a8ad72$var$on(el, event, modifiers, (e)=>{
            setValue($095eca2286a8ad72$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $095eca2286a8ad72$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($095eca2286a8ad72$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $095eca2286a8ad72$var$on(el.form, "reset", [], (e)=>{
            $095eca2286a8ad72$var$nextTick(()=>el._x_model && el._x_model.set($095eca2286a8ad72$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $095eca2286a8ad72$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $095eca2286a8ad72$var$mutateDom(()=>{
            if ($095eca2286a8ad72$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($095eca2286a8ad72$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $095eca2286a8ad72$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $095eca2286a8ad72$var$bind(el, "value", value);
        });
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $095eca2286a8ad72$var$getInputValue(el, modifiers, event, currentValue) {
    return $095eca2286a8ad72$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($095eca2286a8ad72$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $095eca2286a8ad72$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $095eca2286a8ad72$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$095eca2286a8ad72$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $095eca2286a8ad72$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $095eca2286a8ad72$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($095eca2286a8ad72$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $095eca2286a8ad72$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $095eca2286a8ad72$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $095eca2286a8ad72$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $095eca2286a8ad72$var$isNumeric2(number) ? number : rawValue;
}
function $095eca2286a8ad72$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $095eca2286a8ad72$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $095eca2286a8ad72$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$095eca2286a8ad72$var$directive("cloak", (el)=>queueMicrotask(()=>$095eca2286a8ad72$var$mutateDom(()=>el.removeAttribute($095eca2286a8ad72$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$095eca2286a8ad72$var$addInitSelector(()=>`[${$095eca2286a8ad72$var$prefix("init")}]`);
$095eca2286a8ad72$var$directive("init", $095eca2286a8ad72$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$095eca2286a8ad72$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $095eca2286a8ad72$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$095eca2286a8ad72$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $095eca2286a8ad72$var$mutateDom(()=>{
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $095eca2286a8ad72$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$095eca2286a8ad72$var$mapAttributes($095eca2286a8ad72$var$startingWith(":", $095eca2286a8ad72$var$into($095eca2286a8ad72$var$prefix("bind:"))));
var $095eca2286a8ad72$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $095eca2286a8ad72$var$injectBindingProviders(bindingProviders);
        let getBindings = $095eca2286a8ad72$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $095eca2286a8ad72$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $095eca2286a8ad72$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $095eca2286a8ad72$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $095eca2286a8ad72$var$mutateDom(()=>$095eca2286a8ad72$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$095eca2286a8ad72$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$095eca2286a8ad72$var$directive("bind", $095eca2286a8ad72$var$handler2);
function $095eca2286a8ad72$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$095eca2286a8ad72$var$addRootSelector(()=>`[${$095eca2286a8ad72$var$prefix("data")}]`);
$095eca2286a8ad72$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($095eca2286a8ad72$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $095eca2286a8ad72$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $095eca2286a8ad72$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $095eca2286a8ad72$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $095eca2286a8ad72$var$injectMagics(data2, el);
    let reactiveData = $095eca2286a8ad72$var$reactive(data2);
    $095eca2286a8ad72$var$initInterceptors(reactiveData);
    let undo = $095eca2286a8ad72$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $095eca2286a8ad72$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $095eca2286a8ad72$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$095eca2286a8ad72$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $095eca2286a8ad72$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$095eca2286a8ad72$var$isCloning) return false;
    if ($095eca2286a8ad72$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$095eca2286a8ad72$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $095eca2286a8ad72$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $095eca2286a8ad72$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $095eca2286a8ad72$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $095eca2286a8ad72$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$095eca2286a8ad72$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $095eca2286a8ad72$var$parseForExpression(expression);
    let evaluateItems = $095eca2286a8ad72$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $095eca2286a8ad72$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$095eca2286a8ad72$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        el._x_lookup.forEach((el2)=>$095eca2286a8ad72$var$mutateDom(()=>{
                $095eca2286a8ad72$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
    });
});
function $095eca2286a8ad72$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $095eca2286a8ad72$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($095eca2286a8ad72$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $095eca2286a8ad72$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $095eca2286a8ad72$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $095eca2286a8ad72$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $095eca2286a8ad72$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $095eca2286a8ad72$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $095eca2286a8ad72$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $095eca2286a8ad72$var$reactive(scope2);
                $095eca2286a8ad72$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $095eca2286a8ad72$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            $095eca2286a8ad72$var$skipDuringClone(()=>added.forEach((clone2)=>$095eca2286a8ad72$var$initTree(clone2)))();
        });
    });
}
function $095eca2286a8ad72$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $095eca2286a8ad72$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $095eca2286a8ad72$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $095eca2286a8ad72$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $095eca2286a8ad72$var$handler3() {}
$095eca2286a8ad72$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $095eca2286a8ad72$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$095eca2286a8ad72$var$directive("ref", $095eca2286a8ad72$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$095eca2286a8ad72$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $095eca2286a8ad72$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $095eca2286a8ad72$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $095eca2286a8ad72$var$addScopeToNode(clone2, {}, el);
        $095eca2286a8ad72$var$mutateDom(()=>{
            el.after(clone2);
            $095eca2286a8ad72$var$skipDuringClone(()=>$095eca2286a8ad72$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $095eca2286a8ad72$var$mutateDom(()=>{
                $095eca2286a8ad72$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$095eca2286a8ad72$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$095eca2286a8ad72$var$setIdRoot(el, name));
});
$095eca2286a8ad72$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$095eca2286a8ad72$var$mapAttributes($095eca2286a8ad72$var$startingWith("@", $095eca2286a8ad72$var$into($095eca2286a8ad72$var$prefix("on:"))));
$095eca2286a8ad72$var$directive("on", $095eca2286a8ad72$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $095eca2286a8ad72$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $095eca2286a8ad72$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$095eca2286a8ad72$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$095eca2286a8ad72$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$095eca2286a8ad72$var$warnMissingPluginDirective("Focus", "trap", "focus");
$095eca2286a8ad72$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $095eca2286a8ad72$var$warnMissingPluginDirective(name, directiveName, slug) {
    $095eca2286a8ad72$var$directive(directiveName, (el)=>$095eca2286a8ad72$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$095eca2286a8ad72$var$alpine_default.setEvaluator($095eca2286a8ad72$var$normalEvaluator);
$095eca2286a8ad72$var$alpine_default.setRawEvaluator($095eca2286a8ad72$var$normalRawEvaluator);
$095eca2286a8ad72$var$alpine_default.setReactivityEngine({
    reactive: $095eca2286a8ad72$var$reactive2,
    effect: $095eca2286a8ad72$var$effect2,
    release: $095eca2286a8ad72$var$stop,
    raw: $095eca2286a8ad72$var$toRaw
});
var $095eca2286a8ad72$export$b7ee041e4ad2afec = $095eca2286a8ad72$var$alpine_default;
// packages/alpinejs/builds/module.js
var $095eca2286a8ad72$export$2e2bcd8739ae039 = $095eca2286a8ad72$export$b7ee041e4ad2afec;



var $eMV3U = parcelRequire("eMV3U");
// packages/intersect/src/index.js
function $84030622691d0f87$export$1f4807a235930d45(Alpine) {
    Alpine.directive("intersect", Alpine.skipDuringClone((el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $84030622691d0f87$var$getRootMargin(modifiers),
            threshold: $84030622691d0f87$var$getThreshold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    }));
}
function $84030622691d0f87$var$getThreshold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $84030622691d0f87$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $84030622691d0f87$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($84030622691d0f87$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $84030622691d0f87$export$2e2bcd8739ae039 = $84030622691d0f87$export$1f4807a235930d45;


// packages/collapse/src/index.js
function $c0b0e2c36ab5e7cf$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $c0b0e2c36ab5e7cf$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $c0b0e2c36ab5e7cf$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $c0b0e2c36ab5e7cf$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $c0b0e2c36ab5e7cf$export$2e2bcd8739ae039 = $c0b0e2c36ab5e7cf$export$ec45920981e0ca9b;


(0, $095eca2286a8ad72$export$2e2bcd8739ae039).plugin((0, $c0b0e2c36ab5e7cf$export$2e2bcd8739ae039));
(0, $095eca2286a8ad72$export$2e2bcd8739ae039).plugin((0, $84030622691d0f87$export$2e2bcd8739ae039));
(0, $095eca2286a8ad72$export$2e2bcd8739ae039).plugin((0, $eMV3U.default));
(0, $095eca2286a8ad72$export$2e2bcd8739ae039).data('clickTracking', ()=>({
        async registerClick (contentId, buttonKey) {
            try {
                const response = await fetch(`/api/clicktracking?contentId=${encodeURIComponent(contentId)}&buttonKey=${encodeURIComponent(buttonKey)}`, {
                    method: 'POST',
                    keepalive: true
                });
                if (!response.ok) console.error('Click tracking failed with status', response.status);
            } catch (error) {
                console.error('Click tracking failed', error);
            }
        }
    }));
(0, $095eca2286a8ad72$export$2e2bcd8739ae039).start();
(0, $c996c779fad8b3f3$export$cb45b08d97cdc4fd).bind('[data-fancybox]', {});

if (document.querySelectorAll('.swiper').length > 0) (parcelRequire("hraYB")).then((x)=>{
    x.initSwipers();
});

if (document.querySelectorAll('.mux-player').length > 0) (parcelRequire("EXigr")).then((x)=>{
    x.initMuxVideo();
});

if (document.querySelectorAll('#QuizSkill').length > 0) (parcelRequire("fxb6u")).then((x)=>{
    x.initQuiz();
});

if (document.querySelectorAll('#QuizMatching').length > 0) (parcelRequire("97H3y")).then((x)=>{
    x.initQuiz();
});

})();
//# sourceMappingURL=main.js.map
